export function Onboard() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="130"
      height="130"
    >
      <path
        d="M0 0 C14.30320657 10.6181839 23.36554803 26.29226497 26.3125 43.8125 C28.2598012 59.52197799 24.71369768 72.89906215 18 87 C10.93981586 86.12560667 5.42457977 82.9420895 -0.8125 79.6875 C-1.96943359 79.10548828 -3.12636719 78.52347656 -4.31835938 77.92382812 C-5.41599609 77.35470703 -6.51363281 76.78558594 -7.64453125 76.19921875 C-8.64846924 75.68190186 -9.65240723 75.16458496 -10.68676758 74.6315918 C-13 73 -13 73 -13.88330078 70.93481445 C-14.04063244 68.32633455 -13.21720068 66.83272865 -12.0625 64.5 C-8.8338293 56.85018789 -8.82196148 49.41458634 -11.6875 41.625 C-14.82401738 34.78168936 -18.88679789 29.9889819 -26 27 C-32.89471606 24.66190746 -39.79152837 24.78045264 -47 25 C-47.99 20.05 -47.99 20.05 -49 15 C-41.04530798 11.30937579 -31.55101938 12.11605318 -23.40234375 14.96875 C-11.51762192 20.07048425 -4.03128497 27.54780027 1.08984375 39.421875 C2.55955152 43.58499571 3.12608005 47.45759242 3.09765625 51.86328125 C3.09282227 53.19262695 3.09282227 53.19262695 3.08789062 54.54882812 C3.07532227 55.9168457 3.07532227 55.9168457 3.0625 57.3125 C3.05798828 58.24384766 3.05347656 59.17519531 3.04882812 60.13476562 C3.03709254 62.42320487 3.01915861 64.71161086 3 67 C6.3 68.65 9.6 70.3 13 72 C15.8132877 55.21176284 15.29607861 38.05235765 5.8203125 23.41015625 C-3.89325098 10.54906469 -15.21293016 3.86890284 -31 1 C-44.53187266 -0.37168185 -59.12945183 2.87090914 -69.91015625 11.53515625 C-70.41417969 11.99792969 -70.91820312 12.46070312 -71.4375 12.9375 C-74 15 -74 15 -76.5 15.0625 C-79.62500359 13.73437348 -82.25076518 11.9820065 -85 10 C-64.71909876 -16.15168844 -26.26360508 -17.18891682 0 0 Z "
        fill="#335795"
        transform="translate(101,13)"
      />
      <path
        d="M0 0 C3.91355482 0.60511142 6.91908625 1.80734707 10.4140625 3.65234375 C11.42210938 4.18150391 12.43015625 4.71066406 13.46875 5.25585938 C14.5103125 5.81080078 15.551875 6.36574219 16.625 6.9375 C18.19894531 7.76411133 18.19894531 7.76411133 19.8046875 8.60742188 C27.50378024 12.66918683 27.50378024 12.66918683 31 15 C30.49937703 18.80473457 29.61519612 22.29886342 28.4375 25.9375 C26.08225007 33.7225872 26.5643731 40.61285334 30 48 C34.42657974 54.63510985 39.31600096 59.12730384 47.00390625 61.4609375 C52.33578819 62.42025915 57.60853472 62.30857353 63 62 C64.34211745 65.8353791 65.35058876 68.90979782 65 73 C62.65281344 75.34718656 56.35708269 74.31109766 53.07250977 74.31689453 C46.64076907 74.21394601 41.62503201 73.25926945 36 70 C35.22398438 69.57589844 34.44796875 69.15179688 33.6484375 68.71484375 C24.57015601 63.26483864 17.88275325 54.32615383 15.24609375 44.06640625 C13.70703367 36.00328019 14.29940857 28.9927797 16 21 C14.730447 20.35165346 13.45930294 19.70642185 12.1875 19.0625 C11.47980469 18.70285156 10.77210937 18.34320313 10.04296875 17.97265625 C7.88189715 16.89269484 7.88189715 16.89269484 5 16 C1.75600579 33.64089414 2.6715739 50.2818054 13.08984375 65.5 C21.86772581 76.9884346 32.74905887 83.39688692 47 86 C61.30993047 87.50356707 73.6223052 84.30665684 86 77 C87.15494727 76.03474262 88.28678644 75.03991165 89.375 74 C90.24125 73.34 91.1075 72.68 92 72 C95.125 72.5625 95.125 72.5625 98 74 C99.175625 74.556875 99.175625 74.556875 100.375 75.125 C100.91125 75.41375 101.4475 75.7025 102 76 C101.10894423 81.45326133 97.22862696 83.83184375 93 87 C80.55296233 95.47533334 69.78669754 98.33347282 54.9375 98.5 C53.30530518 98.52791626 53.30530518 98.52791626 51.64013672 98.55639648 C34.69083405 98.42475886 20.79570402 90.75638501 9 79 C8.2884375 78.31164062 7.576875 77.62328125 6.84375 76.9140625 C-4.83366413 64.83243018 -8.45431918 50.35950223 -8.5 34 C-8.50400818 33.30668579 -8.50801636 32.61337158 -8.512146 31.89904785 C-8.5295112 19.6760675 -6.89826431 10.34739647 0 0 Z "
        fill="#3962A8"
        transform="translate(8,32)"
      />
      <path
        d="M0 0 C3.91355482 0.60511142 6.91908625 1.80734707 10.4140625 3.65234375 C11.42210938 4.18150391 12.43015625 4.71066406 13.46875 5.25585938 C14.5103125 5.81080078 15.551875 6.36574219 16.625 6.9375 C18.19894531 7.76411133 18.19894531 7.76411133 19.8046875 8.60742188 C27.50378024 12.66918683 27.50378024 12.66918683 31 15 C30.49937703 18.80473457 29.61519612 22.29886342 28.4375 25.9375 C26.7585994 31.43507647 26.34352596 35.7844001 28 41.375 C29.19281429 45.69895179 29.18158826 49.55108753 29 54 C25.535 54.495 25.535 54.495 22 55 C17.24890241 47.87335361 16.857842 39.80202258 16.875 31.4375 C16.87242188 30.17808594 16.86984375 28.91867188 16.8671875 27.62109375 C16.9883692 24.31711034 17.37077045 21.24103157 18 18 C17.443125 17.87625 16.88625 17.7525 16.3125 17.625 C13.77885636 16.94023145 11.42078968 16.00866237 9 15 C9 14.34 9 13.68 9 13 C7.04006395 13.21130782 7.04006395 13.21130782 5 14 C0.98510484 20.2850083 1.54926901 28.60604319 1.625 35.75 C1.61339844 36.85988281 1.60179687 37.96976563 1.58984375 39.11328125 C1.59371094 40.18449219 1.59757813 41.25570312 1.6015625 42.359375 C1.60494629 43.32327148 1.60833008 44.28716797 1.61181641 45.28027344 C2.06594148 48.46200506 3.25620276 50.33264869 5 53 C5.3984375 55.3515625 5.3984375 55.3515625 5.375 57.625 C5.38273438 58.38039062 5.39046875 59.13578125 5.3984375 59.9140625 C4.9104233 62.46896036 3.9691421 63.36425762 2 65 C2 64.01 2 63.02 2 62 C0.68 62 -0.64 62 -2 62 C-2.62817704 60.31368008 -3.25236893 58.62587549 -3.875 56.9375 C-4.22304687 55.99777344 -4.57109375 55.05804688 -4.9296875 54.08984375 C-5.28289063 53.07019531 -5.63609375 52.05054688 -6 51 C-6.36351562 49.98035156 -6.72703125 48.96070313 -7.1015625 47.91015625 C-11.09682381 33.45158669 -9.35890389 15.98293665 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z "
        fill="#497ACD"
        transform="translate(8,32)"
      />
      <path
        d="M0 0 C3.125 0.5625 3.125 0.5625 6 2 C7.175625 2.556875 7.175625 2.556875 8.375 3.125 C8.91125 3.41375 9.4475 3.7025 10 4 C9.10988005 9.44753411 5.23198062 11.84249421 1 15 C-10.39334559 22.51837304 -19.30680216 25.5086816 -32.9375 25.3125 C-34.05318359 25.31572266 -35.16886719 25.31894531 -36.31835938 25.32226562 C-44.52075779 25.26940893 -52.65524122 24.96848027 -60 21 C-60 20.34 -60 19.68 -60 19 C-60.99 18.67 -61.98 18.34 -63 18 C-61.68 16.35 -60.36 14.7 -59 13 C-59 13.99 -59 14.98 -59 16 C-58.01 15.34 -57.02 14.68 -56 14 C-54.09614201 14.19623098 -52.19215851 14.40519973 -50.30078125 14.69824219 C-46.21226536 15.23446944 -42.1171732 15.14371442 -38 15.125 C-36.72382812 15.13080078 -36.72382812 15.13080078 -35.421875 15.13671875 C-30.1920697 15.12869758 -25.17546723 14.75475564 -20 14 C-20 13.34 -20 12.68 -20 12 C-19.05898437 11.55269531 -18.11796875 11.10539062 -17.1484375 10.64453125 C-15.89041125 10.03429463 -14.63261071 9.42359253 -13.375 8.8125 C-12.44880859 8.37454102 -12.44880859 8.37454102 -11.50390625 7.92773438 C-8.2157646 6.31827557 -5.47888035 4.6644691 -2.734375 2.2265625 C-1.83203125 1.49179688 -0.9296875 0.75703125 0 0 Z "
        fill="#487ACF"
        transform="translate(100,104)"
      />
      <path
        d="M0 0 C7.53277185 2.10216889 11.19410672 5.65337827 15.0625 12.375 C24.4394439 29.15896008 25.89234982 46.70780708 21 65 C20.77054688 65.87269531 20.54109375 66.74539062 20.3046875 67.64453125 C19.26480285 70.96140471 18.52708184 72.6837509 15.5 74.5 C12.0204423 75.19591154 9.37502705 74.93104195 6 74 C7.06516922 71.51460515 8.00731493 69.99314225 10 68.125 C12.73724612 65.216676 14 62.01828832 14 58 C13.90073179 54.97796903 13.76260792 51.95799384 13.625 48.9375 C13.5940625 48.11572266 13.563125 47.29394531 13.53125 46.44726562 C13.29663418 41.4773204 12.63194743 36.8721428 11.46337891 32.0378418 C10.85208766 29.34951303 10.58358648 26.68388863 10.375 23.9375 C10.30023438 22.99777344 10.22546875 22.05804688 10.1484375 21.08984375 C10.09945312 20.40019531 10.05046875 19.71054687 10 19 C9.01 18.67 8.02 18.34 7 18 C4.73815567 16.20937324 3.84957656 14.69261298 2.5625 12.0625 C1.02964209 9.05809849 -0.50898822 7.23332091 -3 5 C-1.125 1.125 -1.125 1.125 0 0 Z "
        fill="#497CD3"
        transform="translate(104,21)"
      />
      <path
        d="M0 0 C2 1 4 2 6 3 C7.32860925 3.35169068 8.66158328 3.68770276 10 4 C8.84826645 6.46800047 7.95216435 8.04783565 6 10 C4.68 10 3.36 10 2 10 C-0.95416866 17.40886743 -1.45911863 23.81480897 -1.375 31.75 C-1.38660156 32.85988281 -1.39820313 33.96976563 -1.41015625 35.11328125 C-1.40628906 36.18449219 -1.40242187 37.25570312 -1.3984375 38.359375 C-1.39505371 39.32327148 -1.39166992 40.28716797 -1.38818359 41.28027344 C-0.93405852 44.46200506 0.25620276 46.33264869 2 49 C2.3984375 51.3515625 2.3984375 51.3515625 2.375 53.625 C2.38273438 54.38039062 2.39046875 55.13578125 2.3984375 55.9140625 C1.9104233 58.46896036 0.9691421 59.36425762 -1 61 C-1 60.01 -1 59.02 -1 58 C-2.32 58 -3.64 58 -5 58 C-5.62817704 56.31368008 -6.25236893 54.62587549 -6.875 52.9375 C-7.22304687 51.99777344 -7.57109375 51.05804688 -7.9296875 50.08984375 C-10.16388315 43.64003077 -11.36265315 38.10207291 -11.3125 31.3125 C-11.30758545 30.52447998 -11.3026709 29.73645996 -11.29760742 28.92456055 C-11.06221228 17.09082441 -8.56318644 8.38893555 0 0 Z "
        fill="#487BD0"
        transform="translate(11,36)"
      />
      <path
        d="M0 0 C2.10199129 2.09670991 3.75388668 4.29912183 5 7 C4.3125 9.9375 4.3125 9.9375 3 12 C-2.75 10.25 -2.75 10.25 -5 8 C-18.13943161 3.44611114 -32.57206952 4.76472737 -46.23535156 5.06591797 C-49 5 -49 5 -52 4 C-52 3.01 -52 2.02 -52 1 C-39.24490127 -6.68048956 -13.08071061 -8.04754078 0 0 Z "
        fill="#487DD5"
        transform="translate(92,8)"
      />
      <path
        d="M0 0 C1.3761145 0.00193359 1.3761145 0.00193359 2.7800293 0.00390625 C9.39867909 0.09774621 15.41871534 0.87068308 21.625 3.3125 C21.625 3.6425 21.625 3.9725 21.625 4.3125 C21.03726807 4.24393799 20.44953613 4.17537598 19.84399414 4.10473633 C13.24284358 3.38361308 6.70100059 3.06598907 0.0625 3 C-0.91396484 2.97099609 -1.89042969 2.94199219 -2.89648438 2.91210938 C-8.88500663 2.86003527 -13.19798453 3.63895965 -18.51538086 6.44848633 C-20.375 7.3125 -20.375 7.3125 -23.375 7.3125 C-23.375 8.3025 -23.375 9.2925 -23.375 10.3125 C-22.385 10.6425 -21.395 10.9725 -20.375 11.3125 C-20.705 11.9725 -21.035 12.6325 -21.375 13.3125 C-22.035 13.3125 -22.695 13.3125 -23.375 13.3125 C-23.60445312 14.06015625 -23.83390625 14.8078125 -24.0703125 15.578125 C-25.64256561 18.87326625 -27.23782459 20.04246545 -30.25 22.0625 C-31.11367188 22.65546875 -31.97734375 23.2484375 -32.8671875 23.859375 C-36.76631404 26.11868197 -36.76631404 26.11868197 -39.375 26.3125 C-41.515625 25.31640625 -41.515625 25.31640625 -43.625 23.875 C-44.33140625 23.40191406 -45.0378125 22.92882812 -45.765625 22.44140625 C-46.29671875 22.06886719 -46.8278125 21.69632813 -47.375 21.3125 C-35.78279803 6.36466062 -18.52939009 -0.10832931 0 0 Z "
        fill="#385E9E"
        transform="translate(63.375,1.6875)"
      />
      <path
        d="M0 0 C4.81177081 1.31488567 7.89756716 3.2184357 11.6875 6.4375 C12.61949219 7.21996094 13.55148438 8.00242187 14.51171875 8.80859375 C16.41712196 10.48666471 18.2418804 12.17132042 20 14 C19.67 14.66 19.34 15.32 19 16 C18.2575 15.46375 17.515 14.9275 16.75 14.375 C15.8425 13.92125 14.935 13.4675 14 13 C11.69712207 13.69140351 11.69712207 13.69140351 10 15 C10.9639104 17.15026166 11.71087924 18.74701933 13.5 20.3125 C15 22 15 22 16 25.625 C16.495 27.295625 16.495 27.295625 17 29 C18.485 29.495 18.485 29.495 20 30 C23.99689456 33.06783432 24.0110724 36.87986011 24.65234375 41.6328125 C25.18444196 47.26407177 25.21831326 52.91000872 25.25 58.5625 C25.25926514 59.62170654 25.26853027 60.68091309 25.27807617 61.7722168 C25.27396729 62.77679932 25.2698584 63.78138184 25.265625 64.81640625 C25.26336914 65.71818604 25.26111328 66.61996582 25.25878906 67.54907227 C24.98613032 70.13135633 24.30509386 71.77570275 23 74 C23.0314209 72.92069214 23.0314209 72.92069214 23.06347656 71.81958008 C23.98029903 52.93085468 23.98029903 52.93085468 19 35 C18.5875 34.12988281 18.175 33.25976562 17.75 32.36328125 C11.62497875 21.0006708 1.63385543 12.07665227 -10.5078125 7.75 C-23.40042638 3.93781027 -34.20121953 4.17529155 -47 8 C-48.41657512 8.39616084 -49.83322495 8.79205476 -51.25 9.1875 C-52.1575 9.455625 -53.065 9.72375 -54 10 C-53.34 8.68 -52.68 7.36 -52 6 C-51.34 6 -50.68 6 -50 6 C-50 5.34 -50 4.68 -50 4 C-35.15150642 0.852627 -13.32725021 0.59531269 -0.0625 8.6875 C0.948125 9.450625 1.95875 10.21375 3 11 C3.87754191 8.79561167 3.87754191 8.79561167 4 6 C2.16682624 2.70751892 2.16682624 2.70751892 0 0 Z "
        fill="#2F528C"
        transform="translate(92,9)"
      />
      <path
        d="M0 0 C7.53277185 2.10216889 11.19410672 5.65337827 15.0625 12.375 C24.52333241 29.30911362 25.68837579 46.56435284 21 65 C20.67 65 20.34 65 20 65 C20.0721875 63.99582031 20.144375 62.99164063 20.21875 61.95703125 C21.02830719 50.23861893 21.58394914 38.68162492 20 27 C16.47930015 27.58678331 14.28700157 28.35649921 11 30 C10.67 26.37 10.34 22.74 10 19 C9.01 18.67 8.02 18.34 7 18 C4.73815567 16.20937324 3.84957656 14.69261298 2.5625 12.0625 C1.02964209 9.05809849 -0.50898822 7.23332091 -3 5 C-1.125 1.125 -1.125 1.125 0 0 Z "
        fill="#497BD0"
        transform="translate(104,21)"
      />
      <path
        d="M0 0 C1.32 0.33 2.64 0.66 4 1 C4 1.66 4 2.32 4 3 C4.66 3 5.32 3 6 3 C7.63347575 9.06719565 8.23745682 14.99255347 8.3125 21.25 C8.33860352 22.25933594 8.33860352 22.25933594 8.36523438 23.2890625 C8.36065405 27.9243549 7.47165007 31.08703642 5 35 C4.01 35.66 3.02 36.32 2 37 C2 37.99 2 38.98 2 40 C0.35 39.34 -1.3 38.68 -3 38 C-2.855625 36.98421875 -2.71125 35.9684375 -2.5625 34.921875 C-1.09642908 24.21551022 -0.05002195 13.72487929 -2 3 C-1.34 3 -0.68 3 0 3 C0 2.01 0 1.02 0 0 Z "
        fill="#497CD3"
        transform="translate(94,47)"
      />
      <path
        d="M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C8.96870896 2.85580636 15.92978164 3.32943231 22.9375 3.71875 C26 4 26 4 27 5 C27.04092937 7.33297433 27.04241723 9.66705225 27 12 C18.55153694 16.22423153 6.49518637 11.3876057 -2 9 C-3.1640625 4.2890625 -3.1640625 4.2890625 -1.6875 1.6875 C-1.130625 1.130625 -0.57375 0.57375 0 0 Z "
        fill="#4B7BCF"
        transform="translate(44,92)"
      />
      <path
        d="M0 0 C3.125 0.5625 3.125 0.5625 6 2 C6.78375 2.37125 7.5675 2.7425 8.375 3.125 C8.91125 3.41375 9.4475 3.7025 10 4 C9.10988005 9.44753411 5.23198062 11.84249421 1 15 C-15.48453608 25.87800687 -15.48453608 25.87800687 -22.25 24.5625 C-22.8275 24.376875 -23.405 24.19125 -24 24 C-22.37478703 22.06006325 -21.47190573 21.09348228 -18.94921875 20.59375 C-18.20285156 20.5628125 -17.45648438 20.531875 -16.6875 20.5 C-12.54596369 20.18194084 -9.61764891 19.13348525 -6 17 C-6 16.01 -6 15.02 -6 14 C-4.68 13.67 -3.36 13.34 -2 13 C-2 12.01 -2 11.02 -2 10 C-2.99 10.33 -3.98 10.66 -5 11 C-5 10.34 -5 9.68 -5 9 C-6.65 9.33 -8.3 9.66 -10 10 C-10.33 10.99 -10.66 11.98 -11 13 C-13.97 13 -16.94 13 -20 13 C-17.61237819 10.61237819 -15.30366715 9.62697743 -12.25 8.1875 C-8.60028611 6.42361679 -5.52934991 4.83445914 -2.625 2 C-1.75875 1.34 -0.8925 0.68 0 0 Z "
        fill="#4A7ACD"
        transform="translate(100,104)"
      />
      <path
        d="M0 0 C0.99 0 1.98 0 3 0 C4.10141882 3.58849356 4.1357686 7.01300138 4.25 10.75 C4.59932351 16.45759092 5.52357463 19.78143283 8.921875 24.3125 C10.54323374 26.8502789 10.3638504 29.08919682 10 32 C6.535 32.495 6.535 32.495 3 33 C-1.83957402 25.74063896 -2.13779566 17.57090903 -2.0625 9.0625 C-2.05798828 8.37865234 -2.05347656 7.69480469 -2.04882812 6.99023438 C-2.0371956 5.32678396 -2.01926694 3.6633795 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z "
        fill="#497CD5"
        transform="translate(27,54)"
      />
      <path
        d="M0 0 C2.54173977 -0.02716824 5.08318415 -0.04691969 7.625 -0.0625 C8.33785156 -0.07087891 9.05070312 -0.07925781 9.78515625 -0.08789062 C13.97344438 -0.10710296 17.8728462 0.1732673 22 1 C22 1.33 22 1.66 22 2 C24.97 2.495 24.97 2.495 28 3 C27.42415568 5.38564077 26.77772405 7.66682784 26 10 C19.25 9.125 19.25 9.125 17 8 C14.2764805 8.08924852 11.58986689 8.23353332 8.875 8.4375 C7.74384766 8.51581055 7.74384766 8.51581055 6.58984375 8.59570312 C4.7262063 8.72545004 2.86305004 8.86207488 1 9 C0.67 6.03 0.34 3.06 0 0 Z "
        fill="#487DD5"
        transform="translate(54,28)"
      />
      <path
        d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C5.11375 2.185625 5.11375 2.185625 6.25 2.375 C8.81448542 2.9578376 10.69166512 3.78664449 13 5 C12.99476318 5.59949463 12.98952637 6.19898926 12.98413086 6.81665039 C12.96318557 9.56525602 12.95028444 12.31384478 12.9375 15.0625 C12.92912109 16.00544922 12.92074219 16.94839844 12.91210938 17.91992188 C12.88693224 25.14575929 13.14615973 31.61531716 16.125 38.3125 C17.2578125 40.86328125 17.2578125 40.86328125 18 43 C17.67 43.66 17.34 44.32 17 45 C9.19108409 32.74638668 7.99735669 22.11242357 11 8 C9.730447 7.35165346 8.45930294 6.70642185 7.1875 6.0625 C6.47980469 5.70285156 5.77210937 5.34320313 5.04296875 4.97265625 C2.88189715 3.89269484 2.88189715 3.89269484 0 3 C-2.642802 17.37160095 -1.73776104 29.8482255 2 44 C-1.56772137 42.21613931 -2.7755082 38.60498214 -4 35 C-4.56381598 30.86107816 -4.55973547 26.79652677 -4.5 22.625 C-4.51546875 21.5525 -4.5309375 20.48 -4.546875 19.375 C-4.51160835 12.12770411 -3.19811043 6.50367445 0 0 Z "
        fill="#284676"
        transform="translate(13,45)"
      />
      <path
        d="M0 0 C0 0.33 0 0.66 0 1 C-0.58773193 0.93143799 -1.17546387 0.86287598 -1.78100586 0.79223633 C-8.38215642 0.07111308 -14.92399941 -0.24651093 -21.5625 -0.3125 C-22.53896484 -0.34150391 -23.51542969 -0.37050781 -24.52148438 -0.40039062 C-30.51000663 -0.45246473 -34.82298453 0.32645965 -40.14038086 3.13598633 C-42 4 -42 4 -45 4 C-45 4.99 -45 5.98 -45 7 C-44.01 7.33 -43.02 7.66 -42 8 C-42.33 8.66 -42.66 9.32 -43 10 C-43.66 10 -44.32 10 -45 10 C-45.226875 10.61875 -45.45375 11.2375 -45.6875 11.875 C-47.37929835 14.61410209 -48.99244161 15.05024472 -52 16 C-52 15.34 -52 14.68 -52 14 C-52.99 14 -53.98 14 -55 14 C-55.8125 12.3125 -55.8125 12.3125 -56 10 C-52.12419015 4.60155057 -46.11821406 2.2256661 -40 0 C-39.01 0 -38.02 0 -37 0 C-37 -0.66 -37 -1.32 -37 -2 C-25.65346034 -4.9434538 -10.84194663 -4.26568392 0 0 Z "
        fill="#395FA4"
        transform="translate(85,5)"
      />
      <path
        d="M0 0 C3.47289095 2.90753661 5.94039259 5.52610203 7 10 C6.34 10.99 5.68 11.98 5 13 C-0.75 11.25 -0.75 11.25 -3 9 C-12.52277637 6.3949473 -22.16441485 5.43949456 -32 5 C-32 4.67 -32 4.34 -32 4 C-15.62184189 3.80806846 -15.62184189 3.80806846 -9 5 C-8.67 5.33 -8.34 5.66 -8 6 C-8 4.02 -8 2.04 -8 0 C-4.57930706 -1.14023098 -3.38312738 -1.12770913 0 0 Z "
        fill="#4775C5"
        transform="translate(90,7)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C1.02505615 0.56509277 1.0501123 1.13018555 1.07592773 1.71240234 C1.19179956 4.26683742 1.31456537 6.8208955 1.4375 9.375 C1.47681641 10.26445313 1.51613281 11.15390625 1.55664062 12.0703125 C1.61948242 13.34648438 1.61948242 13.34648438 1.68359375 14.6484375 C1.72025146 15.43395996 1.75690918 16.21948242 1.79467773 17.02880859 C1.890891 19.07523496 1.890891 19.07523496 3 21 C2.34 21.33 1.68 21.66 1 22 C0.7525 22.86625 0.505 23.7325 0.25 24.625 C-1.34596553 28.93410693 -3.88581296 31.68995214 -7 35 C-3.78600767 35.08927756 -1.0937211 34.8534403 2 34 C2.66 34 3.32 34 4 34 C3.34 35.98 2.68 37.96 2 40 C-3.32257301 39.48072458 -6.75032135 38.16642723 -11 35 C-12.0625 31.375 -12.0625 31.375 -12 28 C-10 26 -10 26 -8.0546875 25.8046875 C-6.03645833 25.86979167 -4.01822917 25.93489583 -2 26 C-1.08877472 20.35652914 -0.70225954 14.77002113 -0.4375 9.0625 C-0.39431641 8.18787109 -0.35113281 7.31324219 -0.30664062 6.41210938 C-0.20153099 4.27488005 -0.10036015 2.13745762 0 0 Z "
        fill="#4370BB"
        transform="translate(117,60)"
      />
      <path
        d="M0 0 C3.91355482 0.60511142 6.91908625 1.80734707 10.4140625 3.65234375 C11.42210938 4.18150391 12.43015625 4.71066406 13.46875 5.25585938 C14.5103125 5.81080078 15.551875 6.36574219 16.625 6.9375 C18.19894531 7.76411133 18.19894531 7.76411133 19.8046875 8.60742188 C27.50378024 12.66918683 27.50378024 12.66918683 31 15 C30.44894091 18.9492568 29.61064629 22.34920174 28 26 C26.52470658 22.16423712 27.65360357 19.75140991 29 16 C18.1268772 9.99994628 18.1268772 9.99994628 6 8 C6 7.34 6 6.68 6 6 C2.33173827 6 1.64158305 6.5185129 -1 9 C-4.7634554 14.42380337 -6.00885892 19.51845897 -7 26 C-7.33 26 -7.66 26 -8 26 C-8.30989351 19.94360288 -7.53873719 15.71664216 -5.125 10.1875 C-4.72087891 9.20620117 -4.72087891 9.20620117 -4.30859375 8.20507812 C-3.0726369 5.25385434 -1.78003751 2.67005627 0 0 Z "
        fill="#254273"
        transform="translate(8,32)"
      />
      <path
        d="M0 0 C5.75 1.75 5.75 1.75 8 4 C7.625 7.625 7.625 7.625 7 11 C8.65 11.33 10.3 11.66 12 12 C12 14.31 12 16.62 12 19 C11.34 19.33 10.68 19.66 10 20 C5.25088045 18.12534755 3.96301816 15.33538311 1.98046875 10.94140625 C0.73290906 8.47113866 -0.91021574 6.79124366 -3 5 C-1.125 1.125 -1.125 1.125 0 0 Z "
        fill="#497CD4"
        transform="translate(104,21)"
      />
      <path
        d="M0 0 C0.680625 0.70125 1.36125 1.4025 2.0625 2.125 C3.03811394 3.08694988 4.01761175 4.04496939 5 5 C5.51949219 5.515625 6.03898437 6.03125 6.57421875 6.5625 C14.09145851 13.57158136 21.41740864 14.34734756 31.47265625 14.10546875 C32.72369141 14.05326172 32.72369141 14.05326172 34 14 C35.34211745 17.8353791 36.35058876 20.90979782 36 25 C33.87763479 27.12236521 29.36110131 26.23148154 26.4375 26.25 C25.25704102 26.2809375 25.25704102 26.2809375 24.05273438 26.3125 C18.36699994 26.34999866 14.21458907 25.26980968 9 23 C12.6585615 21.85519848 14.8287802 22.48266271 18.49609375 23.51953125 C23.59331028 24.49762428 28.83180869 24.14181013 34 24 C33.505 20.535 33.505 20.535 33 17 C32.41508789 16.98018066 31.83017578 16.96036133 31.22753906 16.93994141 C28.56791975 16.84446519 25.90906162 16.73487858 23.25 16.625 C22.32960938 16.5940625 21.40921875 16.563125 20.4609375 16.53125 C19.57148437 16.49257812 18.68203125 16.45390625 17.765625 16.4140625 C16.94868164 16.3826416 16.13173828 16.3512207 15.29003906 16.31884766 C12.83167042 15.97656307 11.14240001 15.2260723 9 14 C9 13.34 9 12.68 9 12 C8.34 12 7.68 12 7 12 C6.54625 11.236875 6.0925 10.47375 5.625 9.6875 C4.19410993 6.92083785 4.19410993 6.92083785 1.8125 5.4375 C1.214375 4.963125 0.61625 4.48875 0 4 C0 2.68 0 1.36 0 0 Z "
        fill="#1B2E54"
        transform="translate(37,80)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C0.88543872 2.39674267 0.75871281 4.79181218 0.625 7.1875 C0.57859375 8.19780273 0.57859375 8.19780273 0.53125 9.22851562 C0.30006522 13.17792232 -0.13133122 16.48559134 -2 20 C-6.25066907 22.28882181 -9.4322565 22.26006717 -14 21 C-12.43542921 16.77565886 -9.61920511 14.55473302 -6 12 C-3.125 11.6875 -3.125 11.6875 -1 12 C-1.66 11.67 -2.32 11.34 -3 11 C-2.69217504 9.35328588 -2.37860766 7.70764424 -2.0625 6.0625 C-1.88847656 5.14597656 -1.71445313 4.22945313 -1.53515625 3.28515625 C-1 1 -1 1 0 0 Z "
        fill="#487CD3"
        transform="translate(124,74)"
      />
      <path
        d="M0 0 C2 1 4 2 6 3 C7.32860925 3.35169068 8.66158328 3.68770276 10 4 C8.84826645 6.46800047 7.95216435 8.04783565 6 10 C2.875 10.125 2.875 10.125 0 10 C0 9.34 0 8.68 0 8 C-2.04836882 8.56362302 -2.04836882 8.56362302 -4 10 C-4.81584568 13.05908413 -4.81584568 13.05908413 -5 16 C-5.33 16 -5.66 16 -6 16 C-6.27312207 10.62859937 -6.40444214 7.41316574 -3 3 C-1.3125 1.1875 -1.3125 1.1875 0 0 Z "
        fill="#497DD7"
        transform="translate(11,36)"
      />
      <path
        d="M0 0 C0.66 0.66 1.32 1.32 2 2 C-0.31 2 -2.62 2 -5 2 C-5 1.67 -5 1.34 -5 1 C-9.42682491 -0.0390378 -13.78934632 -0.31592951 -18.3125 -0.5625 C-19.05306641 -0.60568359 -19.79363281 -0.64886719 -20.55664062 -0.69335938 C-22.37091464 -0.79870432 -24.1854355 -0.89978316 -26 -1 C-25.67 1.97 -25.34 4.94 -25 8 C-23.68 7.67 -22.36 7.34 -21 7 C-15.30215845 6.59569771 -10.33769739 6.75254847 -5 9 C-8.14692933 9.97663324 -10.55637571 9.97784814 -13.8125 9.5625 C-17.92057895 9.08778865 -21.86817473 8.91017771 -26 9 C-26.66 5.7 -27.32 2.4 -28 -1 C-19.31597186 -5.02900381 -8.61864602 -3.81108485 0 0 Z "
        fill="#1E345F"
        transform="translate(80,29)"
      />
      <path
        d="M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C9.32097997 2.86859084 16.64748331 3.46589137 24 4 C24 4.33 24 4.66 24 5 C22.72382812 5.10957031 21.44765625 5.21914062 20.1328125 5.33203125 C18.46347228 5.49146262 16.79420495 5.65165855 15.125 5.8125 C13.86236328 5.91788086 13.86236328 5.91788086 12.57421875 6.02539062 C11.76855469 6.10595703 10.96289062 6.18652344 10.1328125 6.26953125 C9.01737061 6.37164917 9.01737061 6.37164917 7.87939453 6.47583008 C5.60154748 6.89086688 5.60154748 6.89086688 4 10 C1.03 9.505 1.03 9.505 -2 9 C-2.6875 6.75 -2.6875 6.75 -3 4 C-1.6875 1.6875 -1.6875 1.6875 0 0 Z "
        fill="#4775C8"
        transform="translate(44,92)"
      />
      <path
        d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C3.01 2 2.02 2 1 2 C-1.642802 16.37160095 -0.73776104 28.8482255 3 43 C-0.5703669 41.21481655 -1.78226225 37.60989728 -3 34 C-3.5400354 29.83980636 -3.51466484 25.7518038 -3.4375 21.5625 C-3.44458984 20.48162109 -3.45167969 19.40074219 -3.45898438 18.28710938 C-3.40600124 11.56640276 -2.47785219 6.25049716 0 0 Z "
        fill="#182B50"
        transform="translate(12,46)"
      />
      <path
        d="M0 0 C1.05058594 -0.01224609 2.10117187 -0.02449219 3.18359375 -0.03710938 C9.18177811 -0.04837005 14.41224197 0.29871109 20.125 2.1875 C20.785 2.8475 21.445 3.5075 22.125 4.1875 C21.05185547 3.9709375 21.05185547 3.9709375 19.95703125 3.75 C7.67312212 1.46166505 -2.88462774 1.60437126 -14.875 5.1875 C-16.29157512 5.58366084 -17.70822495 5.97955476 -19.125 6.375 C-20.0325 6.643125 -20.94 6.91125 -21.875 7.1875 C-21.215 5.8675 -20.555 4.5475 -19.875 3.1875 C-19.215 3.1875 -18.555 3.1875 -17.875 3.1875 C-17.875 2.5275 -17.875 1.8675 -17.875 1.1875 C-11.94190435 -0.09560892 -6.0388105 0.00367772 0 0 Z "
        fill="#264170"
        transform="translate(59.875,11.8125)"
      />
      <path
        d="M0 0 C3.70678873 1.53696118 5.17872343 3.8614286 7.5625 7.0625 C6.2425 6.7325 4.9225 6.4025 3.5625 6.0625 C3.2325 8.3725 2.9025 10.6825 2.5625 13.0625 C1.5725 12.7325 0.5825 12.4025 -0.4375 12.0625 C-0.7675 10.0825 -1.0975 8.1025 -1.4375 6.0625 C-2.076875 5.93875 -2.71625 5.815 -3.375 5.6875 C-4.055625 5.48125 -4.73625 5.275 -5.4375 5.0625 C-5.7675 4.4025 -6.0975 3.7425 -6.4375 3.0625 C-4.2312818 1.01970537 -3.05372536 0.07830065 0 0 Z "
        fill="#497ACF"
        transform="translate(86.4375,34.9375)"
      />
      <path
        d="M0 0 C6.20857963 6.20857963 6.86184051 19.48449119 7.1171875 27.93359375 C7.0887291 34.44582357 5.59852519 40.71427384 4 47 C3.67 47 3.34 47 3 47 C3.0721875 45.99582031 3.144375 44.99164063 3.21875 43.95703125 C4.58736494 26.21216374 4.58736494 26.21216374 1.75390625 8.75390625 C0.95949152 5.85202862 0.45095837 2.97282268 0 0 Z "
        fill="#1C3257"
        transform="translate(121,39)"
      />
      <path
        d="M0 0 C0.33 0.66 0.66 1.32 1 2 C3.02463255 2.65213292 3.02463255 2.65213292 5 3 C-2.01783344 8.49703883 -9.30695985 12.73839606 -18 15 C-20.3828125 14.625 -20.3828125 14.625 -22 14 C-20.37478703 12.06006325 -19.47190573 11.09348228 -16.94921875 10.59375 C-16.20285156 10.5628125 -15.45648438 10.531875 -14.6875 10.5 C-10.54596369 10.18194084 -7.61764891 9.13348525 -4 7 C-4 6.01 -4 5.02 -4 4 C-2.68 3.67 -1.36 3.34 0 3 C0 2.01 0 1.02 0 0 Z "
        fill="#203762"
        transform="translate(98,114)"
      />
      <path
        d="M0 0 C5.28 0 10.56 0 16 0 C16 0.33 16 0.66 16 1 C15.30132812 1.02578125 14.60265625 1.0515625 13.8828125 1.078125 C12.97273438 1.13484375 12.06265625 1.1915625 11.125 1.25 C10.22007813 1.29640625 9.31515625 1.3428125 8.3828125 1.390625 C5.82889456 1.75611148 5.82889456 1.75611148 4.6796875 4.046875 C4.45539062 4.69140625 4.23109375 5.3359375 4 6 C6.31 6.33 8.62 6.66 11 7 C11 7.33 11 7.66 11 8 C7.7 8.33 4.4 8.66 1 9 C0.67 6.03 0.34 3.06 0 0 Z "
        fill="#4F77C4"
        transform="translate(54,28)"
      />
      <path
        d="M0 0 C0.66 0.33 1.32 0.66 2 1 C1 4 1 4 -2.0625 6.375 C-5.26584338 8.66428578 -5.26584338 8.66428578 -5.375 11.8125 C-5.25125 12.534375 -5.1275 13.25625 -5 14 C-7.475 13.01 -7.475 13.01 -10 12 C-10 9 -10 9 -7.8125 6.73828125 C-6.884375 5.93777344 -5.95625 5.13726562 -5 4.3125 C-4.071875 3.50425781 -3.14375 2.69601563 -2.1875 1.86328125 C-1.1046875 0.94095703 -1.1046875 0.94095703 0 0 Z "
        fill="#314D81"
        transform="translate(27,12)"
      />
      <path
        d="M0 0 C3.48670834 1.1094072 6.77484237 2.26337666 10 4 C9.45773019 7.79588866 7.79872437 9.47211993 5 12 C4.34 11.67 3.68 11.34 3 11 C3.66 10.38125 4.32 9.7625 5 9.125 C7.2284549 7.24362573 7.2284549 7.24362573 7 5 C2.48382401 4.92345464 -1.59085217 4.89771304 -6 6 C-4 4 -2 2 0 0 Z "
        fill="#203762"
        transform="translate(100,104)"
      />
      <path
        d="M0 0 C4.0081803 3.67416528 6.52591615 7.14346504 9 12 C9 12.66 9 13.32 9 14 C8.34 14 7.68 14 7 14 C6.67 13.34 6.34 12.68 6 12 C5.01 12.495 5.01 12.495 4 13 C3.67 11.35 3.34 9.7 3 8 C1.68 7.67 0.36 7.34 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z "
        fill="#345993"
        transform="translate(112,25)"
      />
      <path
        d="M0 0 C0.60328125 0.08378906 1.2065625 0.16757813 1.828125 0.25390625 C3.02695313 0.40666016 3.02695313 0.40666016 4.25 0.5625 C5.03890625 0.66691406 5.8278125 0.77132812 6.640625 0.87890625 C9.01990719 1.00102173 10.7282873 0.65530174 13 0 C13.66 0 14.32 0 15 0 C14.34 1.98 13.68 3.96 13 6 C7.71862571 5.48474397 4.42778844 3.74522883 0 1 C0 0.67 0 0.34 0 0 Z "
        fill="#3E5C9D"
        transform="translate(106,94)"
      />
      <path
        d="M0 0 C0.680625 0.70125 1.36125 1.4025 2.0625 2.125 C8.67834394 8.85259859 8.67834394 8.85259859 17 13 C17 13.66 17 14.32 17 15 C14.39417629 15.93065133 13.35801776 16.14917407 10.75 15.0625 C10.1725 14.711875 9.595 14.36125 9 14 C9 13.34 9 12.68 9 12 C8.34 12 7.68 12 7 12 C6.54625 11.236875 6.0925 10.47375 5.625 9.6875 C4.19410993 6.92083785 4.19410993 6.92083785 1.8125 5.4375 C1.214375 4.963125 0.61625 4.48875 0 4 C0 2.68 0 1.36 0 0 Z "
        fill="#365690"
        transform="translate(37,80)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C0.96519531 1.12535156 0.96519531 1.12535156 0.9296875 2.2734375 C0.80880364 9.12927937 1.35063873 15.34364917 3 22 C-0.26755825 18.95027897 -2.74883268 16.62679154 -3.1875 12.0390625 C-3.25 9.875 -3.25 9.875 -3 6 C-2.34 5.34 -1.68 4.68 -1 4 C-0.3574765 1.93125966 -0.3574765 1.93125966 0 0 Z "
        fill="#254071"
        transform="translate(34,58)"
      />
      <path
        d="M0 0 C5 5 10 10 15 15 C11.6875 14.875 11.6875 14.875 8 14 C6.3125 11.0625 6.3125 11.0625 5 8 C4.29875 7.67 3.5975 7.34 2.875 7 C2.25625 6.67 1.6375 6.34 1 6 C0.25 2.875 0.25 2.875 0 0 Z "
        fill="#233B65"
        transform="translate(19,96)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C0.88543872 2.39674267 0.75871281 4.79181218 0.625 7.1875 C0.5940625 7.86103516 0.563125 8.53457031 0.53125 9.22851562 C0.29896078 13.19678975 -0.28387476 16.40729879 -2 20 C-2.33 20 -2.66 20 -3 20 C-3.09765625 13.84765625 -3.09765625 13.84765625 -3 12 C-2.67 11.67 -2.34 11.34 -2 11 C-2 10.01 -2 9.02 -2 8 C-1.17647059 1.17647059 -1.17647059 1.17647059 0 0 Z "
        fill="#3A63A5"
        transform="translate(124,74)"
      />
      <path
        d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C5.11375 2.185625 5.11375 2.185625 6.25 2.375 C8.80141485 2.95486701 10.7267573 3.73708739 13 5 C13.125 7.875 13.125 7.875 13 11 C12.34 11.66 11.68 12.32 11 13 C11 11.35 11 9.7 11 8 C8.36 6.68 5.72 5.36 3 4 C3 3.01 3 2.02 3 1 C2.01 0.67 1.02 0.34 0 0 Z "
        fill="#2D4B7D"
        transform="translate(13,45)"
      />
      <path
        d="M0 0 C-0.92683594 0.33773438 -1.85367188 0.67546875 -2.80859375 1.0234375 C-4.00613281 1.46945313 -5.20367187 1.91546875 -6.4375 2.375 C-7.63246094 2.81585938 -8.82742187 3.25671875 -10.05859375 3.7109375 C-13.10196898 4.67085236 -13.10196898 4.67085236 -14 7 C-15.84765625 7.6328125 -15.84765625 7.6328125 -18.0625 8.125 C-18.79597656 8.29257813 -19.52945313 8.46015625 -20.28515625 8.6328125 C-20.85105469 8.75398437 -21.41695312 8.87515625 -22 9 C-18.83107931 5.36366351 -15.3798134 3.51547651 -11 1.6875 C-10.38382813 1.41099609 -9.76765625 1.13449219 -9.1328125 0.84960938 C-5.76067643 -0.58680481 -3.47330758 -1.48483899 0 0 Z "
        fill="#4A75C0"
        transform="translate(52,5)"
      />
      <path
        d="M0 0 C2.475 0.99 2.475 0.99 5 2 C5 3.32 5 4.64 5 6 C5.66 6.33 6.32 6.66 7 7 C8.09506492 10.28519475 8.09960608 12.73663415 8.0625 16.1875 C8.05347656 17.27417969 8.04445313 18.36085938 8.03515625 19.48046875 C8.02355469 20.31191406 8.01195313 21.14335938 8 22 C7.67 22 7.34 22 7 22 C6.67 17.71 6.34 13.42 6 9 C5.34 9 4.68 9 4 9 C0 2.25 0 2.25 0 0 Z "
        fill="#4165A1"
        transform="translate(86,47)"
      />
      <path
        d="M0 0 C-0.33 1.32 -0.66 2.64 -1 4 C-1.99 4 -2.98 4 -4 4 C-4.33 4.99 -4.66 5.98 -5 7 C-7.97 7 -10.94 7 -14 7 C-11.79459886 4.79459886 -9.78605258 3.7599273 -7 2.375 C-6.113125 1.92898437 -5.22625 1.48296875 -4.3125 1.0234375 C-2 0 -2 0 0 0 Z "
        fill="#294476"
        transform="translate(94,110)"
      />
      <path
        d="M0 0 C1.125 3.75 1.125 3.75 0 6 C-0.66 6 -1.32 6 -2 6 C-2 6.66 -2 7.32 -2 8 C-2.99 8 -3.98 8 -5 8 C-5.75 6.25 -5.75 6.25 -6 4 C-2.77777778 0 -2.77777778 0 0 0 Z "
        fill="#477DD6"
        transform="translate(27,17)"
      />
      <path
        d="M0 0 C6.0546875 -0.1953125 6.0546875 -0.1953125 8 0 C10 2 10 2 10 6 C5.56909529 4.79157144 3.01887244 3.48331435 0 0 Z "
        fill="#365998"
        transform="translate(26,118)"
      />
      <path
        d="M0 0 C4.72284267 -0.73794417 7.55479825 1.23058746 11.42578125 3.61328125 C11.94527344 4.07089844 12.46476562 4.52851563 13 5 C13 5.99 13 6.98 13 8 C8.50202887 6.31326082 4.27113698 4.18326108 0 2 C0 1.34 0 0.68 0 0 Z "
        fill="#2C4D83"
        transform="translate(82,15)"
      />
      <path
        d="M0 0 C-2.22664317 0.985267 -4.45601317 1.96331444 -6.6875 2.9375 C-7.62625977 3.35418945 -7.62625977 3.35418945 -8.58398438 3.77929688 C-12.03484724 5.2788865 -15.27477406 6.43729857 -19 7 C-16.45398308 4.00468598 -13.65531543 2.75995951 -10.0625 1.25 C-9.02222656 0.80140625 -7.98195313 0.3528125 -6.91015625 -0.109375 C-3.98946545 -1.003224 -2.78743446 -1.10154037 0 0 Z "
        fill="#1B3257"
        transform="translate(48,5)"
      />
      <path
        d="M0 0 C0.33 0 0.66 0 1 0 C1.268125 1.134375 1.53625 2.26875 1.8125 3.4375 C2.95849272 8.04620455 4.44306645 12.51603139 6 17 C2.50325031 15.25162516 1.28362006 11.56357377 0 8 C-0.30968217 5.22693694 -0.20010953 2.80153338 0 0 Z "
        fill="#2D497E"
        transform="translate(9,72)"
      />
      <path
        d="M0 0 C0.33 0.66 0.66 1.32 1 2 C3.02463255 2.65213292 3.02463255 2.65213292 5 3 C0.375 7 0.375 7 -3 7 C-3.33 6.01 -3.66 5.02 -4 4 C-2.68 3.67 -1.36 3.34 0 3 C0 2.01 0 1.02 0 0 Z "
        fill="#325691"
        transform="translate(98,114)"
      />
      <path
        d="M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z M-6 2 C-4.02 2.99 -4.02 2.99 -2 4 C-2 3.34 -2 2.68 -2 2 C-1.34 2.33 -0.68 2.66 0 3 C0 4.98 0 6.96 0 9 C-2.04119788 7.38405168 -4.04072937 5.7143618 -6 4 C-6 3.34 -6 2.68 -6 2 Z "
        fill="#335B99"
        transform="translate(18,102)"
      />
      <path
        d="M0 0 C-0.33 0.99 -0.66 1.98 -1 3 C-3.31 3 -5.62 3 -8 3 C-7.67 2.01 -7.34 1.02 -7 0 C-2.25 -1.125 -2.25 -1.125 0 0 Z "
        fill="#447ED6"
        transform="translate(57,98)"
      />
      <path
        d="M0 0 C3.59634744 3.49359465 6.83451967 7.11098131 10 11 C6.01867611 9.31559374 3.10802023 6.96674659 0 4 C0 2.68 0 1.36 0 0 Z "
        fill="#17284A"
        transform="translate(37,80)"
      />
      <path
        d="M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 4.96 2.34 8.92 2 13 C1.67 13 1.34 13 1 13 C0.67 8.71 0.34 4.42 0 0 Z "
        fill="#456FB6"
        transform="translate(31,57)"
      />
      <path
        d="M0 0 C0.99 0.495 0.99 0.495 2 1 C2 2.32 2 3.64 2 5 C2.99 5.33 3.98 5.66 5 6 C4.67 7.65 4.34 9.3 4 11 C1.6870518 8.6870518 1.50419025 7.52095125 0.875 4.375 C0.70742188 3.55773437 0.53984375 2.74046875 0.3671875 1.8984375 C0.24601563 1.27195312 0.12484375 0.64546875 0 0 Z "
        fill="#4A78C0"
        transform="translate(3,83)"
      />
      <path
        d="M0 0 C0.66 0 1.32 0 2 0 C1.34 1.98 0.68 3.96 0 6 C-5.75 5.25 -5.75 5.25 -8 3 C-3.25 3.875 -3.25 3.875 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z "
        fill="#162F51"
        transform="translate(119,94)"
      />
      <path
        d="M0 0 C2.79872437 2.52788007 4.45773019 4.20411134 5 8 C4.34 8 3.68 8 3 8 C3 7.34 3 6.68 3 6 C2.01 6 1.02 6 0 6 C0 4.02 0 2.04 0 0 Z "
        fill="#2A487D"
        transform="translate(95,42)"
      />
      <path
        d="M0 0 C1.65 0.33 3.3 0.66 5 1 C5.33 2.98 5.66 4.96 6 7 C3.69 5.35 1.38 3.7 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z "
        fill="#345690"
        transform="translate(80,40)"
      />
      <path
        d="M0 0 C4.99275057 1.27721526 7.57611908 3.17330957 11 7 C5.58657319 5.85485202 3.0657052 4.65987191 0 0 Z "
        fill="#1B335E"
        transform="translate(92,9)"
      />
      <path
        d="M0 0 C0.99 0 1.98 0 3 0 C4 6.625 4 6.625 4 10 C1.16625119 6.79663178 0.4794463 4.21912747 0 0 Z "
        fill="#31568D"
        transform="translate(7,94)"
      />
      <path
        d="M0 0 C2.475 0.99 2.475 0.99 5 2 C5 4.31 5 6.62 5 9 C2.67527795 6.14693203 1.2491742 3.45925163 0 0 Z "
        fill="#243B6C"
        transform="translate(86,47)"
      />
    </svg>
  );
}

export const RequestOnboardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Слой 1"
      viewBox="0 0 128 128"
      x="0px"
      y="0px"
      height="100%"
    >
      <title fill="currentColor">ic_request_group</title>
      <path
        d="M90.16,92.23a16.15,16.15,0,1,0-17.45,0A27.35,27.35,0,0,0,64,97,38.59,38.59,0,0,0,49,88.83a22.26,22.26,0,1,0-20.75,0A38.66,38.66,0,0,0,0,126a2,2,0,0,0,4,0,34.6,34.6,0,0,1,69.19,0,2,2,0,0,0,4,0A38.46,38.46,0,0,0,66.92,99.82,23.56,23.56,0,0,1,105,118.37a2,2,0,0,0,4,0A27.61,27.61,0,0,0,90.16,92.23ZM20.34,69.15A18.26,18.26,0,1,1,38.59,87.41,18.28,18.28,0,0,1,20.34,69.15Zm49,9.51A12.15,12.15,0,1,1,81.44,90.81,12.16,12.16,0,0,1,69.29,78.66Z"
        fill="currentColor"
      ></path>
      <path
        d="M128,44.66c-.18-2.75-2.34-3.79-3.92-4.55l-.82-.41h0a8,8,0,0,1-4.12-6.65V20.41a20.63,20.63,0,0,0-41.26,0V33.05a8,8,0,0,1-4.12,6.65c-.24.13-.49.25-.74.36-1.52.74-3.82,1.84-4,4.6A5.92,5.92,0,0,0,70.7,49,6,6,0,0,0,75,51H88.18a10.42,10.42,0,0,0,20.64,0H122a6,6,0,0,0,4.31-2A5.92,5.92,0,0,0,128,44.66ZM98.5,56a6.43,6.43,0,0,1-6.26-5h12.52A6.43,6.43,0,0,1,98.5,56Zm24.89-9.73A2.16,2.16,0,0,1,122,47H75a2.16,2.16,0,0,1-1.38-.75A2,2,0,0,1,73,44.92c0-.37.46-.63,1.74-1.25.29-.14.57-.27.85-.42a12,12,0,0,0,6.28-10.2V20.41a16.63,16.63,0,0,1,33.26,0V33.05a12,12,0,0,0,6.28,10.2l.92.46c1.51.73,1.65.89,1.67,1.21A2,2,0,0,1,123.39,46.27Z"
        fill="currentColor"
      ></path>
    </svg>
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   version="1.1"
    //   x="0px"
    //   y="0px"
    //   viewBox="0 0 52 52"
    //   enableBackground="new 0 0 52 52"
    //   height="100%"
    // >
    //   <g fill="currentColor">
    //     <g fill="currentColor">
    //       <g fill="currentColor">
    //         <path
    //           d="M17.0429688,31.4111328c0,0,0,0-0.0009766,0c-0.2529297,0-0.5097656-0.0107422-0.7685547-0.0332031     c-4.4033203-0.3828125-7.8525391-4.3291016-7.8525391-8.9838867v-1.8515625c0-4.6547852,3.4492188-8.6010742,7.8525391-8.9838867     c5.1074219-0.4428711,9.390625,3.5800781,9.390625,8.5883789v2.6425781c0,2.3027344-0.8964844,4.4682617-2.5253906,6.0961914     C21.5107422,30.5146484,19.3457031,31.4111328,17.0429688,31.4111328z M17.0419922,13.5249023     c-0.1962891,0-0.3945313,0.0087891-0.5947266,0.0258789c-3.3798828,0.2939453-6.0263672,3.3647461-6.0263672,6.9916992v1.8515625     c0,3.6264648,2.6474609,6.6977539,6.0263672,6.9916992c0.1992188,0.0175781,0.3984375,0.0253906,0.5947266,0.0253906     c0.0009766,0,0.0009766,0,0.0009766,0c1.7685547,0,3.4316406-0.6884766,4.6816406-1.9394531     c1.2509766-1.2504883,1.9394531-2.9130859,1.9394531-4.6821289v-2.6425781     C23.6640625,16.4956055,20.6933594,13.5249023,17.0419922,13.5249023z"
    //           fill="currentColor"
    //         ></path>
    //       </g>
    //       <g fill="currentColor">
    //         <g fill="currentColor">
    //           <path
    //             d="M30.8544922,45.5683594H3.2314453c-0.3994141,0-0.7617188-0.2382813-0.9189453-0.6054688      c-0.6943359-1.6181641-0.0996094-7.1357422,0.4433594-8.2216797c0.7060547-1.4101563,2.0537109-2.4404297,3.6972656-2.8291016      c4.5400391-1.0722656,7.3955078-4.4931641,7.4238281-4.5273438c0.3496094-0.4257813,0.9804688-0.4882813,1.40625-0.1386719      c0.4267578,0.3486328,0.4902344,0.9775391,0.1416016,1.4042969c-0.1318359,0.1621094-3.2919922,3.9755859-8.5126953,5.2089844      c-1.0644531,0.2509766-1.9277344,0.8994141-2.3671875,1.7773438c-0.3037109,0.6708984-0.6708984,4.3232422-0.5166016,5.9316406      h26.0283203c0.1552734-1.609375-0.2138672-5.2617188-0.5185547-5.9375      c-0.4375-0.8720703-1.3007813-1.5205078-2.3652344-1.7714844c-5.2207031-1.2333984-8.3798828-5.046875-8.5126953-5.2089844      c-0.3476563-0.4267578-0.2841797-1.0556641,0.1425781-1.4052734c0.4248047-0.3466797,1.0556641-0.2861328,1.40625,0.1396484      c0.0283203,0.0351563,2.8828125,3.4560547,7.4228516,4.5273438c1.6435547,0.3886719,2.9912109,1.4189453,3.6972656,2.828125      c0.5419922,1.0859375,1.1376953,6.6025391,0.4443359,8.2216797      C31.6162109,45.3300781,31.2548828,45.5683594,30.8544922,45.5683594z"
    //             fill="currentColor"
    //           ></path>
    //         </g>
    //         <g fill="currentColor">
    //           <path
    //             d="M17.0429688,40.5136719c-4.9130859,0-8.9785156-2.3837891-9.8847656-5.796875      c-0.1416016-0.5341797,0.1767578-1.0820313,0.7099609-1.2236328c0.5341797-0.140625,1.0810547,0.1767578,1.2236328,0.7099609      c0.6630859,2.4980469,4.0068359,4.3105469,7.9511719,4.3105469c3.9472656,0,7.2900391-1.8125,7.9501953-4.3095703      c0.140625-0.5341797,0.6914063-0.8505859,1.2226563-0.7109375c0.5332031,0.140625,0.8525391,0.6884766,0.7109375,1.2226563      C26.0244141,38.1289063,21.9599609,40.5136719,17.0429688,40.5136719z"
    //             fill="currentColor"
    //           ></path>
    //         </g>
    //       </g>
    //     </g>
    //     <g fill="currentColor">
    //       <g fill="currentColor">
    //         <g fill="currentColor">
    //           <path
    //             d="M31.3515625,25.1606445c-0.15625,0-0.3134766-0.0366211-0.4570313-0.1108398      c-0.3330078-0.1708984-0.5429688-0.5141602-0.5429688-0.8891602v-2.4077148h-0.6425781      c-1.3701172,0-2.484375-1.1142578-2.484375-2.4838867V8.9155273c0-1.3696289,1.1142578-2.4838867,2.484375-2.4838867H47.515625      C48.8857422,6.4316406,50,7.5458984,50,8.9155273V19.269043c0,1.3696289-1.1142578,2.4838867-2.484375,2.4838867H36.4335938      l-4.5,3.2207031C31.7607422,25.0976563,31.5566406,25.1606445,31.3515625,25.1606445z M29.7089844,8.4316406      c-0.2666016,0-0.484375,0.2172852-0.484375,0.4838867V19.269043c0,0.2666016,0.2177734,0.4838867,0.484375,0.4838867h1.6425781      c0.5527344,0,1,0.4477539,1,1v1.4619141l3.1787109-2.2749023c0.1699219-0.121582,0.3730469-0.1870117,0.5820313-0.1870117      H47.515625C47.7822266,19.7529297,48,19.5356445,48,19.269043V8.9155273c0-0.2666016-0.2177734-0.4838867-0.484375-0.4838867      H29.7089844z"
    //             fill="currentColor"
    //           ></path>
    //         </g>
    //       </g>
    //     </g>
    //   </g>
    // </svg>
  );
};

export const TrackOnboardIcon = () => {
  return (
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 100 100" height="100%">
      <g transform="translate(0,-952.36218)" fill="currentColor">
        <path
          d="m 37.012126,960.36576 c -16.0043,0 -29,12.99558 -29,29.00001 0,16.00443 12.9957,29.00003 29,29.00003 7.6449,0 14.5979,-2.9705 19.7813,-7.8125 l 4.5313,4.5312 -2.125,2.125 c -0.3655,0.3697 -0.3655,1.0366 0,1.4063 l 25.437398,25.4687 c 0.3697,0.3655 1.0366,0.3655 1.4063,0 l 5.6563,-5.6562 c 0.3842,-0.3718 0.3842,-1.0657 0,-1.4375 l -25.437598,-25.4375 c -0.3697,-0.3655 -1.0365,-0.3655 -1.4062,0 l -2.125,2.125 -4.5,-4.5313 c 4.8333,-5.1817 7.7812,-12.14413 7.7812,-19.78123 0,-16.00443 -12.9956,-29.00001 -29,-29.00001 z m 0,2 c 14.9235,0 27,12.07646 27,27.00001 0,14.92353 -12.0765,27.00003 -27,27.00003 -14.9236,0 -27,-12.0765 -27,-27.00003 0,-14.92355 12.0764,-27.00001 27,-27.00001 z m 0,5 c -5.3158,0 -10.6381,2.08089 -14.6874,6.25 -0.4228,0.59717 -0.4657,1.05369 -0.026,1.47395 0.6635,0.40454 0.9533,0.31438 1.4325,-0.0365 7.3454,-7.56266 19.217,-7.56269 26.5625,0 0.3127,0.34071 0.8672,0.41003 1.25,0.15625 0.5062,-0.32717 0.5888,-1.169 0.1563,-1.59375 -4.0494,-4.16911 -9.3717,-6.25 -14.6876,-6.25 z m 28.5313,46.31254 24.031298,24.0312 -4.2188,4.25 -24.062498,-24.0625 z"
          fill="currentColor"
          fillOpacity="1"
          stroke="currentColor"
          marker="none"
          visibility="visible"
          display="inline"
          overflow="visible"
        ></path>
      </g>
    </svg>
  );
};

export const OverallStatusIcon = () => {
  return (
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 100 100" height="100%">
      <g transform="translate(0,-952.36218)" fill="currentColor">
        <path
          d="M 40.8125 13 A 2.0002 2.0002 0 0 0 39 15 L 39 78 A 2.0002 2.0002 0 0 0 41 80 L 59 80 A 2.0002 2.0002 0 0 0 61 78 L 61 15 A 2.0002 2.0002 0 0 0 59 13 L 41 13 A 2.0002 2.0002 0 0 0 40.8125 13 z M 43 17 L 57 17 L 57 76 L 43 76 L 43 17 z M 67.8125 36 A 2.0002 2.0002 0 0 0 66 38 L 66 78 A 2.0002 2.0002 0 0 0 68 80 L 86 80 A 2.0002 2.0002 0 0 0 88 78 L 88 38 A 2.0002 2.0002 0 0 0 86 36 L 68 36 A 2.0002 2.0002 0 0 0 67.8125 36 z M 70 40 L 84 40 L 84 76 L 70 76 L 70 40 z M 13.8125 50 A 2.0002 2.0002 0 0 0 12 52 L 12 78 A 2.0002 2.0002 0 0 0 14 80 L 32 80 A 2.0002 2.0002 0 0 0 34 78 L 34 52 A 2.0002 2.0002 0 0 0 32 50 L 14 50 A 2.0002 2.0002 0 0 0 13.8125 50 z M 16 54 L 30 54 L 30 76 L 16 76 L 16 54 z M 7.8125 83 A 2.0021961 2.0021961 0 1 0 8 87 L 92 87 A 2.0002 2.0002 0 1 0 92 83 L 8 83 A 2.0002 2.0002 0 0 0 7.8125 83 z "
          transform="translate(0,952.36218)"
          fill="currentColor"
        ></path>
      </g>
    </svg>
  );
};

export const ChangeRole = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      fill="currentColor"
      className="bi bi-person-plus"
      viewBox="0 0 16 16"
    >
      <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
      <path
        fillRule="evenodd"
        d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5"
      />
    </svg>
  );
};

export const BoardSetting = () => {
  return (
    <svg
      width="80px"
      height="80px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="🔍-Product-Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="ic_fluent_board_24_regular" fill="#212121" fillRule="nonzero">
          <path
            d="M18.2513521,2.49820514 C19.9843968,2.49820514 21.4006513,3.85452629 21.4962634,5.56367469 L21.5014083,5.74810161 L21.5008077,17.7519229 C21.5005988,19.5467519 20.0455893,21.0018356 18.2507042,21.0018356 L6.25005624,21.0018356 C4.51701151,21.0018356 3.10075697,19.6455145 3.00514494,17.9363661 L3,17.7519391 L3.00060063,5.74811784 C3.00080955,3.9532889 4.45581897,2.49820514 6.25064792,2.49820514 L18.2513521,2.49820514 Z M11.5,9.49820514 L4.5,9.49920514 L4.50010353,17.7518667 L4.50727563,17.9125936 C4.58838653,18.803788 5.33765319,19.5018356 6.25,19.5018356 L11.5,19.5012051 L11.5,9.49820514 Z M20,15.4982051 L13,15.4992051 L13,19.5012051 L18.2506479,19.5018356 C19.2171619,19.5018356 20.0006952,18.7182622 20.0008077,17.7518046 L20,15.4982051 Z M18.2514083,3.99820514 L13,3.99720514 L13,13.9992051 L20,13.9982051 L20.0013048,5.74817408 L19.9941327,5.58744715 C19.9130218,4.69625278 19.1637551,3.99820514 18.2514083,3.99820514 Z M11.5,3.99720514 L6.25073228,3.99820514 L6.10723072,4.00401666 C5.20785168,4.0770851 4.5007075,4.83010139 4.50060063,5.7482362 L4.5,7.99920514 L11.5,7.99820514 L11.5,3.99720514 Z"
            id="🎨-Color"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-copy"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
      ></path>
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <span className="text-color-497ed8">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-funnel"
        viewBox="0 0 16 16"
      >
        <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z"></path>
      </svg>
    </span>
  );
};

export const TouchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 100"
      version="1.1"
      width="24"
      height="24"
    >
      <g stroke="none" strokeWidth="2" fill="none" fillRule="evenodd">
        <g fill="#497ed8">
          <path d="M30.3209452,36.0013725 C30.7720177,36.0013725 31.2252504,35.8470588 31.5952202,35.5315686 C32.4199936,34.8284314 32.5177881,33.5907843 31.8133924,32.7672549 C29.1099029,29.6064706 27.6209906,25.575098 27.6209906,21.4158824 C27.6209906,11.7694118 35.4806884,3.92156863 45.1417307,3.92156863 C54.802773,3.92156863 62.6624709,11.7694118 62.6624709,21.4158824 C62.6624709,25.575098 61.1735585,29.6064706 58.4700691,32.7668627 C57.7658697,33.5903922 57.8632715,34.8280392 58.6880449,35.5313725 C59.5130147,36.2347059 60.7525313,36.1370588 61.4565344,35.3139216 C64.7668214,31.4437255 66.5899634,26.5080392 66.5899634,21.4158824 C66.5899634,9.60705882 56.968196,0 45.1417307,0 C33.3150691,0 23.6934981,9.60705882 23.6934981,21.4158824 C23.6934981,26.5080392 25.5164437,31.4437255 28.8267307,35.3139216 C29.2151597,35.7682353 29.7663833,36.0013725 30.3209452,36.0013725 M77.3480721,78.0154902 C76.9205646,82.4068627 75.1838274,86.5382353 72.4577549,89.6492157 C68.719764,93.9152941 63.5555041,96.0784314 57.1083289,96.0784314 C45.3185857,96.0784314 38.3025132,85.935098 38.2351567,85.8358824 C38.2110026,85.7998039 38.1854739,85.7645098 38.1589634,85.7301961 C33.1893108,79.3060784 24.4848093,63.2876471 21.9350812,58.5313725 C21.921335,58.5054902 21.9258516,58.4719608 21.9321356,58.4539216 C24.5044467,57.0031373 27.684341,57.7247059 29.5035555,60.1747059 L38.3201869,72.0482353 C38.8246733,72.7276471 39.7087519,73.0076471 40.5134951,72.7423529 C41.3178455,72.4770588 41.8614105,71.7264706 41.8614105,70.8803922 L41.8614105,21.6978431 C41.8614105,20.6960784 42.2541597,19.7405882 42.9391144,19.0764706 C43.5415918,18.4919608 44.3094165,18.1831373 45.120051,18.2064706 C46.8206552,18.2558824 48.2043108,19.8729412 48.2043108,21.8111765 L48.2043108,47.6378431 L48.2043108,52.5903922 C48.2043108,53.6733333 49.08348,54.5511765 50.168057,54.5511765 C51.2524377,54.5511765 52.1318032,53.6733333 52.1318032,52.5903922 L52.1318032,47.692549 C52.2046582,45.8186275 53.5926341,44.3527451 55.298344,44.3527451 C57.04706,44.3527451 58.4697942,45.9196078 58.4697942,47.8452941 L58.4697942,54.4464706 C58.4697942,55.5294118 59.3491597,56.4072549 60.4335404,56.4072549 C61.5181174,56.4072549 62.3972866,55.5294118 62.3972866,54.4464706 C62.3972866,52.5207843 63.8200208,50.9539216 65.5689331,50.9539216 C67.3176492,50.9539216 68.7401869,52.5207843 68.7401869,54.4464706 L68.7401869,59.7576471 C68.7401869,60.0019608 68.7859422,60.2443137 68.8752927,60.4719608 L68.9695525,60.7127451 C69.2896431,61.5294118 70.1128455,62.0354902 70.9878909,61.95 C71.8619543,61.8652941 72.5738123,61.2113725 72.7303229,60.3484314 C73.0256703,58.7241176 74.3329362,57.545098 75.8391295,57.545098 C77.5621205,57.545098 78.9685555,59.0656863 79.0097942,60.9521569 L77.3480721,78.0154902 Z M75.8391295,53.6235294 C79.7536612,53.6235294 82.9382685,56.9494118 82.9382685,61.0376471 C82.9382685,61.1009804 82.9351265,61.1643137 82.9290389,61.227451 L81.2571054,78.395098 C80.7508516,83.595098 78.6755646,88.5090196 75.4133893,92.2313725 C70.9605948,97.3135294 64.6306552,100 57.1083289,100 C43.5433591,100 35.7103682,89.0907843 35.0144165,88.0803922 C29.9964558,81.5729412 21.7785706,66.5498039 18.4726038,60.3817647 C17.4602927,58.4933333 18.1281628,56.1068627 19.9609271,55.0619608 C24.2905948,52.5935294 29.6306099,53.7615686 32.6587066,57.8392157 L37.933918,64.9435294 L37.933918,21.6978431 C37.933918,19.642549 38.7608516,17.6617647 40.2028304,16.2633333 C41.5735253,14.9339216 43.3636764,14.2313725 45.234341,14.2864706 C49.0375283,14.3970588 52.1318032,17.7727451 52.1318032,21.8111765 L52.1318032,41.2005882 C53.0844165,40.707451 54.159764,40.4311765 55.298344,40.4311765 C59.2026643,40.4311765 62.3809875,43.7403922 62.3972866,47.8143137 C63.3522564,47.3141176 64.4295676,47.0323529 65.5687368,47.0323529 C69.4697186,47.0323529 72.6458818,50.3360784 72.667483,54.404902 C73.6279513,53.9033333 74.7074226,53.6235294 75.8391295,53.6235294 Z M54.0514044,30.2170588 C53.1657549,29.5919608 52.9552413,28.3684314 53.5810872,27.4841176 C54.8156945,25.74 55.4682473,23.6862745 55.4682473,21.5456863 C55.4682473,15.8601961 50.83577,11.2347059 45.1416915,11.2347059 C39.4476129,11.2347059 34.8151356,15.8601961 34.8151356,21.5456863 C34.8151356,23.7170588 35.4843803,25.7943137 36.7504075,27.5529412 C37.3835193,28.4321569 37.1828244,29.657451 36.3020842,30.2896078 C35.9552866,30.5386275 35.554486,30.6582353 35.1576129,30.6584314 C34.5468878,30.6584314 33.9449996,30.374902 33.5612836,29.8419608 C31.8121748,27.4123529 30.8876431,24.5435294 30.8876431,21.5456863 C30.8876431,13.6978431 37.2817972,7.31313725 45.1416915,7.31313725 C53.0013893,7.31313725 59.3957398,13.6978431 59.3957398,21.5456863 C59.3957398,24.5013725 58.4941839,27.337451 56.7884739,29.747451 C56.162628,30.6317647 54.937054,30.8421569 54.0514044,30.2170588 Z" />
        </g>
      </g>
    </svg>
  );
};

export const ExportIcon = () => {
  return (
    <span className="text-color-497ed8">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-box-arrow-up-right"
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
        ></path>
        <path
          fillRule="evenodd"
          d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
        ></path>
      </svg>
    </span>
  );
};

export function AdobeAcrobat() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 46 61"
      width="45px"
      height="50px"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.46c0,.25-.1.49-.28.67l-14.52,14.62c-.18.18-.43.29-.68.29ZM1.93,59.08h28.02l13.96-14.06.16-43.11H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.74,2.54-8.3,8.24-8.3h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.04l-14.52,14.62c-.18.19-.43.29-.69.29ZM37.62,46.38c-4.6,0-6.31,1.73-6.31,6.38v4.94l11.25-11.32h-4.93Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.77"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M14.17,12.53h-1.67v-1.47h1.67v1.47ZM17.54,9.48v3.05h-1.66V4.14h3.33c.95,0,1.7.26,2.26.75.54.49.82,1.13.82,1.94s-.28,1.45-.82,1.94c-.56.47-1.31.71-2.26.71h-1.67ZM17.54,8.18h1.67c.47,0,.8-.11,1.05-.37.24-.25.35-.59.35-.98s-.11-.73-.35-1c-.22-.26-.58-.4-1.05-.4h-1.67v2.74ZM23.51,12.53V4.14h2.86c1.03,0,1.87.34,2.53.99.66.64.99,1.49.99,2.52v1.37c0,1.03-.34,1.88-.99,2.52-.66.66-1.5.98-2.53.98h-2.86ZM25.2,5.44v5.8h1.1c.6,0,1.07-.21,1.4-.6.34-.41.51-.94.51-1.6v-1.39c0-.66-.17-1.19-.51-1.58-.34-.41-.8-.62-1.4-.62h-1.1ZM36.37,9.05h-3.5v3.48h-1.67V4.14h5.75v1.3h-4.08v2.31h3.5v1.3Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.94,37.16c-.94,0-2.08.13-3.41.38-1.85-2-3.78-4.87-5.15-7.71,1.35-5.74.67-6.55.37-6.92-.32-.41-.77-1.07-1.27-1.07-.22,0-.8.09-1.03.17-.6.21-.9.66-1.16,1.24-.71,1.69.28,4.55,1.27,6.77-.86,3.46-2.3,7.58-3.84,10.95-3.84,1.77-5.88,3.5-6.05,5.15-.07.6.08,1.49,1.12,2.28.28.23.62.34.97.34.9,0,1.78-.68,2.82-2.15.75-1.07,1.57-2.52,2.41-4.33,2.71-1.19,6.06-2.28,8.95-2.88,1.59,1.54,3.03,2.33,4.27,2.33.9,0,1.68-.41,2.25-1.22.58-.81.71-1.56.39-2.18-.39-.77-1.35-1.15-2.94-1.15h0ZM12.81,47.02c-.47-.38-.45-.62-.43-.71.06-.56.94-1.56,3.11-2.79-1.65,3.05-2.53,3.44-2.68,3.5h0ZM21.12,23.67c.06-.02,1.07,1.13.11,3.27-1.46-1.49-.21-3.24-.11-3.27h0ZM19.04,39.98c1.01-2.45,1.98-5.17,2.7-7.7,1.14,2.05,2.51,4.04,3.87,5.64-2.15.51-4.45,1.24-6.57,2.05h0ZM32.1,39.51c-.32.43-.99.43-1.23.43-.54,0-.73-.32-1.55-.96.67-.07,1.31-.09,1.83-.09.9,0,1.05.13,1.18.19-.02.07-.08.21-.22.43h0Z"
      />
    </svg>
  );
}

export function Pngicon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-3"
        fill="#00b3e8"
        d="M30.34,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.6c-.18.18-.43.28-.69.28ZM1.93,59.08h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-3"
        fill="#00b3e8"
        d="M30.34,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.73,2.54-8.28,8.25-8.28h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.04l-14.52,14.6c-.19.19-.43.28-.69.28ZM37.63,46.4c-4.61,0-6.32,1.72-6.32,6.36v4.95l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-3"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.77"
        fill="#00b3e8"
      />
      <path
        className="cls-2"
        fill="#fefefe"
        d="M12.57,12.53h-1.67v-1.47h1.67v1.47ZM15.79,9.69v2.84h-1.57v-7.83h3.11c.9,0,1.59.23,2.11.7.51.45.77,1.05.77,1.81s-.26,1.35-.77,1.81c-.53.45-1.22.68-2.11.68h-1.53ZM15.79,8.49h1.53c.43,0,.77-.11.99-.36.22-.24.34-.55.34-.9,0-.38-.11-.7-.34-.94-.22-.24-.56-.36-.99-.36h-1.53v2.56ZM27.65,12.53h-1.55l-3.15-5.34h-.04v5.34h-1.57v-7.83h1.57l3.14,5.34h.04v-5.34h1.55v7.83ZM35.1,11.46c-.24.32-.6.58-1.08.83-.49.24-1.12.36-1.87.36-.93,0-1.72-.28-2.32-.88-.6-.6-.92-1.37-.92-2.31v-1.64c0-.94.3-1.71.88-2.31.58-.6,1.33-.9,2.24-.9s1.67.24,2.17.7c.51.47.77,1.07.77,1.84v.02h-1.48c-.02-.41-.15-.73-.39-.98-.24-.24-.58-.36-1.03-.36-.49,0-.86.19-1.16.55-.3.38-.43.85-.43,1.43v1.66c0,.58.15,1.07.45,1.43.3.38.71.56,1.22.56.38,0,.66-.04.88-.11.23-.08.39-.17.51-.28v-1.43h-1.38v-1.09h2.96v2.94Z"
      />
      <path
        className="cls-1"
        fill="#00b3e8"
        d="M11.52,19.34h3.27v3.29h3.27v-3.29h3.29v3.29h3.27v-3.29h3.27v3.29h3.3v-3.29h3.28v3.29h-3.28v3.29h3.28v3.31h-3.28v3.29h3.28v3.29h-3.28v3.31h3.28v3.29h-3.28v-3.29h-3.3v3.29h-3.27v-3.29h-3.27v3.29h-3.29v-3.29h-3.27v3.29h-3.27v-3.29h3.27v-3.31h-3.27v-3.29h3.27v-3.29h-3.27v-3.31h3.27v-3.29h-3.27v-3.29ZM24.64,22.64v3.29h3.27v-3.29h-3.27ZM27.91,25.93v3.31h3.3v-3.31h-3.3ZM18.07,22.64v3.29h3.29v-3.29h-3.29ZM21.36,25.93v3.31h3.27v-3.31h-3.27ZM24.64,29.24v3.29h3.27v-3.29h-3.27ZM27.91,32.53v3.29h3.3v-3.29h-3.3ZM21.36,39.14v-3.31h-3.29v3.31h3.29ZM18.07,35.83v-3.29h-3.27v3.29h3.27ZM27.91,39.14v-3.31h-3.27v3.31h3.27ZM24.64,35.83v-3.29h-3.27v3.29h3.27ZM21.36,32.53v-3.29h-3.29v3.29h3.29ZM18.07,29.24v-3.31h-3.27v3.31h3.27Z"
      />
    </svg>
  );
}

export function Jpgicon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.42.28.68l-.17,44.46c0,.25-.1.49-.28.67l-14.52,14.62c-.18.18-.43.28-.69.28ZM1.93,59.08h28.01l13.96-14.06.16-43.11H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.74,2.54-8.3,8.24-8.3h7.24c.39,0,.74.23.89.59.15.36.07.77-.21,1.05l-14.52,14.62c-.18.19-.43.28-.69.28ZM37.63,46.38c-4.6,0-6.32,1.73-6.32,6.38v4.95l11.25-11.32h-4.93Z"
      />
      <rect
        className="cls-2"
        x="1.06"
        y=".96"
        width="43.88"
        height="14.77"
        fill="#00b3e8"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M13.32,12.53h-1.67v-1.47h1.67v1.47ZM18.24,4.7h1.55v5.47c0,.75-.24,1.35-.73,1.81-.5.43-1.12.66-1.87.66-.8,0-1.46-.21-1.93-.6-.47-.4-.69-.98-.69-1.75l.02-.04h1.52c0,.41.09.71.3.9.19.19.47.28.79.28.3,0,.54-.11.75-.34.19-.23.3-.53.3-.92v-5.47ZM22.79,9.69v2.84h-1.57v-7.83h3.11c.9,0,1.61.22,2.12.68.52.47.77,1.07.77,1.83s-.24,1.35-.77,1.81c-.51.45-1.22.68-2.12.68h-1.53ZM22.79,8.49h1.53c.45,0,.77-.13.99-.36.22-.24.34-.55.34-.92s-.11-.68-.34-.92c-.22-.25-.54-.38-.99-.38h-1.53v2.58ZM34.35,11.46c-.24.32-.6.58-1.09.83-.51.24-1.12.36-1.87.36-.95,0-1.72-.3-2.32-.88-.62-.6-.92-1.37-.92-2.33v-1.62c0-.96.3-1.73.88-2.32.58-.6,1.33-.9,2.23-.9.95,0,1.68.22,2.19.7.5.47.77,1.07.77,1.83v.04h-1.48c-.04-.41-.17-.73-.39-.98-.24-.25-.58-.38-1.03-.38-.49,0-.86.19-1.16.56-.3.38-.43.85-.43,1.43v1.64c0,.6.15,1.07.45,1.45.3.38.71.56,1.22.56.37,0,.66-.04.88-.11.23-.08.39-.17.51-.28v-1.45h-1.39v-1.09h2.96v2.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M8.75,28.6c-2.5,0-4.54-2.05-4.54-4.57s2.04-4.55,4.54-4.55,4.56,2.04,4.56,4.55-2.04,4.57-4.56,4.57ZM8.75,21.39c-1.44,0-2.61,1.18-2.61,2.63s1.17,2.65,2.61,2.65,2.63-1.19,2.63-2.65-1.18-2.63-2.63-2.63Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M40.69,42.02H5.31c-.37,0-.71-.21-.87-.55-.16-.33-.11-.73.13-1.02l11.73-14.19c.33-.4.9-.47,1.32-.16l4.84,3.55,10.1-8.82c.19-.17.45-.26.71-.24.26.02.5.14.67.34l7.49,8.9c.14.17.22.39.22.62l.02,10.61c0,.26-.1.5-.28.68-.18.18-.43.28-.68.28ZM7.35,40.1h32.38l-.02-9.31-6.63-7.88-9.94,8.69c-.34.3-.84.32-1.21.05l-4.73-3.47-9.85,11.92Z"
      />
    </svg>
  );
}

export function Jpegicon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <rect
        className="cls-4"
        fill="#fff"
        x="-608.77"
        y="-324.89"
        width="512"
        height="512"
      />
      <rect
        className="cls-3"
        fill="#00b3e8"
        x="-608.77"
        y="-324.89"
        width="147"
        height="512"
      />
      <g>
        <text
          className="cls-7"
          fill="#fff"
          transform="translate(-575.77 -149.98)"
        >
          <tspan x="0" y="0">
            FREE
          </tspan>
        </text>
        <text
          className="cls-7"
          fill="#fff"
          transform="translate(-575.77 -103.96)"
        >
          <tspan x="0" y="0">
            FILE{" "}
          </tspan>
        </text>
        <text
          className="cls-7"
          fill="#fff"
          transform="translate(-575.77 -57.95)"
        >
          <tspan x="0" y="0">
            T
          </tspan>
        </text>
        <text
          className="cls-7"
          fill="#fff"
          transform="translate(-552.76 -57.95)"
        >
          <tspan x="0" y="0">
            YPE
          </tspan>
        </text>
        <text
          className="cls-7"
          fill="#fff"
          transform="translate(-575.77 -11.93)"
        >
          <tspan x="0" y="0">
            ICON
          </tspan>
        </text>
        <text
          className="cls-7"
          fill="#fff"
          transform="translate(-575.77 34.08)"
        >
          <tspan x="0" y="0">
            S
          </tspan>
        </text>
        <text
          className="cls-7"
          fill="#fff"
          transform="translate(-552.72 34.08)"
        >
          <tspan x="0" y="0">
            E
          </tspan>
        </text>
        <text
          className="cls-7"
          fill="#fff"
          transform="translate(-530.25 34.08)"
        >
          <tspan x="0" y="0">
            T
          </tspan>
        </text>
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-152.86,155.25h-29.34c-.53,0-.96-.43-.96-.96v-59.26c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.61c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.69.29ZM-181.24,153.32h27.98l13.94-14.08.16-43.25h-42.09v57.33Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-152.86,155.25c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.29c0-5.76,2.54-8.32,8.23-8.32h7.23c.39,0,.74.23.89.59s.07.77-.2,1.05l-14.5,14.65c-.19.19-.43.29-.69.29ZM-145.59,140.6c-4.6,0-6.31,1.73-6.31,6.4v4.95l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-182.11"
          y="95.03"
          width="43.83"
          height="14.8"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-169.01,106.64h-1.66v-1.49h1.66v1.49ZM-167.31,106.64v-8.42h2.86c1.03,0,1.85.34,2.52.98.65.66.99,1.51.99,2.53v1.4c0,1.04-.34,1.87-.99,2.53-.67.64-1.5.98-2.52.98h-2.86ZM-165.64,99.53v5.81h1.1c.62,0,1.08-.21,1.42-.62.34-.39.51-.92.51-1.58v-1.4c0-.66-.17-1.19-.51-1.61-.34-.4-.8-.6-1.42-.6h-1.1ZM-152.93,103.19c0,1.04-.32,1.89-.97,2.57-.64.66-1.48,1-2.5,1s-1.87-.34-2.5-1c-.64-.68-.97-1.53-.97-2.57v-1.51c0-1.04.32-1.89.97-2.55.64-.68,1.46-1.02,2.49-1.02s1.89.34,2.52,1.02c.65.66.97,1.51.97,2.55v1.51ZM-154.6,101.66c0-.66-.17-1.19-.49-1.62-.32-.41-.77-.62-1.34-.62s-1.01.21-1.33.62c-.3.42-.47.96-.47,1.62v1.53c0,.66.17,1.21.49,1.64.32.41.75.62,1.33.62s1.01-.21,1.33-.62c.32-.43.49-.98.49-1.64v-1.53ZM-145.35,103.77l.02.04c.02.91-.26,1.62-.82,2.15-.56.53-1.35.79-2.34.79s-1.83-.32-2.45-.98c-.62-.64-.93-1.47-.93-2.51v-1.66c0-1.02.3-1.85.91-2.51.62-.66,1.4-.98,2.37-.98,1.03,0,1.83.27,2.41.79.58.55.86,1.27.86,2.19l-.02.04h-1.63c0-.57-.13-.98-.39-1.28-.26-.28-.67-.43-1.23-.43-.5,0-.9.21-1.18.6-.3.41-.45.94-.45,1.57v1.68c0,.64.15,1.17.47,1.59.3.39.73.61,1.25.61s.9-.13,1.16-.42c.24-.28.37-.71.37-1.26h1.61Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-145.53,120.06h-29.34c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.34c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-145.53,126.86h-29.34c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.34c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-145.53,133.65h-29.34c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.34c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-160.2,140.43h-14.67c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h14.67c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-231.77,155.27h-29.34c-.53,0-.96-.43-.96-.96v-59.28c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.61c0,.25-.1.49-.28.67l-14.5,14.67c-.18.18-.43.29-.68.29ZM-260.15,153.34h27.98l13.94-14.1.16-43.25h-42.09v57.35Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-231.77,155.27c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.3c0-5.76,2.54-8.33,8.23-8.33h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.67c-.18.19-.43.29-.68.29ZM-224.5,140.6c-4.6,0-6.31,1.73-6.31,6.4v4.96l11.23-11.36h-4.93Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-261.02"
          y="95.03"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-247.92,106.64h-1.66v-1.47h1.66v1.47ZM-244.55,103.58v3.06h-1.66v-8.42h3.33c.95,0,1.7.26,2.26.75.54.49.82,1.13.82,1.95s-.28,1.45-.82,1.94c-.56.47-1.31.72-2.26.72h-1.66ZM-244.55,102.28h1.66c.47,0,.8-.11,1.05-.38.24-.25.35-.59.35-.98s-.11-.74-.35-1c-.22-.27-.58-.4-1.05-.4h-1.66v2.75ZM-238.59,106.64v-8.42h2.86c1.03,0,1.87.34,2.52,1,.65.64.99,1.49.99,2.53v1.38c0,1.04-.34,1.89-.99,2.53-.65.66-1.5.98-2.52.98h-2.86ZM-236.91,99.53v5.81h1.1c.6,0,1.06-.21,1.4-.61.34-.41.5-.94.5-1.6v-1.4c0-.66-.17-1.19-.5-1.59-.34-.42-.8-.62-1.4-.62h-1.1ZM-225.75,103.15h-3.5v3.49h-1.66v-8.42h5.74v1.3h-4.08v2.32h3.5v1.3Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-231.17,131.35c-.93,0-2.07.13-3.4.38-1.85-2-3.78-4.89-5.14-7.74,1.35-5.76.67-6.57.37-6.95-.32-.41-.77-1.08-1.27-1.08-.22,0-.8.09-1.03.17-.6.21-.9.66-1.16,1.25-.71,1.7.28,4.57,1.27,6.8-.86,3.47-2.3,7.61-3.83,10.99-3.83,1.77-5.87,3.51-6.04,5.17-.07.6.08,1.49,1.12,2.28.28.23.62.34.97.34.9,0,1.78-.68,2.82-2.15.75-1.08,1.57-2.53,2.41-4.34,2.71-1.19,6.06-2.28,8.93-2.89,1.59,1.55,3.03,2.34,4.26,2.34.9,0,1.68-.42,2.24-1.23.58-.81.71-1.57.39-2.19-.39-.77-1.35-1.15-2.93-1.15h0ZM-249.28,141.24c-.47-.38-.45-.62-.43-.72.06-.57.94-1.57,3.1-2.79-1.64,3.06-2.52,3.45-2.67,3.51h0ZM-240.98,117.82c.06-.02,1.07,1.13.11,3.29-1.46-1.49-.21-3.25-.11-3.29h0ZM-243.06,134.18c1.01-2.45,1.98-5.19,2.69-7.72,1.14,2.06,2.5,4.06,3.87,5.66-2.15.51-4.45,1.25-6.56,2.06h0ZM-230.01,133.71c-.32.44-.99.44-1.23.44-.54,0-.73-.32-1.55-.96.67-.07,1.31-.09,1.83-.09.9,0,1.05.13,1.18.19-.02.07-.08.21-.22.43h0Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-310.67,155.27h-29.34c-.53,0-.96-.43-.96-.96v-59.28c0-.53.43-.96.96-.96h44.01c.26,0,.5.1.68.28s.28.43.28.68l-.17,44.63c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-339.05,153.34h27.98l13.94-14.08.16-43.27h-42.09v57.35Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-310.67,155.27c-.12,0-.25-.03-.37-.07-.36-.15-.6-.5-.6-.89v-7.31c0-5.74,2.54-8.3,8.23-8.3h7.23c.39,0,.74.23.89.59.15.36.07.77-.21,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-303.4,140.62c-4.6,0-6.31,1.73-6.31,6.38v4.96l11.23-11.34h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-339.92"
          y="95.03"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-332.28,106.66h-1.66v-1.49h1.66v1.49ZM-324.36,106.66h-1.55v-3.27h-3.18v3.27h-1.55v-7.87h1.55v3.38h3.18v-3.38h1.55v7.87ZM-317.51,100.01h-2.21v6.65h-1.55v-6.65h-2.21v-1.22h5.96v1.22ZM-314.62,98.79l2,5.79h.02l2-5.79h2.04v7.87h-1.55v-2.36l.15-3.46-.04-.02-2.07,5.83h-1.05l-2.07-5.82-.04.02.15,3.44v2.36h-1.57v-7.87h2.04ZM-305.53,105.43h3.46v1.23h-5.03v-7.87h1.57v6.64Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-323.85,135.18c-.32,0-.63-.12-.88-.35l-7.28-6.9s-.02-.02-.03-.03c-.11-.11-.19-.23-.26-.36-.08-.18-.12-.37-.12-.55,0-.19.04-.37.12-.54.06-.13.15-.26.26-.36,0,0,.02-.02.03-.03l7.28-6.92c.51-.49,1.33-.47,1.82.05.49.51.47,1.33-.05,1.81l-6.31,5.99,6.31,5.98c.52.49.54,1.3.05,1.81-.25.27-.59.4-.93.4ZM-312.19,135.18c-.34,0-.68-.13-.93-.4-.49-.52-.46-1.33.05-1.81l6.32-5.98-6.32-5.99c-.52-.49-.54-1.3-.05-1.81.49-.52,1.3-.54,1.81-.05l7.3,6.92s.02.02.03.04c.1.11.19.22.25.35h0c.08.18.12.37.12.56s-.04.38-.13.55c-.06.13-.14.25-.25.35-.01,0-.02.02-.04.03l-7.3,6.9c-.25.23-.56.35-.88.35Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-389.58,155.25h-29.34c-.53,0-.96-.43-.96-.96v-59.26c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.61c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-417.96,153.32h27.98l13.94-14.08.16-43.25h-42.09v57.33Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-389.58,155.25c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.29c0-5.76,2.54-8.33,8.23-8.33h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-382.31,140.6c-4.6,0-6.31,1.73-6.31,6.4v4.95l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-418.83"
          y="95.03"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-407.47,106.64h-1.68v-1.47h1.68v1.47ZM-399.49,103.77v.04c.02.91-.26,1.62-.82,2.15-.56.53-1.35.79-2.34.79s-1.81-.32-2.45-.98c-.62-.64-.93-1.47-.93-2.51v-1.66c0-1.02.3-1.85.92-2.51.62-.66,1.4-.98,2.37-.98,1.03,0,1.83.27,2.41.79.58.55.88,1.27.86,2.19l-.02.04h-1.63c0-.57-.13-.98-.39-1.28-.26-.28-.67-.43-1.23-.43-.49,0-.9.21-1.18.6-.3.41-.45.94-.45,1.57v1.68c0,.64.15,1.17.47,1.59.3.39.73.61,1.25.61s.92-.13,1.16-.42c.24-.28.37-.71.37-1.26h1.63ZM-393.81,104.45c0-.34-.11-.59-.34-.79-.22-.19-.62-.38-1.2-.55-.99-.28-1.74-.62-2.24-1.02-.51-.39-.77-.94-.77-1.64s.3-1.25.88-1.68c.58-.44,1.33-.66,2.22-.66s1.66.25,2.24.74c.58.49.86,1.1.84,1.81l-.02.04h-1.63c0-.38-.13-.7-.37-.93-.26-.24-.62-.36-1.08-.36s-.8.09-1.05.3c-.24.19-.36.45-.36.76,0,.28.13.51.39.7.26.19.71.38,1.35.57.91.26,1.61.6,2.09,1.04.47.42.71.96.71,1.66s-.28,1.29-.84,1.7c-.58.42-1.31.62-2.24.62s-1.7-.23-2.37-.7c-.67-.47-.99-1.13-.97-1.98v-.04h1.63c0,.49.15.87.47,1.1.3.23.71.34,1.25.34.47,0,.8-.09,1.05-.26.24-.21.35-.46.35-.76h0ZM-386.37,104.45c0-.34-.11-.59-.34-.79-.22-.19-.64-.38-1.2-.55-.99-.28-1.74-.62-2.24-1.02-.51-.39-.77-.94-.77-1.64s.3-1.25.88-1.68c.58-.44,1.31-.66,2.22-.66s1.66.25,2.22.74c.58.49.86,1.1.84,1.81v.04h-1.63c0-.38-.13-.7-.39-.93-.24-.24-.62-.36-1.08-.36s-.78.09-1.03.3c-.24.19-.37.45-.37.76,0,.28.13.51.39.7.26.19.71.38,1.36.57.92.26,1.61.6,2.07,1.04.49.42.71.96.71,1.66s-.28,1.29-.84,1.7c-.56.42-1.31.62-2.22.62s-1.7-.23-2.37-.7c-.67-.47-1.01-1.13-.99-1.98l.02-.04h1.63c0,.49.15.87.45,1.1.3.23.73.34,1.27.34.45,0,.8-.09,1.05-.26.24-.21.35-.46.35-.76h0Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-391.84,135.97c-.53,0-.96-.43-.96-.96s.43-.96.96-.96c.7,0,1.36,0,1.59-.23.12-.12.31-.46.3-1.48l-.06-2.87c-.08-2.15.66-3.38,1.28-4.03.04-.04.07-.07.11-.11-.04-.03-.07-.07-.11-.11-.63-.65-1.36-1.88-1.28-4.04l.06-2.89c0-.99-.19-1.34-.3-1.45-.23-.23-.9-.23-1.6-.23-.53,0-.96-.43-.96-.96s.43-.96.96-.96c1.07,0,2.17,0,2.96.8.6.6.87,1.5.86,2.83l-.04,2.18s0,0,0,.01l-.02.73c-.04,1.17.22,2.11.75,2.64.31.32.69.48,1.13.48.53,0,.96.43.96.96s-.43.96-.96.96c-.44,0-.82.16-1.13.48-.52.54-.79,1.47-.75,2.64l.02.74s0,0,0,0h0l.04,2.15c0,1.35-.26,2.26-.86,2.86-.8.8-1.9.8-2.96.8ZM-402.01,135.97c-1.06,0-2.16,0-2.96-.8-.6-.61-.87-1.51-.85-2.85l.02-2.14s0-.02,0-.03c0,0,0-.02,0-.03l.04-.73c.04-1.14-.22-2.08-.74-2.62-.31-.32-.7-.49-1.15-.49-.53,0-.96-.43-.96-.96s.43-.96.96-.96c.45,0,.84-.16,1.15-.49.52-.54.78-1.47.74-2.63l-.04-.71s0-.02,0-.03,0-.02,0-.03l-.02-2.16c-.02-1.32.25-2.22.84-2.83.8-.8,1.9-.8,2.96-.8.53,0,.96.43.96.96s-.43.96-.96.96c-.7,0-1.36,0-1.59.23-.11.12-.3.46-.29,1.45l.06,2.87c.08,2.17-.66,3.4-1.28,4.05-.04.04-.08.08-.12.11.04.04.08.08.12.12.63.65,1.36,1.88,1.28,4.04l-.04.73-.02,2.13c-.01,1.01.18,1.36.29,1.47.23.23.89.23,1.58.23.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-152.86,61.1h-29.34c-.53,0-.96-.43-.96-.96V.86c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.63c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.28-.69.28ZM-181.24,59.18h27.98l13.94-14.08.16-43.27h-42.09v57.35Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-152.86,61.1c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.31c0-5.74,2.54-8.3,8.23-8.3h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.19.19-.43.28-.69.28ZM-145.59,46.45c-4.6,0-6.31,1.73-6.31,6.38v4.96l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-182.11"
          y=".86"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-164.84,12.47h-1.68v-1.47h1.68v1.47ZM-158.69,10.66h-2.92l-.56,1.81h-1.7l2.88-8.4h1.7l2.86,8.4h-1.68l-.58-1.81ZM-161.19,9.38h2.09l-1.03-3.34h-.04l-1.03,3.34ZM-153.89,12.47h-1.66V4.07h1.66v8.4Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-144.24,29.63v-5.7h-5.63v1.91h-5.62v-3.79h-9.4v3.79h-5.62v-1.91h-5.64v5.7h5.64v-1.91h3.33c-4.3,2.51-7.08,7.2-7.08,12.33,0,.53.41.96.93.96s.93-.43.93-.96c0-4.96,3.03-9.48,7.51-11.37v2.83h9.4v-2.83c4.47,1.89,7.51,6.4,7.51,11.37,0,.53.41.96.93.96s.93-.43.93-.96c0-5.13-2.8-9.82-7.08-12.33h3.33v1.91h5.63ZM-172.41,27.72h-1.87v-1.89h1.87v1.89ZM-157.38,29.63h-5.63v-5.7h5.63v5.7ZM-147.98,25.84h1.87v1.89h-1.87v-1.89Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-231.77,61.1h-29.34c-.53,0-.96-.43-.96-.96V.86c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.62c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-260.15,59.18h27.98l13.94-14.08.16-43.27h-42.09v57.35Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-231.77,61.1c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.3c0-5.74,2.54-8.3,8.23-8.3h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-224.5,46.45c-4.6,0-6.31,1.73-6.31,6.38v4.96l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-261.02"
          y=".86"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-248.42,12.49h-1.66v-1.49h1.66v1.49ZM-244.03,7.41l1.46-2.79h1.81l-2.3,3.91,2.43,3.96h-1.89l-1.5-2.83-1.49,2.83h-1.83l2.37-3.96-2.32-3.91h1.81l1.44,2.79ZM-238.25,11.26h3.46v1.23h-5.01v-7.87h1.55v6.64ZM-229.69,10.43c0-.3-.11-.55-.32-.72-.2-.19-.58-.36-1.1-.53-.94-.26-1.65-.59-2.11-.96-.47-.36-.71-.87-.71-1.51s.28-1.17.82-1.59c.54-.41,1.23-.6,2.08-.6s1.55.23,2.09.68c.54.45.8,1.02.79,1.7l-.02.04h-1.51c0-.36-.11-.66-.35-.87-.24-.23-.58-.34-1.01-.34s-.75.1-.97.28c-.22.19-.34.42-.34.7,0,.26.11.49.35.66.24.17.67.34,1.27.53.86.25,1.51.57,1.94.96.45.4.67.9.67,1.55,0,.68-.26,1.21-.8,1.61-.52.38-1.22.58-2.07.58s-1.59-.23-2.22-.68c-.62-.43-.93-1.05-.92-1.85l.02-.02h1.51c0,.46.15.81.43,1.02.28.22.67.32,1.18.32.43,0,.75-.08.97-.27.22-.17.34-.4.34-.7h0Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-221.32,28.49h-35.59c-.44,0-.8-.36-.8-.8v-5.61c0-.44.36-.8.8-.8h35.59c.44,0,.8.36.8.8v5.61c0,.44-.36.8-.8.8ZM-256.1,26.88h33.98v-4h-33.98v4Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-221.32,34.12h-35.59c-.44,0-.8-.36-.8-.8v-5.63c0-.44.36-.8.8-.8h35.59c.44,0,.8.36.8.8v5.63c0,.44-.36.8-.8.8ZM-256.1,32.51h33.98v-4.02h-33.98v4.02Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-221.32,39.74h-35.59c-.44,0-.8-.36-.8-.8v-5.62c0-.44.36-.8.8-.8h35.59c.44,0,.8.36.8.8v5.62c0,.44-.36.8-.8.8ZM-256.1,38.14h33.98v-4.02h-33.98v4.02Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-232.27,39.74h-13.68c-.44,0-.8-.36-.8-.8v-16.86c0-.44.36-.8.8-.8h13.68c.44,0,.8.36.8.8v16.86c0,.44-.36.8-.8.8ZM-245.15,38.14h12.08v-15.25h-12.08v15.25Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-310.67,61.1h-29.34c-.53,0-.96-.43-.96-.96V.86c0-.53.43-.96.96-.96h44.01c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.61c0,.25-.1.5-.28.67l-14.5,14.67c-.18.18-.43.29-.68.29ZM-339.05,59.18h27.98l13.95-14.1.16-43.25h-42.09v57.35Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-310.67,61.1c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.3c0-5.76,2.54-8.32,8.23-8.32h7.23c.39,0,.74.23.89.59.15.36.07.77-.21,1.05l-14.5,14.67c-.18.19-.43.29-.68.29ZM-303.4,46.43c-4.6,0-6.31,1.73-6.31,6.4v4.96l11.23-11.36h-4.93Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-339.92"
          y=".86"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-327.68,12.47h-1.66v-1.47h1.66v1.47ZM-322.77,4.62h1.55v5.49c0,.75-.24,1.36-.73,1.81-.5.43-1.12.66-1.87.66-.8,0-1.46-.21-1.93-.6-.47-.4-.69-.98-.69-1.75l.02-.04h1.51c0,.42.09.72.3.91.19.19.47.28.79.28.3,0,.54-.11.75-.34.19-.23.3-.53.3-.93v-5.49ZM-318.22,9.62v2.85h-1.57v-7.85h3.1c.9,0,1.61.22,2.11.68.52.47.77,1.08.77,1.83s-.24,1.36-.77,1.81c-.5.45-1.21.68-2.11.68h-1.53ZM-318.22,8.41h1.53c.45,0,.77-.13.99-.36.22-.24.34-.55.34-.93s-.11-.68-.34-.92c-.22-.25-.54-.38-.99-.38h-1.53v2.59ZM-306.67,11.4c-.24.32-.6.58-1.08.83-.5.24-1.12.36-1.87.36-.95,0-1.72-.3-2.32-.89-.62-.6-.92-1.38-.92-2.34v-1.62c0-.96.3-1.74.88-2.32.58-.6,1.33-.9,2.22-.9.95,0,1.68.22,2.19.7.5.47.77,1.08.77,1.83v.04h-1.48c-.04-.42-.17-.74-.39-.98-.24-.25-.58-.38-1.03-.38-.49,0-.86.19-1.16.56-.3.38-.43.85-.43,1.43v1.64c0,.6.15,1.08.45,1.45.3.38.71.57,1.21.57.37,0,.65-.04.88-.11.23-.08.39-.17.51-.28v-1.45h-1.38v-1.1h2.95v2.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-332.24,28.59c-2.5,0-4.53-2.06-4.53-4.59s2.03-4.57,4.53-4.57,4.55,2.05,4.55,4.57-2.04,4.59-4.55,4.59ZM-332.24,21.36c-1.44,0-2.61,1.19-2.61,2.64s1.17,2.66,2.61,2.66,2.63-1.2,2.63-2.66-1.18-2.64-2.63-2.64Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-300.34,42.05h-35.34c-.37,0-.71-.21-.87-.55-.16-.34-.11-.73.13-1.02l11.72-14.23c.33-.4.9-.47,1.31-.16l4.83,3.56,10.09-8.85c.19-.17.45-.26.71-.24.26.02.5.14.66.34l7.48,8.93c.14.17.22.39.22.62l.02,10.65c0,.26-.1.5-.28.68-.18.18-.42.28-.68.28ZM-333.64,40.13h32.34l-.02-9.34-6.62-7.91-9.93,8.71c-.34.3-.84.32-1.21.05l-4.72-3.48-9.84,11.96Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M30.35,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.42.28.68l-.17,44.46c0,.25-.1.49-.28.67l-14.52,14.62c-.18.18-.43.28-.69.28ZM1.93,59.08h28.01l13.96-14.06.16-43.11H1.93v57.16Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M30.34,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.74,2.54-8.3,8.24-8.3h7.24c.39,0,.74.23.89.59.15.36.07.77-.21,1.05l-14.52,14.62c-.18.19-.43.28-.69.28ZM37.62,46.38c-4.6,0-6.32,1.73-6.32,6.38v4.95l11.25-11.32h-4.93Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="1.06"
          y=".96"
          width="43.88"
          height="14.77"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M8.74,28.6c-2.5,0-4.54-2.05-4.54-4.57s2.04-4.55,4.54-4.55,4.56,2.04,4.56,4.55-2.04,4.57-4.56,4.57ZM8.74,21.39c-1.44,0-2.61,1.18-2.61,2.63s1.17,2.65,2.61,2.65,2.63-1.19,2.63-2.65-1.18-2.63-2.63-2.63Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M40.68,42.02H5.3c-.37,0-.71-.21-.87-.55-.16-.33-.11-.73.13-1.02l11.73-14.19c.33-.4.9-.47,1.32-.16l4.84,3.55,10.1-8.82c.19-.17.45-.26.71-.24.26.02.5.14.67.34l7.49,8.9c.14.17.22.39.22.62l.02,10.61c0,.26-.1.5-.28.68-.18.18-.43.28-.68.28ZM7.34,40.1h32.38l-.02-9.31-6.63-7.88-9.94,8.69c-.34.3-.84.32-1.21.05l-4.73-3.47-9.85,11.92Z"
        />
        <text
          className="cls-5"
          fill="#fefefe"
          transform="translate(6.78 12.36)"
        >
          <tspan x="0" y="0">
            .JPEG
          </tspan>
        </text>
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-389.58,61.1h-29.34c-.53,0-.96-.43-.96-.96V.86c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.62c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-417.96,59.18h27.98l13.94-14.08.16-43.27h-42.09v57.35Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-389.58,61.1c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.3c0-5.74,2.54-8.3,8.23-8.3h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-382.31,46.45c-4.6,0-6.31,1.73-6.31,6.38v4.96l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-418.83"
          y=".86"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-406.72,12.47h-1.66v-1.47h1.66v1.47ZM-403.53,9.62v2.85h-1.55v-7.85h3.1c.88,0,1.59.22,2.11.7.5.45.77,1.06.77,1.81s-.26,1.36-.77,1.81c-.52.45-1.23.68-2.11.68h-1.55ZM-403.53,8.41h1.55c.43,0,.75-.11.97-.36.22-.24.34-.55.34-.91,0-.38-.11-.7-.32-.94-.22-.25-.56-.36-.99-.36h-1.55v2.57ZM-396.39,9.62v2.85h-1.57v-7.85h3.1c.9,0,1.59.22,2.11.7.5.45.77,1.06.77,1.81s-.26,1.36-.77,1.81c-.52.45-1.22.68-2.11.68h-1.53ZM-396.39,8.41h1.53c.43,0,.77-.11.99-.36.22-.24.34-.55.34-.91,0-.38-.11-.7-.34-.94-.22-.25-.56-.36-.99-.36h-1.53v2.57ZM-385.45,5.85h-2.21v6.62h-1.55v-6.62h-2.19v-1.23h5.94v1.23Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-389.47,45.9c-.34,0-.66-.18-.84-.49l-3.35-5.97c-.26-.46-.09-1.05.37-1.31.46-.26,1.05-.1,1.31.37l3.35,5.97c.26.46.1,1.05-.37,1.31-.15.08-.31.12-.47.12ZM-404.37,45.9c-.16,0-.32-.04-.47-.12-.46-.26-.63-.85-.37-1.31l3.35-5.97c.26-.46.85-.63,1.31-.37.46.26.63.85.37,1.31l-3.35,5.97c-.18.31-.5.49-.84.49Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-396.91,22.99c-.53,0-.96-.43-.96-.96v-2.06c0-.53.43-.96.96-.96s.96.43.96.96v2.06c0,.53-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-381.38,39.94h-31.08c-.53,0-.96-.43-.96-.96v-16.95c0-.53.43-.96.96-.96h31.08c.53,0,.96.43.96.96v16.95c0,.53-.43.96-.96.96ZM-411.5,38.01h29.16v-15.03h-29.16v15.03Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-385.45,35.63c-.53,0-.96-.43-.96-.96v-8.21c0-.53.43-.96.96-.96s.96.43.96.96v8.21c0,.53-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-388.54,35.63c-.53,0-.96-.43-.96-.96l-.02-4.81c0-.53.43-.96.96-.97h0c.53,0,.96.43.96.96l.02,4.81c0,.53-.43.96-.96.97h0Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-391.64,35.63c-.53,0-.96-.43-.96-.96v-2.42c0-.53.43-.96.96-.96s.96.43.96.96v2.42c0,.53-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-398.98,27.42h-9.46c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h9.46c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-402.67,31.54h-5.77c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h5.77c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-396.76,35.63h-11.68c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h11.68c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-152.86-33.09h-29.34c-.53,0-.96-.43-.96-.96v-59.25c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.61c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.28-.69.28ZM-181.24-35.01h27.98l13.94-14.08.16-43.25h-42.09v57.33Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-152.86-33.09c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.29c0-5.76,2.54-8.33,8.23-8.33h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.19.19-.43.28-.69.28ZM-145.59-47.74c-4.6,0-6.31,1.74-6.31,6.4v4.95l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-182.11"
          y="-93.31"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-171.17-81.98h-1.55v-1.38h1.55v1.38ZM-167.55-89.83l1.98,5.8h.02l2-5.8h2.04v7.85h-1.55v-2.34l.15-3.47h-.04l-2.08,5.81h-1.05l-2.07-5.8h-.04l.15,3.45v2.34h-1.55v-7.85h2.04ZM-158.48-84.83v2.85h-1.57v-7.85h3.1c.9,0,1.61.23,2.11.7.52.45.77,1.06.77,1.81s-.24,1.36-.77,1.81c-.5.45-1.22.68-2.11.68h-1.53ZM-158.48-86.04h1.53c.45,0,.77-.13.99-.36.22-.25.34-.55.34-.93s-.11-.68-.34-.92c-.22-.25-.54-.38-.99-.38h-1.53v2.59ZM-148.54-84.89h.88v1.21h-.88v1.7h-1.55v-1.7h-3.18l-.07-.94,3.23-5.21h1.57v4.95ZM-151.89-84.89h1.79v-2.85h-.04l-.13.23-1.62,2.62Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-160.2-47.63c-7.84,0-14.22-6.44-14.22-14.36s6.38-14.36,14.22-14.36,14.24,6.44,14.24,14.36-6.39,14.36-14.24,14.36ZM-160.2-74.74c-6.96,0-12.62,5.72-12.62,12.75s5.66,12.75,12.62,12.75,12.64-5.72,12.64-12.75-5.67-12.75-12.64-12.75Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-163.79-54.17c-.6,0-1.16-.32-1.46-.83-.16-.31-.22-.58-.22-.86v-12.27c0-.93.75-1.69,1.66-1.69.33,0,.65.1.92.28l5.2,3.02s.08.05.12.09l5.13,2.99c.8.48,1.06,1.5.6,2.29-.14.25-.35.46-.61.61l-5.15,3s-.06.05-.1.07l-5.27,3.08c-.27.14-.55.22-.83.22ZM-163.79-68.21s-.08.03-.08.09v12.27s0,.06.03.1c0-.02.03-.02.05-.02.01,0,.03,0,.04,0l5.13-3s.06-.05.1-.07l5.27-3.08c.05-.06.03-.11,0-.13l-5.21-3.04s-.08-.05-.12-.09l-5.15-2.99s-.04-.03-.07-.04Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-231.77-33.07h-29.34c-.53,0-.96-.43-.96-.96v-59.28c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.63c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-260.15-34.99h27.98l13.94-14.08.16-43.27h-42.09v57.35Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-231.77-33.07c-.12,0-.25-.03-.37-.07-.36-.15-.6-.5-.6-.89v-7.31c0-5.74,2.54-8.3,8.23-8.3h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-224.5-47.72c-4.6,0-6.31,1.73-6.31,6.38v4.96l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-261.02"
          y="-93.31"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-248.87-46.09c-2.98,0-5.41-2.23-5.41-4.96s2.43-4.95,5.41-4.95c.91,0,1.78.2,2.55.58v-15.23c0-.71.52-1.31,1.23-1.42l14.55-1.89c.05,0,.12-.01.19-.01.35,0,.69.13.94.37.3.27.48.66.48,1.07v17.8c0,2.73-2.43,4.95-5.41,4.95s-5.41-2.22-5.41-4.95c0-2.89,2.3-4.9,5.6-4.9,1.19,0,2.33.27,3.29.75v-7.17l-13.53,1.77v10.8c0,.24.02.48.04.73.03.43.06.92.04,1.55-.06,3.15-1.8,5.12-4.55,5.12ZM-248.87-54.08c-1.92,0-3.49,1.36-3.49,3.02s1.56,3.04,3.49,3.04c2.12,0,2.6-1.77,2.63-3.25.02-.54,0-.96-.04-1.37-.01-.16-.02-.32-.03-.47-.65-.62-1.56-.98-2.56-.98ZM-234.15-57.72c-1.7,0-3.68.78-3.68,2.98,0,1.67,1.56,3.02,3.48,3.02s3.49-1.36,3.49-3.02v-1.84c-.76-.71-1.99-1.14-3.29-1.14ZM-244.39-70.23v3.99l13.53-1.77v-3.98l-13.53,1.76Z"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-249.97-82h-1.55v-1.38h1.55v1.38ZM-246.34-89.79l1.98,5.74h.02l2-5.74h2.06v7.8h-1.57v-2.32l.15-3.45h-.04l-2.07,5.78h-1.05l-2.07-5.76h-.04l.15,3.44v2.32h-1.55v-7.8h2.04ZM-237.28-84.83v2.83h-1.55v-7.8h3.08c.9,0,1.61.23,2.11.68.52.45.79,1.06.79,1.81s-.26,1.34-.79,1.79c-.51.45-1.22.68-2.11.68h-1.53ZM-237.28-86.04h1.53c.45,0,.77-.11.99-.36.22-.23.34-.53.34-.91s-.11-.68-.34-.92c-.21-.25-.54-.36-.99-.36h-1.53v2.55ZM-230.33-86.57h.88c.35,0,.64-.09.82-.28.17-.21.26-.47.26-.81,0-.32-.09-.57-.26-.75-.19-.19-.45-.28-.79-.28-.28,0-.54.08-.73.25-.21.17-.3.4-.3.68h-1.51l-.02-.04c-.02-.6.22-1.11.71-1.51.49-.4,1.08-.59,1.81-.59.8,0,1.44.19,1.92.57.49.4.71.94.71,1.66,0,.34-.09.66-.32.96-.21.3-.5.55-.88.72.43.15.77.4.99.7.23.32.34.7.34,1.11,0,.72-.26,1.28-.79,1.7-.5.4-1.18.6-1.98.6-.73,0-1.35-.19-1.87-.59-.5-.38-.77-.92-.75-1.62l.02-.02h1.51c0,.28.09.53.32.74.2.19.49.28.8.28.36,0,.65-.09.86-.3.21-.19.32-.47.32-.81,0-.4-.11-.7-.32-.89-.21-.21-.5-.3-.9-.3h-.88v-1.17Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-310.67-33.07h-29.34c-.53,0-.96-.43-.96-.96v-59.27c0-.53.43-.96.96-.96h44.01c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.63c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-339.05-34.99h27.98l13.94-14.08.16-43.27h-42.09v57.35Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-310.67-33.07c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.3c0-5.74,2.54-8.31,8.23-8.31h7.23c.39,0,.74.23.89.59.15.36.07.77-.21,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-303.4-47.72c-4.6,0-6.31,1.73-6.31,6.38v4.96l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-339.92"
          y="-93.31"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-327.29-81.68h-1.67v-1.49h1.67v1.49ZM-320.28-88.32h-2.19v6.64h-1.57v-6.64h-2.19v-1.23h5.94v1.23ZM-316.65-86.76l1.46-2.79h1.81l-2.32,3.91,2.45,3.96h-1.89l-1.5-2.83-1.51,2.83h-1.81l2.37-3.96-2.32-3.91h1.81l1.44,2.79ZM-307.07-88.32h-2.2v6.64h-1.55v-6.64h-2.19v-1.23h5.94v1.23Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-303.35-68.26h-9.68c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h9.68c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-303.35-61.46h-29.34c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.34c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-303.35-54.66h-17.92c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h17.92c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-318.02-47.89h-14.67c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h14.67c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-319.29-68.26h-13.4c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h13.4c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-325.48-54.66h-7.21c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.21c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-389.58-33.09h-29.34c-.53,0-.96-.43-.96-.96v-59.25c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.61c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.28-.68.28ZM-417.96-35.01h27.98l13.94-14.08.16-43.25h-42.09v57.33Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-389.58-33.09c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.29c0-5.76,2.54-8.33,8.23-8.33h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.18.19-.43.28-.68.28ZM-382.31-47.74c-4.6,0-6.31,1.74-6.31,6.4v4.95l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-418.83"
          y="-93.31"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-406.95-81.7h-1.55v-1.38h1.55v1.38ZM-403.81-84.55v2.85h-1.55v-7.85h3.1c.9,0,1.59.23,2.11.68.5.47.77,1.08.77,1.83s-.26,1.34-.77,1.81c-.52.45-1.21.68-2.11.68h-1.55ZM-403.81-85.75h1.55c.43,0,.77-.13.99-.36.22-.25.34-.55.34-.93s-.11-.68-.34-.92c-.22-.25-.56-.38-.99-.38h-1.55v2.59ZM-394.03-83.75c0-.3-.11-.53-.32-.72-.21-.19-.58-.36-1.12-.51-.92-.28-1.63-.6-2.09-.96-.47-.38-.71-.89-.71-1.53s.26-1.17.82-1.59c.54-.4,1.23-.6,2.07-.6s1.55.23,2.09.68c.52.47.78,1.04.77,1.7v.04h-1.51c0-.36-.13-.64-.35-.87-.24-.23-.58-.34-1.03-.34-.41,0-.73.09-.95.28-.22.19-.36.42-.36.72,0,.26.13.47.37.64.24.17.67.36,1.27.55.86.23,1.5.55,1.94.94.45.4.65.93.65,1.57s-.26,1.19-.79,1.59c-.52.4-1.21.58-2.07.58s-1.59-.23-2.22-.66c-.62-.43-.93-1.06-.92-1.85l.02-.04h1.51c0,.47.13.81.43,1.02.28.23.67.34,1.18.34.43,0,.75-.09.97-.26.22-.19.34-.42.34-.72h0ZM-391.28-81.7v-7.85h2.67c.93,0,1.72.3,2.34.93.62.6.94,1.4.94,2.36v1.3c0,.96-.32,1.74-.94,2.36-.62.6-1.4.91-2.34.91h-2.67ZM-389.73-88.34v5.44h1.03c.56,0,1.01-.19,1.33-.59.32-.38.47-.87.47-1.49v-1.3c0-.6-.15-1.1-.47-1.49-.32-.38-.77-.57-1.33-.57h-1.03Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-401.45-48.92c-.2,0-.39-.06-.56-.18l-1.79-1.28c-.21-.15-.35-.38-.39-.64-.04-.26.03-.52.19-.73,1.79-2.32,3.54-5.05,5.39-7.95,3.99-6.24,8.11-12.69,13.02-15.35.32-.17.72-.15,1.02.06.3.21.45.58.39.94-.87,5.35-5.54,10.97-10.06,16.41-2.4,2.89-4.68,5.62-6.4,8.29-.14.22-.37.37-.63.42-.06,0-.12.02-.18.02ZM-401.88-51.38l.18.13c1.71-2.51,3.88-5.12,5.98-7.64,3.64-4.38,7.38-8.88,8.97-13.07-3.65,2.97-6.99,8.2-10.24,13.28-1.67,2.62-3.26,5.1-4.89,7.3Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-408.68-39.17h0c-.58,0-1.21-.05-1.86-.16-.35-.06-.65-.31-.76-.65-.11-.34-.03-.71.22-.97,1.22-1.26,1.32-2.38,1.43-3.56.16-1.79.34-3.82,4.4-5.35.3-.11.64-.07.9.12l1.92,1.38c.19.14.33.34.38.58.32,1.45.33,3.71-.68,5.34-1.02,1.54-2.6,3.28-5.95,3.28ZM-405.04-47.88c-2.47,1.03-2.55,2-2.69,3.54-.08.94-.18,2.05-.84,3.24,2.46-.03,3.47-1.25,4.23-2.39.58-.94.67-2.39.49-3.54l-1.18-.85Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-152.86-127.24h-29.34c-.53,0-.96-.43-.96-.96v-59.27c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.63c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.69.29ZM-181.24-129.16h27.98l13.94-14.08.16-43.27h-42.09v57.35Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-152.86-127.24c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.31c0-5.74,2.54-8.31,8.23-8.31h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.19.19-.43.29-.69.29ZM-145.59-141.89c-4.6,0-6.31,1.73-6.31,6.38v4.96l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-182.11"
          y="-187.47"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-170.61-175.86h-1.66v-1.47h1.66v1.47ZM-167.4-178.71v2.85h-1.57v-7.85h3.1c.9,0,1.59.23,2.11.7.5.45.77,1.06.77,1.81s-.26,1.36-.77,1.81c-.52.45-1.21.68-2.11.68h-1.53ZM-167.4-179.92h1.53c.43,0,.77-.11.99-.36.22-.25.34-.55.34-.91,0-.38-.11-.7-.34-.94-.22-.25-.56-.36-.99-.36h-1.53v2.57ZM-155.55-175.86h-1.55l-3.14-5.36h-.04v5.36h-1.57v-7.85h1.57l3.14,5.36h.04v-5.36h1.55v7.85ZM-148.11-176.94c-.24.32-.6.59-1.08.83-.49.25-1.12.36-1.87.36-.93,0-1.72-.28-2.32-.89-.6-.6-.92-1.38-.92-2.32v-1.64c0-.94.3-1.72.88-2.32.58-.6,1.33-.91,2.24-.91s1.66.25,2.17.7c.5.47.77,1.08.77,1.85v.02h-1.48c-.02-.42-.15-.74-.39-.98-.24-.24-.58-.36-1.03-.36-.49,0-.86.19-1.16.55-.3.38-.43.85-.43,1.43v1.66c0,.58.15,1.08.45,1.43.3.38.71.57,1.21.57.37,0,.65-.04.88-.11.23-.08.39-.17.5-.28v-1.43h-1.38v-1.1h2.95v2.95Z"
        />
        <path
          className="cls-1"
          fill="#00b3e8"
          d="M-171.66-169.03h3.27v3.3h3.27v-3.3h3.29v3.3h3.27v-3.3h3.27v3.3h3.29v-3.3h3.27v3.3h-3.27v3.3h3.27v3.32h-3.27v3.3h3.27v3.3h-3.27v3.32h3.27v3.3h-3.27v-3.3h-3.29v3.3h-3.27v-3.3h-3.27v3.3h-3.29v-3.3h-3.27v3.3h-3.27v-3.3h3.27v-3.32h-3.27v-3.3h3.27v-3.3h-3.27v-3.32h3.27v-3.3h-3.27v-3.3ZM-158.56-165.73v3.3h3.27v-3.3h-3.27ZM-155.29-162.42v3.32h3.29v-3.32h-3.29ZM-165.12-165.73v3.3h3.29v-3.3h-3.29ZM-161.83-162.42v3.32h3.27v-3.32h-3.27ZM-158.56-159.1v3.3h3.27v-3.3h-3.27ZM-155.29-155.8v3.3h3.29v-3.3h-3.29ZM-161.83-149.17v-3.32h-3.29v3.32h3.29ZM-165.12-152.49v-3.3h-3.27v3.3h3.27ZM-155.29-149.17v-3.32h-3.27v3.32h3.27ZM-158.56-152.49v-3.3h-3.27v3.3h3.27ZM-161.83-155.8v-3.3h-3.29v3.3h3.29ZM-165.12-159.1v-3.32h-3.27v3.32h3.27Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-231.77-127.26h-29.34c-.53,0-.96-.43-.96-.96v-59.26c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.61c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-260.15-129.18h27.98l13.94-14.08.16-43.25h-42.09v57.33Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-231.77-127.26c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.29c0-5.76,2.54-8.33,8.23-8.33h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-224.5-141.9c-4.6,0-6.31,1.73-6.31,6.4v4.95l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-261.02"
          y="-187.47"
          width="43.83"
          height="14.8"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-246.91-175.86h-1.68v-1.49h1.68v1.49ZM-243.69-177.09h3.79v1.23h-5.68v-.83l3.7-5.81h-3.7v-1.21h5.59v.77l-3.7,5.85ZM-237.17-175.86h-1.55v-7.85h1.55v7.85ZM-234.05-178.71v2.85h-1.57v-7.85h3.1c.9,0,1.61.23,2.11.68.5.45.77,1.08.77,1.81s-.26,1.36-.77,1.81c-.5.47-1.21.7-2.11.7h-1.53ZM-234.05-179.94h1.53c.43,0,.77-.11.99-.36.22-.23.34-.53.34-.91s-.11-.68-.34-.94c-.22-.24-.54-.36-.99-.36h-1.53v2.57Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-244.12-167.94h-7.25c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.25c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-244.12-163.86h-7.25c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.25c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-247.75-146.74c-.53,0-.96-.43-.96-.96v-26.32c0-.53.43-.96.96-.96s.96.43.96.96v26.32c0,.53-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-244.12-159.78h-7.25c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.25c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-244.12-155.7h-7.25c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.25c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-244.12-151.64h-7.25c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.25c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-247.75-132.01c-1.75,0-3.49-.78-4.65-2.08-1.03-1.15-1.5-2.59-1.34-4.05l1.12-9.67c.06-.49.47-.85.96-.85h7.79c.49,0,.9.37.96.85l1.12,9.67c.17,1.46-.31,2.9-1.34,4.06-1.16,1.3-2.89,2.07-4.62,2.07ZM-250.8-146.74l-1.02,8.81c-.1.9.2,1.81.86,2.55.8.9,2,1.44,3.21,1.44s2.39-.54,3.19-1.43c.66-.74.97-1.65.86-2.56l-1.02-8.81h-6.08Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-247.75-135.09c-.99,0-1.96-.45-2.6-1.19-.55-.65-.79-1.45-.66-2.25l.28-1.7c.08-.47.48-.81.95-.81h4.02c.47,0,.87.34.95.81l.28,1.7c.13.8-.1,1.6-.66,2.25-.63.75-1.6,1.19-2.57,1.19ZM-248.95-139.11l-.15.89c-.04.24.04.47.22.69.27.31.71.52,1.13.52s.84-.2,1.11-.51c.13-.15.27-.39.22-.69l-.15-.89h-2.39Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-310.67-127.24h-29.34c-.53,0-.96-.43-.96-.96v-59.28c0-.53.43-.96.96-.96h44.01c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.63c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-339.05-129.16h27.98l13.94-14.08.16-43.27h-42.09v57.35Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-310.67-127.24c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.31c0-5.75,2.54-8.31,8.23-8.31h7.23c.39,0,.74.23.89.59.15.36.07.77-.21,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-303.4-141.89c-4.6,0-6.31,1.73-6.31,6.38v4.96l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-339.92"
          y="-187.47"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-328.28-175.85h-1.66v-1.49h1.66v1.49ZM-322.47-177.54h-2.73l-.52,1.7h-1.57l2.67-7.87h1.59l2.67,7.87h-1.57l-.54-1.7ZM-324.8-178.75h1.96l-.97-3.12h-.02l-.97,3.12ZM-318.08-178.7v2.85h-1.55v-7.87h3.1c.9,0,1.59.25,2.11.7.5.45.77,1.06.77,1.81s-.26,1.36-.77,1.81c-.52.47-1.21.7-2.11.7h-1.55ZM-318.08-179.92h1.55c.43,0,.77-.11.99-.36.22-.23.34-.55.34-.91,0-.38-.11-.7-.34-.94-.23-.25-.56-.36-.99-.36h-1.55v2.57ZM-310.08-179.13h-.86v3.28h-1.57v-7.87h1.57v3.23h.67l2.06-3.23h1.92l-2.64,3.68,2.84,4.19h-1.91l-2.09-3.28Z"
        />
        <path
          className="cls-1"
          fill="#00b3e8"
          d="M-320.43-154.59l2.95-2.38c.34-.26.39-.76.13-1.09-.26-.36-.75-.42-1.08-.13l-3.14,2.49c-.97-.85-2.11-1.55-3.4-2.04-1.27-.47-2.58-.7-3.89-.74l-.71-3.95c-.08-.43-.49-.72-.9-.64-.43.07-.71.49-.64.91l.67,3.76c-4.19.51-7.98,3.28-9.57,7.55l-.02.04v.47c.08.23.22.41.47.49l20.39,7.76c.39.15.84-.04,1.01-.45,1.57-4.27.54-8.87-2.28-12.04h0ZM-338.24-151.02c2.21-4.79,7.76-7.14,12.73-5.25,4.97,1.91,7.61,7.36,6.15,12.42l-18.88-7.17Z"
        />
        <path
          className="cls-1"
          fill="#00b3e8"
          d="M-319.44-141.36l-20.39-7.76c-.06-.02-.13-.04-.19-.04v2.79l.37-1,18.93,7.21-4.47,11.95h1.66l4.52-12.14c.15-.4-.04-.85-.45-1.02h0Z"
        />
        <path
          className="cls-1"
          fill="#00b3e8"
          d="M-311.85-149.04c-1.4-.53-2.97.19-3.5,1.6l-3.85,10.29c-.52,1.44.19,3.02,1.59,3.55,1.4.55,2.99-.17,3.51-1.6l3.83-10.29c.54-1.42-.17-3-1.59-3.55h0ZM-315.55-135.75c-.22.6-.9.92-1.5.68-.62-.23-.92-.91-.69-1.51l3.85-10.29c.22-.62.9-.92,1.5-.7.6.23.91.91.67,1.53l-3.83,10.29Z"
        />
        <path
          className="cls-1"
          fill="#00b3e8"
          d="M-330.58-154.4c.58.23.86.87.65,1.43-.22.59-.86.87-1.42.66-.58-.23-.86-.87-.65-1.43.22-.58.86-.87,1.42-.66h0Z"
        />
        <path
          className="cls-1"
          fill="#00b3e8"
          d="M-322.94-151.49c.56.23.86.87.64,1.43-.21.59-.84.87-1.42.66-.56-.23-.86-.87-.63-1.44.2-.59.84-.87,1.42-.66h0Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-389.58-127.24h-29.34c-.53,0-.96-.43-.96-.96v-59.28c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.63c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-417.96-129.16h27.98l13.94-14.08.16-43.27h-42.09v57.35Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-389.58-127.24c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.31c0-5.74,2.54-8.31,8.23-8.31h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-382.31-141.88c-4.6,0-6.31,1.73-6.31,6.38v4.96l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-418.83"
          y="-187.47"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-408.25-175.85h-1.66v-1.49h1.66v1.49ZM-406.61-175.85v-7.87h2.67c.95,0,1.74.32,2.35.93.62.62.92,1.4.92,2.36v1.3c0,.96-.3,1.75-.92,2.36-.62.6-1.4.92-2.35.92h-2.67ZM-405.06-182.49v5.42h1.03c.56,0,1.01-.19,1.33-.57.32-.38.47-.89.47-1.49v-1.32c0-.6-.15-1.09-.47-1.47-.32-.38-.77-.57-1.33-.57h-1.03ZM-397.41-183.72l2,5.8h.02l2-5.8h2.04v7.87h-1.55v-2.36l.15-3.45-.04-.02-2.07,5.83h-1.05l-2.07-5.81-.04.02.15,3.44v2.36h-1.57v-7.87h2.04ZM-383.92-176.92c-.22.3-.6.57-1.08.81-.49.24-1.1.36-1.85.36-.95,0-1.74-.28-2.34-.89-.6-.6-.9-1.38-.9-2.32v-1.64c0-.94.28-1.72.86-2.32.58-.6,1.33-.91,2.24-.91s1.66.25,2.17.7c.5.47.77,1.1.79,1.85l-.02.04h-1.46c-.04-.43-.17-.76-.41-1-.22-.25-.58-.36-1.03-.36s-.86.19-1.16.55c-.28.38-.43.85-.43,1.43v1.66c0,.59.15,1.08.45,1.44.32.38.71.57,1.23.57.36,0,.65-.04.88-.11.21-.08.37-.17.48-.28v-1.43h-1.36v-1.1h2.93v2.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-383.06-145.5h-27.72c-1,0-1.81-.82-1.81-1.82v-8.91c0-.6.06-1.56.12-2.1.01-.1.04-.2.09-.29l5.66-10.64c.18-.88.99-1.56,1.89-1.56h16.26c.91,0,1.71.68,1.88,1.58l5.27,10.65c.04.09.07.18.08.27.06.59.1,1.55.1,2.1v8.91c0,1-.81,1.82-1.81,1.82ZM-410.89-158.02c-.05.52-.09,1.31-.09,1.78v8.91c0,.12.09.22.21.22h27.72c.12,0,.21-.09.21-.22v-8.91c0-.47-.03-1.27-.08-1.8l-5.26-10.63c-.04-.09-.07-.18-.08-.28-.02-.16-.18-.3-.3-.3h-16.26c-.13,0-.31.14-.32.3-.01.1-.04.2-.09.3l-5.64,10.62ZM-385.83-148.29h-22.19c-1,0-1.81-.82-1.81-1.82v-4.08c0-1,.81-1.82,1.81-1.82h22.19c1,0,1.81.82,1.81,1.82v4.08c0,1-.81,1.82-1.81,1.82ZM-408.01-154.41c-.12,0-.21.11-.21.22v4.08c0,.12.09.22.21.22h22.19c.12,0,.21-.09.21-.22v-4.08c0-.1-.09-.22-.21-.22h-22.19Z"
        />
        <path
          className="cls-1"
          fill="#00b3e8"
          d="M-394.93-153.17h-11.06c-.54,0-1.01.47-1.01,1.02s.47,1.02,1.01,1.02h11.06c.56,0,1.01-.45,1.01-1.02s-.45-1.02-1.01-1.02h0ZM-391.28-151.13c-.56,0-1.01-.45-1.01-1.02s.45-1,1.01-1,.99.45.99,1-.45,1.02-.99,1.02h0ZM-387.84-151.13c-.56,0-1.01-.45-1.01-1.02s.45-1,1.01-1,.99.45.99,1-.45,1.02-.99,1.02h0Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-152.86-221.4h-29.34c-.53,0-.96-.43-.96-.96v-59.26c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.61c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.69.29ZM-181.24-223.33h27.98l13.94-14.08.16-43.25h-42.09v57.33Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-152.86-221.4c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.29c0-5.76,2.54-8.33,8.23-8.33h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.19.19-.43.29-.69.29ZM-145.59-236.05c-4.6,0-6.31,1.73-6.31,6.4v4.95l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-182.11"
          y="-281.62"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-174.07-270.01h-1.68v-1.47h1.68v1.47ZM-172.45-270.01v-7.85h2.67c.95,0,1.74.3,2.36.93.62.6.93,1.4.93,2.36v1.3c0,.96-.32,1.74-.93,2.36-.62.6-1.4.91-2.36.91h-2.67ZM-170.88-276.66v5.44h1.03c.56,0,.99-.19,1.31-.58.32-.38.49-.87.49-1.49v-1.3c0-.6-.17-1.1-.49-1.49-.32-.38-.75-.57-1.31-.57h-1.03ZM-159.01-273.24c0,.96-.3,1.77-.91,2.4-.6.62-1.38.94-2.36.94s-1.72-.32-2.32-.94c-.6-.62-.9-1.43-.9-2.4v-1.42c0-.94.28-1.76.88-2.38.6-.62,1.38-.94,2.34-.94s1.76.32,2.36.94c.62.62.91,1.43.91,2.38v1.42ZM-160.58-274.66c0-.62-.15-1.13-.45-1.51-.3-.4-.71-.6-1.25-.6s-.93.21-1.23.59c-.28.4-.43.91-.43,1.53v1.42c0,.62.15,1.13.43,1.53.3.4.71.59,1.23.59s.95-.19,1.25-.59c.3-.4.45-.91.45-1.53v-1.42ZM-151.92-272.69l.02.04c.02.85-.24,1.51-.76,2-.52.51-1.25.76-2.19.76s-1.7-.3-2.28-.91c-.6-.62-.88-1.4-.88-2.36v-1.55c0-.96.28-1.74.86-2.36.56-.6,1.31-.91,2.21-.91.97,0,1.72.25,2.26.75.54.49.8,1.17.78,2.04v.02h-1.51c0-.51-.13-.91-.37-1.19-.24-.26-.64-.41-1.16-.41-.47,0-.82.19-1.1.59-.28.38-.41.87-.41,1.45v1.57c0,.6.15,1.1.43,1.47.3.38.67.57,1.18.57s.84-.13,1.08-.38c.22-.28.34-.66.34-1.19h1.51ZM-148.05-275.09l1.46-2.77h1.81l-2.3,3.89,2.43,3.96h-1.89l-1.5-2.83-1.5,2.83h-1.83l2.37-3.96-2.32-3.89h1.81l1.44,2.77Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-145.53-256.57h-29.34c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.34c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-145.53-249.8h-29.34c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.34c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-145.53-243h-29.34c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.34c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-160.2-236.2h-14.67c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h14.67c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-231.77-221.4h-29.34c-.53,0-.96-.43-.96-.96v-59.26c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.61c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-260.15-223.33h27.98l13.94-14.08.16-43.25h-42.09v57.33Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-231.77-221.4c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.29c0-5.76,2.54-8.32,8.23-8.32h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-224.5-236.05c-4.6,0-6.31,1.73-6.31,6.4v4.95l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-261.02"
          y="-281.62"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-252.08-270.01h-1.66v-1.47h1.66v1.47ZM-247.69-275.09l1.46-2.77h1.81l-2.3,3.89,2.43,3.96h-1.89l-1.5-2.83-1.5,2.83h-1.83l2.37-3.96-2.32-3.89h1.81l1.44,2.77ZM-241.92-271.22h3.46v1.21h-5.03v-7.85h1.57v6.64ZM-233.36-272.07c0-.3-.11-.55-.32-.72-.21-.19-.58-.36-1.12-.51-.92-.28-1.63-.6-2.09-.96-.47-.38-.71-.89-.71-1.53s.28-1.17.82-1.59c.54-.4,1.23-.6,2.07-.6s1.55.23,2.09.68c.52.47.79,1.04.77,1.7v.04h-1.51c0-.36-.11-.64-.35-.87-.24-.23-.58-.34-1.03-.34-.41,0-.73.09-.95.28-.22.19-.36.41-.36.72,0,.26.13.47.37.64.24.17.67.36,1.27.55.86.23,1.5.55,1.94.94.45.4.65.93.65,1.57s-.26,1.19-.79,1.59c-.52.4-1.21.59-2.07.59s-1.59-.23-2.22-.66c-.62-.45-.93-1.06-.91-1.85l.02-.04h1.51c0,.47.13.81.43,1.02.28.23.67.34,1.18.34.43,0,.75-.09.97-.26.22-.19.34-.41.34-.72h0ZM-227.88-275.09l1.46-2.77h1.83l-2.32,3.89,2.45,3.96h-1.89l-1.51-2.83-1.5,2.83h-1.81l2.36-3.96-2.3-3.89h1.79l1.44,2.77Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-221.32-254h-35.59c-.44,0-.8-.36-.8-.8v-5.62c0-.44.36-.8.8-.8h35.59c.44,0,.8.36.8.8v5.62c0,.44-.36.8-.8.8ZM-256.1-255.6h33.98v-4.02h-33.98v4.02Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-221.32-248.39h-35.59c-.44,0-.8-.36-.8-.8v-5.61c0-.44.36-.8.8-.8h35.59c.44,0,.8.36.8.8v5.61c0,.44-.36.8-.8.8ZM-256.1-249.99h33.98v-4h-33.98v4Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-221.32-242.76h-35.59c-.44,0-.8-.36-.8-.8v-5.62c0-.44.36-.8.8-.8h35.59c.44,0,.8.36.8.8v5.62c0,.44-.36.8-.8.8ZM-256.1-244.37h33.98v-4.02h-33.98v4.02Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-232.27-242.76h-13.68c-.44,0-.8-.36-.8-.8v-16.86c0-.44.36-.8.8-.8h13.68c.44,0,.8.36.8.8v16.86c0,.44-.36.8-.8.8ZM-245.15-244.37h12.08v-15.25h-12.08v15.25Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M76.24-221.49h-29.38c-.53,0-.96-.43-.96-.96v-59.08c0-.53.43-.96.96-.96h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.61c-.18.18-.43.28-.68.28ZM47.83-223.41h28.02l13.96-14.04.16-43.12h-42.14v57.16Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M76.24-221.49c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.27c0-5.74,2.54-8.3,8.24-8.3h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.04l-14.52,14.61c-.18.19-.43.28-.69.28ZM83.52-236.1c-4.6,0-6.31,1.73-6.31,6.38v4.93l11.25-11.31h-4.93Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="46.96"
          y="-281.54"
          width="43.89"
          height="14.78"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M86.7-253.99h-35.63c-.44,0-.8-.36-.8-.8v-5.61c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.61c0,.44-.36.8-.8.8ZM51.88-255.59h34.03v-4.01h-34.03v4.01Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M86.7-248.4h-35.63c-.44,0-.8-.36-.8-.8v-5.59c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.59c0,.44-.36.8-.8.8ZM51.88-250h34.03v-3.99h-34.03v3.99Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M86.7-242.79h-35.63c-.44,0-.8-.36-.8-.8v-5.61c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.61c0,.44-.36.8-.8.8ZM51.88-244.39h34.03v-4.01h-34.03v4.01Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M75.74-242.79h-13.7c-.44,0-.8-.36-.8-.8v-16.81c0-.44.36-.8.8-.8h13.7c.44,0,.8.36.8.8v16.81c0,.44-.36.8-.8.8ZM62.84-244.39h12.09v-15.21h-12.09v15.21Z"
        />
        <text
          className="cls-6"
          fill="#fefefe"
          transform="translate(54.48 -270.25)"
        >
          <tspan x="0" y="0">
            .CSV
          </tspan>
        </text>
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-310.67-221.4h-29.34c-.53,0-.96-.43-.96-.96v-59.26c0-.53.43-.96.96-.96h44.01c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.61c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-339.05-223.33h27.98l13.94-14.08.16-43.25h-42.09v57.33Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-310.67-221.4c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.29c0-5.76,2.54-8.33,8.23-8.33h7.23c.39,0,.74.23.89.59.15.36.07.77-.21,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-303.4-236.05c-4.6,0-6.31,1.73-6.31,6.4v4.95l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-339.92"
          y="-281.62"
          width="43.83"
          height="14.8"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-331.33-270.01h-1.66v-1.49h1.66v1.49ZM-328.13-272.86v2.85h-1.55v-7.85h3.1c.9,0,1.59.23,2.11.68.51.47.77,1.08.77,1.81s-.26,1.36-.77,1.81c-.52.47-1.21.7-2.11.7h-1.55ZM-328.13-274.09h1.55c.43,0,.77-.11.99-.36.22-.23.34-.53.34-.91s-.11-.68-.34-.94c-.22-.24-.56-.36-.99-.36h-1.55v2.57ZM-320.99-272.86v2.85h-1.57v-7.85h3.1c.9,0,1.61.23,2.11.68.5.47.77,1.08.77,1.81s-.26,1.36-.77,1.81c-.5.47-1.22.7-2.11.7h-1.53ZM-320.99-274.09h1.53c.43,0,.77-.11.99-.36.22-.23.34-.53.34-.91s-.11-.68-.34-.94c-.22-.24-.54-.36-.99-.36h-1.53v2.57ZM-310.06-276.66h-2.21v6.64h-1.55v-6.64h-2.19v-1.21h5.94v1.21ZM-306.45-275.09l1.46-2.77h1.83l-2.32,3.89,2.45,3.96h-1.89l-1.5-2.83-1.51,2.83h-1.81l2.35-3.96-2.3-3.89h1.81l1.42,2.77Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-310.56-236.6c-.34,0-.66-.18-.84-.49l-3.35-5.95c-.26-.46-.1-1.05.37-1.31.46-.26,1.05-.1,1.31.37l3.35,5.95c.26.46.1,1.05-.37,1.31-.15.09-.31.12-.47.12ZM-325.46-236.6c-.16,0-.32-.04-.47-.12-.46-.26-.63-.85-.37-1.31l3.35-5.95c.26-.46.85-.63,1.31-.37.46.26.63.85.37,1.31l-3.35,5.95c-.18.31-.5.49-.84.49Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-318-259.52c-.53,0-.96-.43-.96-.96v-2.06c0-.53.43-.96.96-.96s.96.43.96.96v2.06c0,.53-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-302.47-242.55h-31.08c-.53,0-.96-.43-.96-.96v-16.97c0-.53.43-.96.96-.96h31.08c.53,0,.96.43.96.96v16.97c0,.53-.43.96-.96.96ZM-332.59-244.47h29.16v-15.05h-29.16v15.05Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-306.54-246.85c-.53,0-.96-.43-.96-.96v-8.21c0-.53.43-.96.96-.96s.96.43.96.96v8.21c0,.53-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-309.63-246.85c-.53,0-.96-.43-.96-.96l-.02-4.83c0-.53.43-.96.96-.97.52.02.96.43.97.96l.02,4.83c0,.53-.43.96-.96.97h0Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-312.73-246.85c-.53,0-.96-.43-.96-.96v-2.42c0-.53.43-.96.96-.96s.96.43.96.96v2.42c0,.53-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-320.08-255.06h-9.46c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h9.46c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-323.76-250.97h-5.78c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h5.78c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-329.53-246.85c-.53,0-.96-.43-.96-.96,0-.53.43-.96.96-.96l11.68-.02h0c.53,0,.96.43.96.96,0,.53-.43.96-.96.96l-11.68.02h0Z"
        />
      </g>
      <g>
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-389.58-221.4h-29.34c-.53,0-.96-.43-.96-.96v-59.26c0-.53.43-.96.96-.96h44.02c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.61c0,.25-.1.49-.28.67l-14.5,14.65c-.18.18-.43.29-.68.29ZM-417.96-223.33h27.98l13.94-14.08.16-43.25h-42.09v57.33Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-389.58-221.4c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.29c0-5.76,2.54-8.33,8.23-8.33h7.23c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.5,14.65c-.18.19-.43.29-.68.29ZM-382.31-236.05c-4.6,0-6.31,1.73-6.31,6.4v4.95l11.23-11.35h-4.92Z"
        />
        <rect
          className="cls-3"
          fill="#00b3e8"
          x="-418.83"
          y="-281.62"
          width="43.83"
          height="14.82"
        />
        <path
          className="cls-2"
          fill="#fefefe"
          d="M-407.13-270.01h-1.66v-1.47h1.66v1.47ZM-403.94-273.15v3.13h-1.55v-7.85h2.93c.88,0,1.57.21,2.07.6.51.42.75.98.75,1.72,0,.4-.09.75-.32,1.04-.21.3-.5.53-.92.72.47.13.79.36.99.68.21.32.3.72.3,1.19v.57c0,.23.04.45.09.7.06.23.15.42.3.53v.11h-1.61c-.15-.11-.24-.3-.28-.58-.04-.26-.06-.51-.06-.76v-.57c0-.38-.11-.7-.32-.91-.22-.23-.52-.32-.9-.32h-1.49ZM-403.94-274.37h1.35c.45,0,.77-.09.99-.28.21-.17.32-.45.32-.83,0-.36-.11-.64-.32-.85-.22-.21-.54-.32-.95-.32h-1.38v2.28ZM-394.09-271.71h-2.73l-.52,1.7h-1.57l2.67-7.85h1.59l2.67,7.85h-1.57l-.54-1.7ZM-396.42-272.92h1.96l-.97-3.11h-.02l-.97,3.11ZM-389.69-273.15v3.13h-1.55v-7.85h2.93c.88,0,1.57.21,2.08.6.5.42.75.98.75,1.72,0,.4-.09.75-.32,1.04-.21.3-.51.53-.92.72.47.13.78.36.99.68.21.32.3.72.3,1.19v.57c0,.23.04.45.09.7.06.23.15.42.3.53v.11h-1.61c-.15-.11-.24-.3-.28-.58-.04-.26-.06-.51-.06-.76v-.57c0-.38-.11-.7-.32-.91-.22-.23-.52-.32-.9-.32h-1.5ZM-389.69-274.37h1.35c.45,0,.77-.09.99-.28.21-.17.32-.45.32-.83,0-.36-.11-.64-.32-.85-.22-.21-.54-.32-.95-.32h-1.38v2.28Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-401.94-262.08h-7.25c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.25c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-401.94-258.01h-7.25c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.25c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-405.56-240.89c-.53,0-.96-.43-.96-.96v-26.32c0-.53.43-.96.96-.96s.96.43.96.96v26.32c0,.53-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-401.94-253.93h-7.25c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.25c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-401.94-249.85h-7.25c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.25c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-401.94-245.77h-7.25c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.25c.53,0,.96.43.96.96s-.43.96-.96.96Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-405.56-226.14c-1.74,0-3.48-.78-4.64-2.08-1.04-1.16-1.51-2.61-1.35-4.07l1.12-9.67c.06-.49.47-.85.96-.85h7.79c.49,0,.9.37.96.85l1.12,9.67c.17,1.47-.31,2.91-1.35,4.08-1.16,1.3-2.89,2.08-4.62,2.08ZM-408.61-240.89l-1.02,8.81c-.1.91.2,1.82.87,2.57.8.9,2,1.44,3.2,1.44s2.38-.54,3.18-1.43c.67-.75.98-1.66.87-2.57l-1.02-8.81h-6.08Z"
        />
        <path
          className="cls-3"
          fill="#00b3e8"
          d="M-405.56-229.24c-.99,0-1.97-.45-2.6-1.2-.55-.64-.78-1.43-.65-2.22l.28-1.72c.08-.47.48-.81.95-.81h4.02c.47,0,.87.34.95.81l.28,1.72c.13.79-.1,1.58-.65,2.23-.63.75-1.6,1.19-2.58,1.19ZM-406.76-233.26l-.15.91c-.05.29.09.52.21.67.27.32.71.52,1.13.52s.85-.2,1.11-.52c.12-.15.26-.38.22-.67l-.15-.91h-2.38Z"
        />
      </g>
    </svg>
  );
}

export function Svgicon() {
  return (
    <svg
      fill="#00b3e8"
      width="45px"
      height="50px"
      version="1.1"
      id="_x32_"
      viewBox="0 0 512 512"
    >
      <g>
        <path
          className="st0"
          d="M378.409,0H208.294h-13.176l-9.314,9.315L57.017,138.101l-9.314,9.315v13.176v265.513
		   c0,47.36,38.528,85.896,85.895,85.896h244.811c47.361,0,85.888-38.535,85.888-85.896V85.896C464.297,38.528,425.77,0,378.409,0z
			M432.493,426.104c0,29.877-24.214,54.091-54.084,54.091H133.598c-29.877,0-54.091-24.214-54.091-54.091V160.592h83.717
		   c24.884,0,45.07-20.179,45.07-45.071V31.804h170.114c29.87,0,54.084,24.214,54.084,54.091V426.104z"
        />
        <path
          className="st0"
          d="M180.296,296.668l-4.846-0.67c-10.63-1.487-14.265-4.978-14.265-10.104c0-5.78,4.309-9.817,12.383-9.817
		   c5.653,0,11.305,1.62,15.745,3.764c1.886,0.942,3.903,1.487,5.789,1.487c4.845,0,8.612-3.63,8.612-8.616
		   c0-3.226-1.481-5.921-4.71-7.939c-5.384-3.372-15.476-6.06-25.572-6.06c-19.781,0-32.436,11.171-32.436,27.998
		   c0,16.15,10.232,24.898,28.938,27.454l4.846,0.67c10.903,1.48,14.129,4.846,14.129,10.229c0,6.326-5.247,10.766-14.939,10.766
		   c-6.727,0-12.111-1.745-19.645-5.921c-1.616-0.942-3.634-1.62-5.788-1.62c-5.115,0-8.885,3.91-8.885,8.756
		   c0,3.226,1.616,6.326,4.713,8.344c6.054,3.764,15.878,7.8,28.798,7.8c23.823,0,35.934-12.24,35.934-28.795
		   C209.097,307.84,199.273,299.356,180.296,296.668z"
        />
        <path
          className="st0"
          d="M281.108,259.382c-4.577,0-7.939,2.43-9.556,7.674l-16.69,54.51h-0.402l-17.634-54.51
		   c-1.745-5.244-4.978-7.674-9.551-7.674c-5.653,0-9.692,4.176-9.692,9.287c0,1.347,0.269,2.834,0.67,4.175l23.286,68.104
		   c2.96,8.477,6.727,11.57,12.652,11.57c5.785,0,9.555-3.093,12.516-11.57l23.282-68.104c0.406-1.341,0.674-2.828,0.674-4.175
		   C290.664,263.558,286.76,259.382,281.108,259.382z"
        />
        <path
          className="st0"
          d="M364.556,300.836h-18.841c-5.114,0-8.344,3.1-8.344,7.806c0,4.713,3.23,7.814,8.344,7.814h6.193
		   c0.538,0,0.803,0.258,0.803,0.803c0,3.505-0.265,6.598-1.075,9.014c-1.882,5.796-7.67,9.426-14.669,9.426
		   c-7.943,0-12.921-3.903-14.939-10.096c-1.075-3.365-1.48-7.8-1.48-19.648c0-11.842,0.405-16.15,1.48-19.516
		   c2.018-6.325,6.867-10.228,14.67-10.228c5.924,0,10.362,1.885,13.859,6.724c2.695,3.777,5.387,4.852,8.749,4.852
		   c4.981,0,9.021-3.638,9.021-8.888c0-2.151-0.674-4.035-1.752-5.921c-4.842-8.204-15.071-14.264-29.877-14.264
		   c-16.287,0-28.935,7.408-33.644,22.204c-2.022,6.466-2.559,11.576-2.559,25.038c0,13.454,0.538,18.573,2.559,25.031
		   c4.709,14.802,17.357,22.204,33.644,22.204c16.286,0,28.668-8.204,33.374-22.881c1.617-5.111,2.29-12.645,2.29-20.716v-0.95
		   C372.362,303.664,369.538,300.836,364.556,300.836z"
        />
      </g>
    </svg>
  );
}

export function Docicon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.47c0,.25-.1.49-.28.67l-14.52,14.61c-.18.18-.43.28-.69.28ZM1.93,59.08h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.27c0-5.74,2.54-8.3,8.25-8.3h7.24c.39,0,.74.23.89.59s.07.77-.2,1.05l-14.52,14.61c-.19.18-.43.28-.69.28ZM37.63,46.4c-4.61,0-6.32,1.73-6.32,6.38v4.93l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.75"
        fill="#00b3e8"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M14.18,12.53h-1.67v-1.49h1.67v1.49ZM15.88,12.53V4.14h2.86c1.03,0,1.85.34,2.53.98.66.66.99,1.51.99,2.52v1.39c0,1.03-.34,1.86-.99,2.52-.67.64-1.5.98-2.53.98h-2.86ZM17.54,5.44v5.8h1.1c.62,0,1.09-.21,1.42-.62.34-.39.51-.92.51-1.58v-1.39c0-.66-.17-1.19-.51-1.6-.34-.4-.8-.6-1.42-.6h-1.1ZM30.27,9.09c0,1.03-.32,1.88-.97,2.56-.64.66-1.48,1-2.51,1s-1.87-.34-2.51-1c-.64-.68-.97-1.52-.97-2.56v-1.51c0-1.03.32-1.88.97-2.54.64-.68,1.46-1.02,2.49-1.02s1.89.34,2.53,1.02c.66.66.97,1.51.97,2.54v1.51ZM28.6,7.57c0-.66-.17-1.19-.49-1.62-.32-.41-.77-.62-1.35-.62s-1.01.21-1.33.62c-.3.41-.47.96-.47,1.62v1.52c0,.66.17,1.2.49,1.64.32.41.75.62,1.33.62s1.01-.21,1.33-.62c.32-.43.49-.98.49-1.64v-1.52ZM37.87,9.67l.02.04c.02.9-.26,1.62-.82,2.15-.56.53-1.35.79-2.34.79s-1.83-.32-2.45-.98c-.62-.64-.94-1.47-.94-2.5v-1.66c0-1.01.3-1.84.92-2.5.62-.66,1.4-.98,2.38-.98,1.03,0,1.83.26,2.41.79.58.55.86,1.26.86,2.18l-.02.04h-1.63c0-.56-.13-.98-.39-1.28-.26-.28-.67-.43-1.24-.43-.5,0-.9.21-1.18.6-.3.41-.45.94-.45,1.56v1.67c0,.64.15,1.17.47,1.58.3.39.73.6,1.25.6s.9-.13,1.16-.42c.24-.28.37-.71.37-1.26h1.61Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M37.68,25.92H8.3c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.38c.53,0,.97.43.97.96s-.43.96-.97.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M37.68,32.69H8.3c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.38c.53,0,.97.43.97.96s-.43.96-.97.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M37.68,39.47H8.3c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.38c.53,0,.97.43.97.96s-.43.96-.97.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M22.99,46.23h-14.69c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h14.69c.53,0,.97.43.97.96s-.43.96-.97.96Z"
      />
    </svg>
  );
}

export function Docxicon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      width="45px"
      height="50px"
      version="1.1"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.61c-.18.18-.43.28-.69.28ZM1.93,59.08h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.27c0-5.74,2.54-8.3,8.25-8.3h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.52,14.61c-.19.19-.43.28-.69.28ZM37.63,46.39c-4.61,0-6.32,1.73-6.32,6.38v4.93l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.78"
        fill="#00b3e8"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M9.1,12.53h-1.68v-1.47h1.68v1.47ZM10.73,12.53v-7.83h2.68c.96,0,1.74.3,2.36.92.62.6.94,1.39.94,2.35v1.3c0,.96-.32,1.73-.94,2.35-.62.6-1.4.9-2.36.9h-2.68ZM12.3,5.91v5.42h1.03c.56,0,.99-.19,1.31-.58.32-.38.49-.87.49-1.49v-1.3c0-.6-.17-1.09-.49-1.49-.32-.38-.75-.56-1.31-.56h-1.03ZM24.19,9.32c0,.96-.3,1.77-.92,2.39-.6.62-1.39.94-2.36.94s-1.72-.32-2.32-.94c-.6-.62-.9-1.43-.9-2.39v-1.41c0-.94.28-1.75.88-2.37.6-.62,1.39-.94,2.34-.94s1.76.32,2.36.94c.62.62.92,1.43.92,2.37v1.41ZM22.62,7.9c0-.62-.15-1.13-.45-1.51-.3-.4-.71-.6-1.25-.6s-.93.21-1.23.58c-.28.4-.43.9-.43,1.52v1.41c0,.62.15,1.13.43,1.52.3.4.71.58,1.23.58s.95-.19,1.25-.58c.3-.39.45-.9.45-1.52v-1.41ZM31.28,9.86l.02.04c.02.85-.24,1.51-.77,2-.52.51-1.25.75-2.19.75s-1.7-.3-2.28-.9c-.6-.62-.88-1.39-.88-2.35v-1.54c0-.96.28-1.73.86-2.35.56-.6,1.31-.9,2.21-.9.97,0,1.72.24,2.26.75.54.49.81,1.17.79,2.03v.02h-1.51c0-.51-.13-.9-.38-1.19-.24-.26-.64-.41-1.16-.41-.47,0-.82.19-1.11.58-.28.38-.41.87-.41,1.45v1.56c0,.6.15,1.09.43,1.47.3.38.67.56,1.18.56s.84-.13,1.09-.38c.22-.28.34-.66.34-1.19h1.52ZM35.15,7.47l1.46-2.77h1.81l-2.3,3.88,2.43,3.95h-1.89l-1.5-2.82-1.5,2.82h-1.83l2.38-3.95-2.32-3.88h1.81l1.44,2.77Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M37.68,25.94H8.3c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.38c.53,0,.97.43.97.96s-.43.96-.97.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M37.68,32.69H8.3c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.38c.53,0,.97.43.97.96s-.43.96-.97.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M37.68,39.47H8.3c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.38c.53,0,.97.43.97.96s-.43.96-.97.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M22.99,46.24h-14.69c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h14.69c.53,0,.97.43.97.96s-.43.96-.97.96Z"
      />
    </svg>
  );
}

export function Csvicon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.61c-.18.18-.43.28-.68.28ZM1.93,59.08h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.27c0-5.74,2.54-8.3,8.24-8.3h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.04l-14.52,14.61c-.18.19-.43.28-.69.28ZM37.62,46.39c-4.6,0-6.31,1.73-6.31,6.38v4.93l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.78"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M40.81,28.5H5.17c-.44,0-.8-.36-.8-.8v-5.61c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.61c0,.44-.36.8-.8.8ZM5.98,26.9h34.03v-4.01H5.98v4.01Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M40.81,34.1H5.17c-.44,0-.8-.36-.8-.8v-5.59c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.59c0,.44-.36.8-.8.8ZM5.98,32.5h34.03v-3.99H5.98v3.99Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M40.81,39.7H5.17c-.44,0-.8-.36-.8-.8v-5.61c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.61c0,.44-.36.8-.8.8ZM5.98,38.1h34.03v-4.01H5.98v4.01Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M29.84,39.7h-13.7c-.44,0-.8-.36-.8-.8v-16.81c0-.44.36-.8.8-.8h13.7c.44,0,.8.36.8.8v16.81c0,.44-.36.8-.8.8ZM16.94,38.1h12.09v-15.21h-12.09v15.21Z"
      />
      <text className="cls-1" fill="#fefefe" transform="translate(8.58 12.24)">
        <tspan x="0" y="0">
          .CSV
        </tspan>
      </text>
    </svg>
  );
}

export function Xlsxicon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.61c-.18.18-.43.28-.68.28ZM1.93,59.08h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.27c0-5.74,2.54-8.3,8.24-8.3h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.04l-14.52,14.61c-.18.19-.43.28-.69.28ZM37.62,46.39c-4.6,0-6.31,1.73-6.31,6.38v4.93l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.78"
        fill="#00b3e8"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M10,12.53h-1.67v-1.47h1.67v1.47ZM14.4,7.47l1.46-2.77h1.81l-2.3,3.88,2.43,3.95h-1.89l-1.5-2.82-1.5,2.82h-1.83l2.38-3.95-2.32-3.88h1.82l1.44,2.77ZM20.18,11.33h3.46v1.2h-5.03v-7.83h1.57v6.62ZM28.75,10.48c0-.3-.11-.55-.32-.72-.21-.19-.58-.36-1.12-.51-.92-.28-1.63-.6-2.1-.96-.47-.38-.71-.89-.71-1.52s.28-1.17.82-1.58c.54-.4,1.23-.6,2.08-.6s1.55.23,2.1.68c.52.47.79,1.04.77,1.69v.04h-1.52c0-.36-.11-.64-.35-.87-.24-.23-.58-.34-1.03-.34-.41,0-.73.09-.95.28-.22.19-.36.41-.36.72,0,.26.13.47.37.64.24.17.67.36,1.27.55.86.23,1.5.55,1.95.94.45.4.66.92.66,1.56s-.26,1.19-.79,1.58c-.52.4-1.22.58-2.08.58s-1.59-.23-2.23-.66c-.62-.45-.94-1.05-.92-1.85l.02-.04h1.52c0,.47.13.81.43,1.02.28.23.67.34,1.18.34.43,0,.75-.09.97-.26.22-.19.34-.41.34-.71h0ZM34.24,7.47l1.46-2.77h1.83l-2.32,3.88,2.45,3.95h-1.89l-1.51-2.82-1.5,2.82h-1.81l2.36-3.95-2.3-3.88h1.8l1.44,2.77Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M40.81,28.5H5.17c-.44,0-.8-.36-.8-.8v-5.61c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.61c0,.44-.36.8-.8.8ZM5.98,26.9h34.03v-4.01H5.98v4.01Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M40.81,34.1H5.17c-.44,0-.8-.36-.8-.8v-5.59c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.59c0,.44-.36.8-.8.8ZM5.98,32.5h34.03v-3.99H5.98v3.99Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M40.81,39.7H5.17c-.44,0-.8-.36-.8-.8v-5.61c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.61c0,.44-.36.8-.8.8ZM5.98,38.1h34.03v-4.01H5.98v4.01Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M29.84,39.7h-13.7c-.44,0-.8-.36-.8-.8v-16.81c0-.44.36-.8.8-.8h13.7c.44,0,.8.36.8.8v16.81c0,.44-.36.8-.8.8ZM16.94,38.1h12.09v-15.21h-12.09v15.21Z"
      />
    </svg>
  );
}

export function Mp4icon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.61c-.18.18-.43.28-.69.28ZM1.93,59.08h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.26c0-5.74,2.54-8.3,8.25-8.3h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.52,14.61c-.19.19-.43.28-.69.28ZM37.63,46.39c-4.61,0-6.32,1.73-6.32,6.38v4.93l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.77"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M12,12.25h-1.55v-1.37h1.55v1.37ZM15.64,4.42l1.98,5.78h.02l2-5.78h2.04v7.83h-1.55v-2.33l.15-3.46h-.04l-2.08,5.8h-1.05l-2.08-5.78h-.04l.15,3.44v2.33h-1.55v-7.83h2.04ZM24.71,9.41v2.84h-1.57v-7.83h3.11c.9,0,1.61.23,2.12.7.52.45.77,1.05.77,1.81s-.24,1.36-.77,1.81c-.51.45-1.22.68-2.12.68h-1.53ZM24.71,8.21h1.53c.45,0,.77-.13.99-.36.22-.24.34-.55.34-.92s-.11-.68-.34-.92c-.22-.24-.54-.38-.99-.38h-1.53v2.58ZM34.67,9.35h.88v1.2h-.88v1.69h-1.55v-1.69h-3.18l-.07-.94,3.24-5.2h1.57v4.93ZM31.32,9.35h1.8v-2.84h-.04l-.13.22-1.63,2.62Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M22.99,46.5c-7.85,0-14.24-6.42-14.24-14.31s6.39-14.31,14.24-14.31,14.26,6.42,14.26,14.31-6.4,14.31-14.26,14.31ZM22.99,19.47c-6.97,0-12.63,5.7-12.63,12.71s5.67,12.71,12.63,12.71,12.65-5.7,12.65-12.71-5.68-12.71-12.65-12.71Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M19.4,39.98c-.6,0-1.16-.32-1.46-.83-.16-.31-.22-.58-.22-.85v-12.24c0-.93.75-1.69,1.66-1.69.34,0,.65.1.92.28l5.21,3.01s.08.05.12.09l5.14,2.98c.8.48,1.07,1.5.61,2.28-.14.25-.35.46-.61.61l-5.16,3s-.06.05-.1.07l-5.28,3.07c-.27.14-.55.22-.84.22ZM19.4,25.98s-.08.03-.08.08v12.24s0,.06.03.1c0-.02.03-.02.05-.02.01,0,.03,0,.05,0l5.14-2.99s.06-.05.1-.07l5.28-3.07c.05-.06.03-.11,0-.13l-5.21-3.03s-.08-.05-.12-.09l-5.15-2.98s-.04-.03-.07-.04Z"
      />
    </svg>
  );
}

export function Mp3icon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.6c-.18.18-.43.29-.68.29ZM1.93,59.08h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61c-.12,0-.25-.03-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.73,2.54-8.28,8.24-8.28h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.04l-14.52,14.6c-.18.19-.43.29-.69.29ZM37.62,46.4c-4.6,0-6.31,1.72-6.31,6.36v4.95l11.25-11.31h-4.93Z"
      />
      <rect className="cls-2" x="1.06" y=".96" width="43.89" height="14.77" />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M13.22,48.02c-2.99,0-5.42-2.22-5.42-4.95s2.43-4.93,5.42-4.93c.91,0,1.78.2,2.56.58v-15.18c0-.71.52-1.31,1.23-1.42l14.57-1.88c.05,0,.12-.01.19-.01.35,0,.69.13.94.37.3.27.48.66.48,1.06v17.74c0,2.72-2.43,4.93-5.42,4.93s-5.42-2.21-5.42-4.93c0-2.88,2.31-4.89,5.61-4.89,1.2,0,2.34.27,3.3.75v-7.15l-13.55,1.76v10.77c0,.24.02.48.04.73.03.43.06.92.04,1.55-.06,3.14-1.81,5.1-4.56,5.1ZM13.22,40.06c-1.92,0-3.49,1.35-3.49,3.01s1.57,3.03,3.49,3.03c2.12,0,2.6-1.76,2.63-3.24.02-.54,0-.96-.04-1.36-.01-.16-.02-.32-.03-.47-.65-.62-1.57-.97-2.56-.97ZM27.95,36.43c-1.7,0-3.68.78-3.68,2.97,0,1.66,1.56,3.01,3.49,3.01s3.49-1.35,3.49-3.01v-1.83c-.77-.71-1.99-1.13-3.3-1.13ZM17.7,23.96v3.98l13.55-1.76v-3.97l-13.55,1.75Z"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M12.12,12.23h-1.55v-1.37h1.55v1.37ZM15.75,4.46l1.98,5.72h.02l2-5.72h2.06v7.77h-1.57v-2.31l.15-3.44h-.04l-2.08,5.76h-1.05l-2.08-5.74h-.04l.15,3.42v2.31h-1.55v-7.77h2.04ZM24.82,9.41v2.82h-1.55v-7.77h3.09c.9,0,1.61.23,2.11.68.52.45.79,1.05.79,1.81s-.26,1.34-.79,1.79c-.51.45-1.22.68-2.11.68h-1.54ZM24.82,8.2h1.54c.45,0,.77-.11.99-.36.22-.22.34-.53.34-.9s-.11-.68-.34-.92c-.21-.24-.54-.36-.99-.36h-1.54v2.54ZM31.79,7.68h.88c.35,0,.64-.09.82-.28.17-.21.26-.47.26-.81,0-.32-.09-.56-.26-.75-.19-.19-.45-.28-.79-.28-.28,0-.54.08-.73.24-.21.17-.3.39-.3.68h-1.52l-.02-.04c-.02-.6.22-1.11.71-1.51.49-.39,1.09-.58,1.82-.58.8,0,1.44.19,1.93.56.49.4.71.94.71,1.66,0,.34-.09.66-.32.96-.21.3-.5.55-.88.71.43.15.77.39.99.7.23.32.34.7.34,1.11,0,.71-.26,1.28-.79,1.69-.5.4-1.18.6-1.98.6-.73,0-1.35-.19-1.87-.58-.5-.38-.77-.92-.75-1.62l.02-.02h1.52c0,.28.09.53.32.73.21.19.49.28.8.28.36,0,.66-.09.86-.3.21-.19.32-.47.32-.81,0-.4-.11-.7-.32-.88-.21-.21-.5-.3-.9-.3h-.88v-1.17Z"
      />
    </svg>
  );
}

export function Txticon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.6c-.18.18-.43.28-.69.28ZM1.93,59.08h28.02l13.96-14.04.16-43.13H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.73,2.54-8.28,8.24-8.28h7.24c.39,0,.74.23.89.59.15.36.07.77-.21,1.05l-14.52,14.6c-.18.18-.43.28-.69.28ZM37.63,46.4c-4.6,0-6.32,1.72-6.32,6.36v4.95l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.88"
        height="14.77"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M13.71,12.55h-1.67v-1.49h1.67v1.49ZM20.73,5.93h-2.19v6.62h-1.57v-6.62h-2.19v-1.22h5.95v1.22ZM24.36,7.49l1.46-2.78h1.82l-2.32,3.89,2.45,3.95h-1.89l-1.5-2.82-1.52,2.82h-1.82l2.38-3.95-2.32-3.89h1.82l1.44,2.78ZM33.96,5.93h-2.21v6.62h-1.55v-6.62h-2.19v-1.22h5.95v1.22Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M37.68,25.93h-9.69c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h9.69c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M37.68,32.7H8.3c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h29.38c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M37.68,39.47h-17.95c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h17.95c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M22.99,46.23h-14.69c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h14.69c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M21.72,25.93h-13.42c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h13.42c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M15.52,39.47h-7.22c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.22c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
    </svg>
  );
}

export function PptIcon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.42.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.6c-.18.18-.43.28-.68.28ZM1.93,59.08h28.02l13.96-14.04.16-43.13H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.73,2.54-8.28,8.24-8.28h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.04l-14.52,14.6c-.18.19-.43.28-.68.28ZM37.62,46.4c-4.6,0-6.32,1.72-6.32,6.36v4.95l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.77"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M13.18,12.53h-1.67v-1.47h1.67v1.47ZM16.38,9.69v2.84h-1.55v-7.83h3.11c.88,0,1.59.22,2.11.7.51.45.77,1.05.77,1.8s-.26,1.35-.77,1.81c-.52.45-1.24.68-2.11.68h-1.55ZM16.38,8.49h1.55c.43,0,.75-.11.97-.36.22-.24.34-.55.34-.9,0-.38-.11-.7-.32-.94-.22-.25-.56-.36-.99-.36h-1.55v2.56ZM23.53,9.69v2.84h-1.57v-7.83h3.11c.9,0,1.59.22,2.12.7.51.45.77,1.05.77,1.8s-.26,1.35-.77,1.81c-.52.45-1.22.68-2.12.68h-1.53ZM23.53,8.49h1.53c.43,0,.77-.11.99-.36.22-.24.34-.55.34-.9,0-.38-.11-.7-.34-.94-.22-.25-.56-.36-.99-.36h-1.53v2.56ZM34.48,5.93h-2.21v6.6h-1.55v-6.6h-2.19v-1.22h5.95v1.22Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.46,45.85c-.34,0-.66-.18-.84-.49l-3.35-5.95c-.26-.46-.09-1.05.37-1.31.46-.26,1.05-.1,1.31.37l3.35,5.95c.26.46.1,1.05-.37,1.31-.15.08-.31.12-.47.12ZM15.54,45.85c-.16,0-.32-.04-.47-.12-.46-.26-.63-.84-.37-1.31l3.35-5.95c.26-.46.85-.62,1.31-.37.46.26.63.84.37,1.31l-3.35,5.95c-.18.31-.5.49-.84.49Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M23.01,23.01c-.53,0-.96-.43-.96-.96v-2.05c0-.53.43-.96.96-.96s.96.43.96.96v2.05c0,.53-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M38.56,39.91H7.44c-.53,0-.96-.43-.96-.96v-16.9c0-.53.43-.96.96-.96h31.12c.53,0,.96.43.96.96v16.9c0,.53-.43.96-.96.96ZM8.4,37.99h29.19v-14.98H8.4v14.98Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M34.48,35.62c-.53,0-.96-.43-.96-.96v-8.18c0-.53.43-.96.96-.96s.96.43.96.96v8.18c0,.53-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M31.39,35.62c-.53,0-.96-.43-.96-.96l-.02-4.8c0-.53.43-.96.96-.96h0c.53,0,.96.43.96.96l.02,4.8c0,.53-.43.96-.96.96h0Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M28.29,35.62c-.53,0-.96-.43-.96-.96v-2.41c0-.53.43-.96.96-.96s.96.43.96.96v2.41c0,.53-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M20.93,27.43h-9.47c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h9.47c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M17.25,31.54h-5.78c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h5.78c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M23.16,35.62h-11.7c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h11.7c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
    </svg>
  );
}

export function PsdIcon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 60.98"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,60.99H.96c-.53,0-.96-.43-.96-.96V.95C0,.42.43-.01.96-.01h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.61c-.18.18-.43.28-.68.28ZM1.93,59.07h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,60.99c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.26c0-5.74,2.54-8.3,8.24-8.3h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.52,14.61c-.18.19-.43.28-.68.28ZM37.62,46.38c-4.6,0-6.32,1.73-6.32,6.38v4.93l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.06"
        y=".95"
        width="43.89"
        height="14.77"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M12.96,12.52h-1.55v-1.37h1.55v1.37ZM16.1,9.68v2.84h-1.55v-7.83h3.11c.9,0,1.59.23,2.12.68.51.47.77,1.07.77,1.83s-.26,1.34-.77,1.81c-.52.45-1.22.68-2.12.68h-1.55ZM16.1,8.48h1.55c.43,0,.77-.13.99-.36.22-.24.34-.55.34-.92s-.11-.68-.34-.92c-.22-.24-.56-.38-.99-.38h-1.55v2.58ZM25.89,10.47c0-.3-.11-.53-.32-.72-.21-.19-.58-.36-1.12-.51-.92-.28-1.63-.6-2.1-.96-.47-.38-.71-.88-.71-1.52s.26-1.17.82-1.58c.54-.39,1.24-.6,2.08-.6s1.55.23,2.1.68c.52.47.79,1.03.77,1.69v.04h-1.52c0-.36-.13-.64-.35-.87-.24-.22-.58-.34-1.03-.34-.41,0-.73.09-.95.28-.22.19-.36.41-.36.72,0,.26.13.47.37.64.24.17.67.36,1.27.55.86.23,1.5.55,1.95.94.45.4.65.92.65,1.56s-.26,1.19-.79,1.58c-.52.39-1.22.58-2.08.58s-1.59-.23-2.23-.66c-.62-.43-.94-1.05-.92-1.84l.02-.04h1.52c0,.47.13.81.43,1.02.28.23.67.34,1.18.34.43,0,.75-.09.97-.26.22-.19.34-.41.34-.72h0ZM28.64,12.52v-7.83h2.68c.94,0,1.72.3,2.34.92.62.6.94,1.39.94,2.35v1.3c0,.96-.32,1.73-.94,2.35-.62.6-1.4.9-2.34.9h-2.68ZM30.19,5.9v5.42h1.03c.56,0,1.01-.19,1.33-.58.32-.38.47-.87.47-1.49v-1.3c0-.6-.15-1.09-.47-1.49-.32-.38-.77-.56-1.33-.56h-1.03Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M18.46,45.2c-.2,0-.4-.06-.56-.18l-1.8-1.28c-.21-.15-.35-.38-.39-.64-.04-.26.03-.52.19-.73,1.79-2.31,3.55-5.04,5.4-7.93,3.99-6.22,8.12-12.65,13.03-15.31.32-.17.72-.15,1.02.06.3.21.45.58.39.94-.87,5.34-5.55,10.94-10.07,16.36-2.41,2.88-4.68,5.61-6.41,8.27-.14.22-.37.37-.63.42-.06,0-.12.02-.18.02ZM18.03,42.75l.18.13c1.72-2.51,3.88-5.1,5.99-7.62,3.64-4.37,7.39-8.86,8.98-13.03-3.65,2.96-7,8.18-10.25,13.24-1.67,2.61-3.27,5.09-4.9,7.28Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M11.22,54.93h0c-.58,0-1.21-.05-1.86-.16-.35-.06-.65-.31-.76-.65-.11-.34-.03-.71.22-.97,1.23-1.26,1.32-2.37,1.43-3.55.16-1.79.34-3.81,4.41-5.34.3-.11.64-.07.9.12l1.93,1.37c.19.14.33.34.38.57.32,1.44.33,3.7-.68,5.32-1.02,1.53-2.6,3.27-5.96,3.27ZM14.87,46.25c-2.47,1.03-2.56,1.99-2.69,3.52-.08.94-.18,2.05-.84,3.23,2.46-.03,3.48-1.25,4.23-2.39.58-.94.67-2.39.49-3.53l-1.19-.85Z"
      />
    </svg>
  );
}

export function DmgIcon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-3"
        fill="#00b3e8"
        d="M30.35,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.6c-.18.18-.43.28-.68.28ZM1.93,59.08h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-3"
        fill="#00b3e8"
        d="M30.35,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.73,2.54-8.28,8.24-8.28h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.04l-14.52,14.6c-.18.19-.43.28-.68.28ZM37.62,46.4c-4.6,0-6.32,1.72-6.32,6.36v4.95l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-3"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.77"
      />
      <path
        className="cls-2"
        fill="#fefefe"
        d="M11.65,12.55h-1.67v-1.49h1.67v1.49ZM13.3,12.55v-7.85h2.68c.95,0,1.74.32,2.36.92.62.62.92,1.39.92,2.35v1.3c0,.96-.3,1.75-.92,2.35-.62.6-1.4.92-2.36.92h-2.68ZM14.85,5.93v5.4h1.03c.56,0,1.01-.19,1.33-.56.32-.38.47-.88.47-1.49v-1.32c0-.6-.15-1.09-.47-1.47-.32-.38-.77-.56-1.33-.56h-1.03ZM22.5,4.7l2,5.78h.02l2-5.78h2.04v7.85h-1.55v-2.35l.15-3.44-.04-.02-2.08,5.81h-1.05l-2.08-5.79-.04.02.15,3.42v2.35h-1.57v-7.85h2.04ZM36.02,11.48c-.22.3-.6.56-1.09.81-.49.24-1.1.36-1.85.36-.95,0-1.74-.28-2.34-.88-.6-.6-.9-1.37-.9-2.31v-1.64c0-.94.28-1.71.86-2.31.58-.6,1.33-.9,2.25-.9s1.67.24,2.17.7c.51.47.77,1.09.79,1.84l-.02.04h-1.46c-.04-.43-.17-.75-.41-1-.22-.24-.58-.36-1.03-.36s-.86.19-1.16.55c-.28.38-.43.85-.43,1.43v1.66c0,.58.15,1.07.45,1.43.32.38.71.56,1.23.56.36,0,.66-.04.88-.11.21-.08.37-.17.49-.28v-1.43h-1.37v-1.09h2.94v2.95Z"
      />
      <path
        className="cls-3"
        fill="#00b3e8"
        d="M36.88,42.8H9.12c-1,0-1.81-.81-1.81-1.82v-8.88c0-.59.06-1.55.12-2.09.01-.1.04-.2.09-.29l5.66-10.61c.18-.87.99-1.56,1.9-1.56h16.28c.92,0,1.71.68,1.88,1.57l5.28,10.61c.04.09.07.18.08.27.06.59.1,1.54.1,2.09v8.88c0,1-.81,1.82-1.81,1.82ZM9.01,30.32c-.05.52-.09,1.3-.09,1.78v8.88c0,.12.09.22.21.22h27.75c.12,0,.21-.09.21-.22v-8.88c0-.47-.03-1.26-.08-1.79l-5.27-10.59c-.04-.09-.07-.18-.08-.28-.02-.16-.18-.3-.3-.3H15.07c-.13,0-.31.14-.32.3-.01.1-.04.2-.09.3l-5.65,10.58ZM34.11,40.01H11.89c-1,0-1.81-.81-1.81-1.82v-4.06c0-1,.81-1.82,1.81-1.82h22.21c1,0,1.81.81,1.81,1.82v4.06c0,1-.81,1.82-1.81,1.82ZM11.89,33.92c-.12,0-.21.11-.21.22v4.06c0,.12.09.22.21.22h22.21c.12,0,.21-.09.21-.22v-4.06c0-.1-.09-.22-.21-.22H11.89Z"
      />
      <path
        className="cls-1"
        fill="#00b3e8"
        d="M24.99,35.15h-11.08c-.54,0-1.01.47-1.01,1.02s.47,1.02,1.01,1.02h11.08c.56,0,1.01-.45,1.01-1.02s-.45-1.02-1.01-1.02h0ZM28.64,37.18c-.56,0-1.01-.45-1.01-1.02s.45-1,1.01-1,.99.45.99,1-.45,1.02-.99,1.02h0ZM32.09,37.18c-.56,0-1.01-.45-1.01-1.02s.45-1,1.01-1,.99.45.99,1-.45,1.02-.99,1.02h0Z"
      />
    </svg>
  );
}

export function AiIcon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.42.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.6c-.18.18-.43.28-.69.28ZM1.93,59.08h28.02l13.96-14.04.16-43.13H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.73,2.54-8.28,8.25-8.28h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.52,14.6c-.19.18-.43.28-.69.28ZM37.63,46.4c-4.61,0-6.32,1.72-6.32,6.36v4.95l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.77"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M18.35,12.53h-1.68v-1.47h1.68v1.47ZM24.51,10.72h-2.92l-.56,1.81h-1.7l2.88-8.38h1.7l2.87,8.38h-1.68l-.58-1.81ZM22,9.45h2.1l-1.03-3.33h-.04l-1.03,3.33ZM29.32,12.53h-1.67V4.16h1.67v8.38Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M38.97,29.63v-5.68h-5.63v1.9h-5.63v-3.78h-9.41v3.78h-5.63v-1.9h-5.65v5.68h5.65v-1.9h3.33c-4.31,2.5-7.09,7.17-7.09,12.29,0,.53.41.96.93.96s.94-.43.94-.96c0-4.95,3.03-9.45,7.52-11.33v2.82h9.41v-2.82c4.47,1.88,7.52,6.38,7.52,11.33,0,.53.41.96.93.96s.94-.43.94-.96c0-5.12-2.81-9.79-7.09-12.29h3.33v1.9h5.63ZM10.77,27.73h-1.87v-1.88h1.87v1.88ZM25.82,29.63h-5.63v-5.68h5.63v5.68ZM35.23,25.85h1.87v1.88h-1.87v-1.88Z"
      />
    </svg>
  );
}

export function HtmlIcon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28s.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.6c-.18.18-.43.29-.69.29ZM1.93,59.08h28.02l13.96-14.04.16-43.13H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,61c-.12,0-.25-.03-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.72,2.54-8.28,8.24-8.28h7.24c.39,0,.74.23.89.59.15.36.07.77-.21,1.05l-14.52,14.6c-.18.19-.43.29-.69.29ZM37.63,46.4c-4.6,0-6.32,1.72-6.32,6.36v4.95l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.88"
        height="14.77"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M8.71,12.55h-1.67v-1.49h1.67v1.49ZM16.65,12.55h-1.55v-3.26h-3.18v3.26h-1.55v-7.85h1.55v3.37h3.18v-3.37h1.55v7.85ZM23.5,5.93h-2.21v6.62h-1.55v-6.62h-2.21v-1.22h5.97v1.22ZM26.4,4.71l2,5.77h.02l2-5.77h2.04v7.85h-1.55v-2.35l.15-3.44-.04-.02-2.08,5.81h-1.05l-2.08-5.8-.04.02.15,3.42v2.35h-1.57v-7.85h2.04ZM35.49,11.33h3.46v1.22h-5.03v-7.85h1.57v6.62Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M17.15,40.98c-.32,0-.63-.12-.88-.35l-7.29-6.88s-.02-.02-.03-.03c-.11-.11-.19-.23-.26-.36-.08-.18-.12-.36-.12-.55,0-.18.04-.37.12-.54.06-.13.15-.26.26-.36,0,0,.02-.02.03-.03l7.29-6.9c.51-.49,1.33-.47,1.82.05.49.51.47,1.32-.05,1.81l-6.32,5.97,6.32,5.96c.52.48.54,1.29.05,1.81-.25.26-.59.4-.93.4ZM28.83,40.98c-.34,0-.68-.13-.94-.4-.49-.51-.46-1.32.05-1.81l6.33-5.96-6.33-5.97c-.52-.49-.54-1.3-.05-1.81.49-.51,1.3-.53,1.82-.05l7.31,6.9s.02.02.03.04c.1.11.19.22.25.35h0c.08.18.13.37.13.56s-.04.38-.13.55c-.06.13-.14.25-.25.35-.01,0-.02.02-.04.03l-7.31,6.88c-.25.23-.57.35-.88.35Z"
      />
    </svg>
  );
}

export function CssIcon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.47c0,.25-.1.49-.28.67l-14.52,14.61c-.18.18-.43.28-.68.28ZM1.93,59.08h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.35,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.26c0-5.74,2.54-8.3,8.24-8.3h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.52,14.61c-.18.18-.43.28-.68.28ZM37.62,46.4c-4.6,0-6.32,1.73-6.32,6.38v4.93l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.77"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M12.44,12.53h-1.68v-1.47h1.68v1.47ZM20.43,9.67v.04c.02.9-.26,1.62-.82,2.15-.56.53-1.35.79-2.34.79s-1.82-.32-2.45-.98c-.62-.64-.94-1.47-.94-2.5v-1.66c0-1.01.3-1.84.92-2.5.62-.66,1.4-.98,2.38-.98,1.03,0,1.83.26,2.41.79.58.55.88,1.26.86,2.18l-.02.04h-1.63c0-.56-.13-.98-.39-1.28-.26-.28-.67-.43-1.23-.43-.49,0-.9.21-1.18.6-.3.41-.45.94-.45,1.56v1.67c0,.64.15,1.17.47,1.58.3.39.73.6,1.25.6s.92-.13,1.16-.42c.24-.28.37-.71.37-1.26h1.63ZM26.12,10.35c0-.34-.11-.58-.34-.79-.22-.19-.62-.38-1.2-.55-.99-.28-1.74-.62-2.25-1.02-.51-.39-.77-.94-.77-1.64s.3-1.24.88-1.67c.58-.43,1.33-.66,2.23-.66s1.67.25,2.25.73c.58.49.86,1.09.84,1.81l-.02.04h-1.63c0-.38-.13-.7-.37-.92-.26-.24-.62-.36-1.09-.36s-.8.09-1.05.3c-.24.19-.36.45-.36.75,0,.28.13.51.39.7.26.19.71.38,1.35.57.92.26,1.61.6,2.1,1.03.47.41.71.96.71,1.66s-.28,1.28-.84,1.69c-.58.41-1.31.62-2.25.62s-1.7-.23-2.38-.7c-.67-.47-.99-1.13-.97-1.98v-.04h1.63c0,.49.15.87.47,1.09.3.23.71.34,1.25.34.47,0,.8-.09,1.05-.26.24-.21.36-.45.36-.75h0ZM33.56,10.35c0-.34-.11-.58-.34-.79-.22-.19-.64-.38-1.2-.55-.99-.28-1.74-.62-2.24-1.02-.51-.39-.77-.94-.77-1.64s.3-1.24.88-1.67c.58-.43,1.31-.66,2.23-.66s1.67.25,2.23.73c.58.49.86,1.09.84,1.81v.04h-1.63c0-.38-.13-.7-.39-.92-.24-.24-.62-.36-1.09-.36s-.79.09-1.03.3c-.24.19-.37.45-.37.75,0,.28.13.51.39.7.26.19.71.38,1.37.57.92.26,1.61.6,2.08,1.03.49.41.71.96.71,1.66s-.28,1.28-.84,1.69c-.56.41-1.31.62-2.23.62s-1.7-.23-2.38-.7c-.67-.47-1.01-1.13-.99-1.98l.02-.04h1.63c0,.49.15.87.45,1.09.3.23.73.34,1.27.34.45,0,.8-.09,1.05-.26.24-.21.35-.45.35-.75h0Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M28.08,41.78c-.53,0-.96-.43-.96-.96s.43-.96.96-.96c.7,0,1.36,0,1.6-.23.12-.11.31-.46.3-1.47l-.06-2.86c-.08-2.14.66-3.37,1.29-4.02.04-.04.07-.07.11-.11-.04-.03-.07-.07-.11-.11-.63-.65-1.36-1.87-1.29-4.03l.06-2.88c0-.99-.19-1.33-.3-1.45-.23-.23-.9-.23-1.6-.23-.53,0-.96-.43-.96-.96s.43-.96.96-.96c1.07,0,2.17,0,2.97.8.6.6.87,1.49.86,2.82l-.04,2.17s0,0,0,.01l-.02.73c-.04,1.17.22,2.1.75,2.64.31.32.69.48,1.13.48.53,0,.96.43.96.96s-.43.96-.96.96c-.44,0-.82.16-1.13.48-.52.54-.79,1.47-.75,2.63l.02.74s0,0,0,0h0l.04,2.15c0,1.35-.26,2.25-.86,2.85-.8.8-1.9.8-2.96.8ZM17.9,41.78c-1.06,0-2.16,0-2.96-.8-.6-.6-.87-1.51-.85-2.84l.02-2.13s0-.02,0-.03c0,0,0-.02,0-.03l.04-.73c.04-1.14-.22-2.07-.74-2.61-.31-.32-.7-.49-1.16-.49-.53,0-.96-.43-.96-.96s.43-.96.96-.96c.45,0,.84-.16,1.16-.49.52-.54.79-1.47.74-2.62l-.04-.71s0-.02,0-.03,0-.02,0-.03l-.02-2.16c-.02-1.32.25-2.22.84-2.82.8-.8,1.9-.8,2.96-.8.53,0,.96.43.96.96s-.43.96-.96.96c-.7,0-1.36,0-1.59.23-.11.11-.3.46-.29,1.45l.06,2.86c.08,2.17-.66,3.39-1.28,4.04-.04.04-.08.08-.12.11.04.04.08.08.12.11.63.65,1.36,1.87,1.28,4.02l-.04.73-.02,2.12c-.01,1.01.18,1.35.29,1.47.23.23.89.23,1.59.23.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
    </svg>
  );
}

export function XlsIcon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.42.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.6c-.18.18-.43.28-.68.28ZM1.93,59.08h28.02l13.96-14.04.16-43.13H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.73,2.54-8.28,8.24-8.28h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.04l-14.52,14.6c-.18.19-.43.28-.69.28ZM37.62,46.4c-4.6,0-6.31,1.72-6.31,6.36v4.95l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.77"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M13.67,12.55h-1.67v-1.49h1.67v1.49ZM18.07,7.49l1.46-2.78h1.82l-2.3,3.9,2.43,3.95h-1.89l-1.5-2.82-1.5,2.82h-1.84l2.38-3.95-2.32-3.9h1.82l1.44,2.78ZM23.85,11.33h3.46v1.22h-5.02v-7.85h1.55v6.62ZM32.42,10.5c0-.3-.11-.55-.32-.72-.21-.19-.58-.36-1.1-.53-.94-.26-1.65-.58-2.12-.96-.47-.36-.71-.86-.71-1.5s.28-1.17.82-1.58c.54-.41,1.23-.6,2.08-.6s1.55.23,2.1.68c.54.45.81,1.02.79,1.69l-.02.04h-1.52c0-.36-.11-.66-.35-.87-.24-.23-.58-.34-1.01-.34s-.75.1-.97.28c-.22.19-.34.41-.34.7,0,.26.11.49.35.66.24.17.67.34,1.27.53.86.25,1.52.57,1.95.96.45.4.67.9.67,1.54,0,.68-.26,1.21-.8,1.6-.52.38-1.22.58-2.08.58s-1.59-.23-2.23-.68c-.62-.43-.94-1.05-.92-1.84l.02-.02h1.52c0,.45.15.81.43,1.02.28.22.67.32,1.18.32.43,0,.75-.08.97-.26.22-.17.34-.4.34-.7h0Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M40.81,28.49H5.17c-.44,0-.8-.36-.8-.8v-5.59c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.59c0,.44-.36.8-.8.8ZM5.98,26.9h34.03v-3.99H5.98v3.99Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M40.81,34.1H5.17c-.44,0-.8-.36-.8-.8v-5.61c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.61c0,.44-.36.8-.8.8ZM5.98,32.5h34.03v-4.01H5.98v4.01Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M40.81,39.71H5.17c-.44,0-.8-.36-.8-.8v-5.61c0-.44.36-.8.8-.8h35.63c.44,0,.8.36.8.8v5.61c0,.44-.36.8-.8.8ZM5.98,38.11h34.03v-4.01H5.98v4.01Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M29.84,39.71h-13.7c-.44,0-.8-.36-.8-.8v-16.8c0-.44.36-.8.8-.8h13.7c.44,0,.8.36.8.8v16.8c0,.44-.36.8-.8.8ZM16.94,38.11h12.09v-15.2h-12.09v15.2Z"
      />
    </svg>
  );
}

export function ZipIcon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.47c0,.25-.1.49-.28.67l-14.52,14.61c-.18.18-.43.28-.68.28ZM1.93,59.08h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.34,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.26c0-5.74,2.54-8.3,8.24-8.3h7.24c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.52,14.61c-.18.19-.43.28-.69.28ZM37.62,46.39c-4.6,0-6.31,1.73-6.31,6.38v4.93l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.89"
        height="14.76"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M15.19,12.54h-1.68v-1.49h1.68v1.49ZM18.4,11.31h3.8v1.22h-5.69v-.83l3.71-5.8h-3.71v-1.21h5.6v.77l-3.71,5.84ZM24.94,12.54h-1.55v-7.83h1.55v7.83ZM28.06,9.69v2.84h-1.57v-7.83h3.11c.9,0,1.61.23,2.12.68.5.45.77,1.07.77,1.81s-.26,1.35-.77,1.81c-.51.47-1.22.7-2.12.7h-1.53ZM28.06,8.47h1.53c.43,0,.77-.11.99-.36.22-.23.34-.53.34-.9s-.11-.68-.34-.94c-.22-.24-.54-.36-.99-.36h-1.53v2.56Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M17.97,20.44h-7.26c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.26c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M17.97,24.51h-7.26c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.26c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M14.34,41.58c-.53,0-.96-.43-.96-.96V14.38c0-.53.43-.96.96-.96s.96.43.96.96v26.24c0,.53-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M17.97,28.57h-7.26c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.26c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M17.97,32.64h-7.26c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.26c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M17.97,36.68h-7.26c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.26c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M14.34,56.26c-1.75,0-3.49-.77-4.65-2.07-1.03-1.15-1.51-2.58-1.34-4.04l1.12-9.64c.06-.48.47-.85.96-.85h7.8c.49,0,.9.37.96.85l1.12,9.64c.17,1.46-.31,2.89-1.34,4.05-1.16,1.3-2.89,2.07-4.63,2.07ZM11.29,41.58l-1.02,8.79c-.1.9.2,1.81.86,2.54.8.9,2,1.43,3.22,1.43s2.39-.53,3.19-1.43c.66-.74.97-1.64.86-2.55l-1.02-8.79h-6.09Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M14.34,53.19c-.99,0-1.96-.44-2.6-1.19-.55-.65-.79-1.44-.66-2.24l.28-1.7c.08-.46.48-.8.95-.8h4.02c.47,0,.87.34.95.8l.28,1.69c.13.8-.1,1.6-.66,2.24-.64.74-1.6,1.19-2.58,1.19ZM13.14,49.18l-.15.89c-.04.24.04.47.22.68.27.31.71.51,1.13.51s.84-.2,1.11-.51c.13-.15.27-.39.22-.69l-.15-.89h-2.39Z"
      />
    </svg>
  );
}

export function ApkIcon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-3"
        fill="#00b3e8"
        d="M30.35,61H.96c-.53,0-.96-.43-.96-.96V.96C0,.43.43,0,.96,0h44.07c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.52,14.6c-.18.18-.43.28-.69.28ZM1.93,59.08h28.02l13.96-14.04.16-43.12H1.93v57.16Z"
      />
      <path
        className="cls-3"
        fill="#00b3e8"
        d="M30.35,61c-.12,0-.25-.02-.37-.07-.36-.15-.6-.5-.6-.89v-7.28c0-5.73,2.54-8.28,8.24-8.28h7.24c.39,0,.74.23.89.59.15.36.07.77-.21,1.04l-14.52,14.6c-.18.19-.43.28-.69.28ZM37.63,46.4c-4.6,0-6.32,1.72-6.32,6.36v4.95l11.25-11.31h-4.93Z"
      />
      <rect
        className="cls-3"
        fill="#00b3e8"
        x="1.06"
        y=".96"
        width="43.88"
        height="14.77"
      />
      <path
        className="cls-2"
        fill="#fefefe"
        d="M12.72,12.55h-1.67v-1.49h1.67v1.49ZM18.54,10.86h-2.73l-.52,1.69h-1.57l2.68-7.85h1.59l2.68,7.85h-1.57l-.54-1.69ZM16.2,9.65h1.97l-.97-3.11h-.02l-.97,3.11ZM22.93,9.71v2.84h-1.55v-7.85h3.11c.9,0,1.59.25,2.12.7.5.45.77,1.05.77,1.81s-.26,1.35-.77,1.81c-.53.47-1.22.7-2.12.7h-1.55ZM22.93,8.49h1.55c.43,0,.77-.11.99-.36.22-.23.34-.55.34-.9,0-.38-.11-.7-.34-.94-.23-.24-.56-.36-.99-.36h-1.55v2.56ZM30.94,9.28h-.86v3.27h-1.57v-7.85h1.57v3.22h.67l2.06-3.22h1.93l-2.64,3.67,2.84,4.18h-1.91l-2.1-3.27Z"
      />
      <path
        className="cls-1"
        fill="#00b3e8"
        d="M20.58,33.74l2.96-2.37c.34-.26.39-.75.13-1.09-.26-.36-.75-.41-1.09-.13l-3.14,2.48c-.97-.85-2.11-1.54-3.41-2.03-1.27-.47-2.58-.7-3.89-.73l-.71-3.93c-.08-.43-.49-.71-.9-.64-.43.07-.71.49-.64.9l.67,3.74c-4.19.51-7.99,3.27-9.58,7.53l-.02.04v.47c.08.22.22.41.47.49l20.42,7.73c.39.15.84-.04,1.01-.45,1.57-4.25.54-8.84-2.28-12h0ZM2.74,37.29c2.21-4.78,7.77-7.11,12.74-5.23,4.98,1.9,7.62,7.34,6.16,12.38l-18.9-7.15Z"
      />
      <path
        className="cls-1"
        fill="#00b3e8"
        d="M21.57,46.93L1.15,39.19c-.06-.02-.13-.04-.19-.04v2.79l.37-1,18.96,7.19-4.47,11.91h1.67l4.53-12.1c.15-.4-.04-.85-.45-1.02h0Z"
      />
      <path
        className="cls-1"
        fill="#00b3e8"
        d="M29.17,39.27c-1.4-.53-2.98.19-3.5,1.6l-3.86,10.25c-.52,1.43.19,3.01,1.59,3.54,1.4.55,2.99-.17,3.52-1.6l3.84-10.25c.54-1.41-.17-2.99-1.59-3.54h0ZM25.46,52.51c-.22.6-.9.92-1.5.68-.62-.22-.92-.9-.69-1.5l3.86-10.25c.22-.62.9-.92,1.5-.7.6.23.92.9.67,1.52l-3.84,10.25Z"
      />
      <path
        className="cls-1"
        fill="#00b3e8"
        d="M10.41,33.92c.58.23.86.87.66,1.43-.22.58-.86.87-1.42.66-.58-.23-.86-.87-.65-1.43.22-.58.86-.87,1.42-.66h0Z"
      />
      <path
        className="cls-1"
        fill="#00b3e8"
        d="M18.07,36.82c.56.23.86.87.64,1.43-.21.58-.84.87-1.42.66-.56-.23-.86-.87-.64-1.43.21-.58.84-.87,1.42-.66h0Z"
      />
    </svg>
  );
}

export function PptxIcon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 45.94 61.18"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.28,61.09H1.03c-.53,0-.96-.43-.96-.96V1.05C.07.52.5.09,1.03.09h43.88c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.46,14.61c-.18.18-.43.29-.68.29ZM1.99,59.17h27.9l13.9-14.04.16-43.12H1.99v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.28,61.09c-.12,0-.25-.02-.37-.07-.36-.15-.59-.5-.59-.89v-7.26c0-5.74,2.53-8.3,8.21-8.3h7.21c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.46,14.61c-.18.19-.43.29-.68.29ZM37.53,46.48c-4.58,0-6.29,1.73-6.29,6.38v4.93l11.2-11.31h-4.91Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.12"
        y="1.05"
        width="43.7"
        height="14.76"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M9.69,12.63h-1.66v-1.49h1.66v1.49ZM12.88,9.78v2.84h-1.55v-7.83h3.09c.89,0,1.58.23,2.11.68.5.47.76,1.07.76,1.81s-.26,1.36-.76,1.81c-.52.47-1.21.7-2.11.7h-1.55ZM12.88,8.56h1.55c.43,0,.76-.11.99-.36.22-.23.33-.53.33-.9s-.11-.68-.33-.94c-.22-.24-.56-.36-.99-.36h-1.55v2.56ZM20,9.78v2.84h-1.57v-7.83h3.09c.89,0,1.6.23,2.11.68.5.47.76,1.07.76,1.81s-.26,1.36-.76,1.81c-.5.47-1.21.7-2.11.7h-1.53ZM20,8.56h1.53c.43,0,.76-.11.99-.36.22-.23.33-.53.33-.9s-.11-.68-.33-.94c-.22-.24-.54-.36-.99-.36h-1.53v2.56ZM30.9,6h-2.2v6.62h-1.55v-6.62h-2.18v-1.2h5.92v1.2ZM34.5,7.56l1.45-2.77h1.83l-2.31,3.88,2.44,3.95h-1.88l-1.49-2.82-1.51,2.82h-1.81l2.35-3.95-2.29-3.88h1.81l1.42,2.77Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.4,45.94c-.34,0-.66-.18-.84-.49l-3.34-5.93c-.26-.46-.1-1.05.37-1.31.46-.26,1.05-.1,1.31.37l3.34,5.93c.26.46.1,1.05-.37,1.31-.15.08-.31.12-.47.12ZM15.54,45.94c-.16,0-.32-.04-.47-.12-.46-.26-.63-.85-.37-1.31l3.34-5.93c.26-.46.85-.63,1.31-.37.46.26.63.85.37,1.31l-3.34,5.93c-.18.31-.5.49-.84.49Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M22.98,23.09c-.53,0-.96-.43-.96-.96v-2.05c0-.53.43-.96.96-.96s.96.43.96.96v2.05c0,.53-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M38.47,40.01H7.48c-.53,0-.96-.43-.96-.96v-16.92c0-.53.43-.96.96-.96h30.99c.53,0,.96.43.96.96v16.92c0,.53-.43.96-.96.96ZM8.44,38.09h29.07v-15H8.44v15Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M34.4,35.72c-.53,0-.96-.43-.96-.96v-8.19c0-.53.43-.96.96-.96s.96.43.96.96v8.19c0,.53-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M31.33,35.72c-.53,0-.96-.43-.96-.96l-.02-4.82c0-.53.43-.96.96-.96.52.02.96.43.96.96l.02,4.82c0,.53-.43.96-.96.96h0Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M28.24,35.72c-.53,0-.96-.43-.96-.96v-2.41c0-.53.43-.96.96-.96s.96.43.96.96v2.41c0,.53-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M20.91,27.53h-9.43c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h9.43c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M17.24,31.62h-5.76c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h5.76c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M11.48,35.72c-.53,0-.96-.43-.96-.96,0-.53.43-.96.96-.96l11.65-.02h0c.53,0,.96.43.96.96,0,.53-.43.96-.96.96l-11.65.02h0Z"
      />
    </svg>
  );
}

export function RarIcon() {
  return (
    <svg
      id="_1"
      data-name="1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="45px"
      height="50px"
      viewBox="0 0 46 61"
    >
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.31,61H1.06c-.53,0-.96-.43-.96-.96V.96C.1.43.53,0,1.06,0h43.88c.26,0,.5.1.68.28.18.18.28.43.28.68l-.17,44.48c0,.25-.1.49-.28.67l-14.46,14.61c-.18.18-.43.29-.68.29ZM2.02,59.08h27.9l13.9-14.04.16-43.12H2.02v57.16Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M30.31,61c-.12,0-.25-.02-.37-.07-.36-.15-.59-.5-.59-.89v-7.26c0-5.74,2.53-8.3,8.21-8.3h7.21c.39,0,.74.23.89.59.15.36.07.77-.2,1.05l-14.46,14.61c-.18.19-.43.29-.68.29ZM37.56,46.39c-4.58,0-6.29,1.73-6.29,6.38v4.93l11.2-11.31h-4.91Z"
      />
      <rect
        className="cls-2"
        fill="#00b3e8"
        x="1.15"
        y=".96"
        width="43.7"
        height="14.78"
      />
      <path
        className="cls-1"
        fill="#fefefe"
        d="M12.82,12.53h-1.66v-1.47h1.66v1.47ZM16,9.41v3.12h-1.55v-7.83h2.93c.88,0,1.57.21,2.07.6.5.41.75.98.75,1.71,0,.39-.09.75-.32,1.04-.21.3-.5.53-.91.72.47.13.78.36.99.68.2.32.3.72.3,1.19v.56c0,.23.04.45.09.7.06.23.15.41.3.53v.11h-1.6c-.15-.11-.24-.3-.28-.58-.04-.26-.06-.51-.06-.75v-.56c0-.38-.11-.7-.32-.9-.22-.23-.52-.32-.89-.32h-1.49ZM16,8.19h1.34c.45,0,.76-.09.99-.28.2-.17.32-.45.32-.83,0-.36-.11-.64-.32-.85-.22-.21-.54-.32-.95-.32h-1.38v2.28ZM25.82,10.84h-2.72l-.52,1.69h-1.57l2.66-7.83h1.58l2.66,7.83h-1.57l-.54-1.69ZM23.49,9.64h1.96l-.97-3.11h-.02l-.97,3.11ZM30.2,9.41v3.12h-1.55v-7.83h2.93c.88,0,1.57.21,2.07.6.5.41.74.98.74,1.71,0,.39-.09.75-.32,1.04-.2.3-.5.53-.91.72.46.13.78.36.99.68.21.32.3.72.3,1.19v.56c0,.23.04.45.09.7.06.23.15.41.3.53v.11h-1.6c-.15-.11-.24-.3-.28-.58-.04-.26-.06-.51-.06-.75v-.56c0-.38-.11-.7-.32-.9-.22-.23-.52-.32-.89-.32h-1.49ZM30.2,8.19h1.34c.45,0,.76-.09.99-.28.2-.17.32-.45.32-.83,0-.36-.11-.64-.32-.85-.22-.21-.54-.32-.95-.32h-1.38v2.28Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M18,20.44h-7.23c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.23c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M18,24.51h-7.23c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.23c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M14.38,41.58c-.53,0-.96-.43-.96-.96V14.38c0-.53.43-.96.96-.96s.96.43.96.96v26.24c0,.53-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M18,28.57h-7.23c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.23c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M18,32.64h-7.23c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.23c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M18,36.7h-7.23c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h7.23c.53,0,.96.43.96.96s-.43.96-.96.96Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M14.38,56.27c-1.74,0-3.47-.78-4.63-2.07-1.03-1.16-1.51-2.6-1.34-4.06l1.12-9.64c.06-.48.47-.85.95-.85h7.77c.49,0,.9.36.95.85l1.12,9.64c.17,1.46-.31,2.9-1.34,4.06-1.16,1.3-2.88,2.07-4.6,2.07ZM11.34,41.58l-1.02,8.79c-.1.91.2,1.82.87,2.56.8.9,1.99,1.43,3.19,1.43s2.37-.53,3.17-1.43c.66-.74.97-1.66.87-2.56l-1.02-8.79h-6.06Z"
      />
      <path
        className="cls-2"
        fill="#00b3e8"
        d="M14.38,53.19c-.99,0-1.96-.45-2.6-1.19-.55-.64-.77-1.43-.64-2.22l.28-1.71c.08-.46.48-.8.95-.8h4.01c.47,0,.87.34.95.8l.28,1.71c.13.79-.1,1.57-.65,2.22-.63.75-1.6,1.19-2.57,1.19ZM13.18,49.18l-.15.91c-.05.28.09.52.21.66.27.31.71.52,1.13.52s.85-.2,1.11-.51c.12-.15.26-.38.22-.67l-.15-.91h-2.38Z"
      />
    </svg>
  );
}

export function UploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      style={{ background: "new 0 0 100 100", maxWidth: "100%" }}
      // xml:space="preserve"
      height="20px"
    >
      <path
        style={{}}
        d="M0,50c0,27.612,22.388,50,50.012,50C77.612,100,100,77.612,100,50c0-27.618-22.388-50-49.988-50  C22.388,0,0,22.382,0,50z M75,49.902H56.25V75h-12.5V49.902H25.098l24.914-24.908L75,49.902z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function GovernifyTeam() {
  return (
    <span style={{ width: "20px", color: "white" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="30"
        viewBox="0 0 300 140"
        preserveAspectRatio="xMidYMid meet"
        version="1.0"
        className="text-white"
      >
        <path
          d="M0 0 C14.30320657 10.6181839 23.36554803 26.29226497 26.3125 43.8125 C28.2598012 59.52197799 24.71369768 72.89906215 18 87 C10.93981586 86.12560667 5.42457977 82.9420895 -0.8125 79.6875 C-1.96943359 79.10548828 -3.12636719 78.52347656 -4.31835938 77.92382812 C-5.41599609 77.35470703 -6.51363281 76.78558594 -7.64453125 76.19921875 C-8.64846924 75.68190186 -9.65240723 75.16458496 -10.68676758 74.6315918 C-13 73 -13 73 -13.88330078 70.93481445 C-14.04063244 68.32633455 -13.21720068 66.83272865 -12.0625 64.5 C-8.8338293 56.85018789 -8.82196148 49.41458634 -11.6875 41.625 C-14.82401738 34.78168936 -18.88679789 29.9889819 -26 27 C-32.89471606 24.66190746 -39.79152837 24.78045264 -47 25 C-47.99 20.05 -47.99 20.05 -49 15 C-41.04530798 11.30937579 -31.55101938 12.11605318 -23.40234375 14.96875 C-11.51762192 20.07048425 -4.03128497 27.54780027 1.08984375 39.421875 C2.55955152 43.58499571 3.12608005 47.45759242 3.09765625 51.86328125 C3.09282227 53.19262695 3.09282227 53.19262695 3.08789062 54.54882812 C3.07532227 55.9168457 3.07532227 55.9168457 3.0625 57.3125 C3.05798828 58.24384766 3.05347656 59.17519531 3.04882812 60.13476562 C3.03709254 62.42320487 3.01915861 64.71161086 3 67 C6.3 68.65 9.6 70.3 13 72 C15.8132877 55.21176284 15.29607861 38.05235765 5.8203125 23.41015625 C-3.89325098 10.54906469 -15.21293016 3.86890284 -31 1 C-44.53187266 -0.37168185 -59.12945183 2.87090914 -69.91015625 11.53515625 C-70.41417969 11.99792969 -70.91820312 12.46070312 -71.4375 12.9375 C-74 15 -74 15 -76.5 15.0625 C-79.62500359 13.73437348 -82.25076518 11.9820065 -85 10 C-64.71909876 -16.15168844 -26.26360508 -17.18891682 0 0 Z "
          fill="#335795"
          transform="translate(101,13)"
        />
        <path
          d="M0 0 C3.91355482 0.60511142 6.91908625 1.80734707 10.4140625 3.65234375 C11.42210938 4.18150391 12.43015625 4.71066406 13.46875 5.25585938 C14.5103125 5.81080078 15.551875 6.36574219 16.625 6.9375 C18.19894531 7.76411133 18.19894531 7.76411133 19.8046875 8.60742188 C27.50378024 12.66918683 27.50378024 12.66918683 31 15 C30.49937703 18.80473457 29.61519612 22.29886342 28.4375 25.9375 C26.08225007 33.7225872 26.5643731 40.61285334 30 48 C34.42657974 54.63510985 39.31600096 59.12730384 47.00390625 61.4609375 C52.33578819 62.42025915 57.60853472 62.30857353 63 62 C64.34211745 65.8353791 65.35058876 68.90979782 65 73 C62.65281344 75.34718656 56.35708269 74.31109766 53.07250977 74.31689453 C46.64076907 74.21394601 41.62503201 73.25926945 36 70 C35.22398438 69.57589844 34.44796875 69.15179688 33.6484375 68.71484375 C24.57015601 63.26483864 17.88275325 54.32615383 15.24609375 44.06640625 C13.70703367 36.00328019 14.29940857 28.9927797 16 21 C14.730447 20.35165346 13.45930294 19.70642185 12.1875 19.0625 C11.47980469 18.70285156 10.77210937 18.34320313 10.04296875 17.97265625 C7.88189715 16.89269484 7.88189715 16.89269484 5 16 C1.75600579 33.64089414 2.6715739 50.2818054 13.08984375 65.5 C21.86772581 76.9884346 32.74905887 83.39688692 47 86 C61.30993047 87.50356707 73.6223052 84.30665684 86 77 C87.15494727 76.03474262 88.28678644 75.03991165 89.375 74 C90.24125 73.34 91.1075 72.68 92 72 C95.125 72.5625 95.125 72.5625 98 74 C99.175625 74.556875 99.175625 74.556875 100.375 75.125 C100.91125 75.41375 101.4475 75.7025 102 76 C101.10894423 81.45326133 97.22862696 83.83184375 93 87 C80.55296233 95.47533334 69.78669754 98.33347282 54.9375 98.5 C53.30530518 98.52791626 53.30530518 98.52791626 51.64013672 98.55639648 C34.69083405 98.42475886 20.79570402 90.75638501 9 79 C8.2884375 78.31164062 7.576875 77.62328125 6.84375 76.9140625 C-4.83366413 64.83243018 -8.45431918 50.35950223 -8.5 34 C-8.50400818 33.30668579 -8.50801636 32.61337158 -8.512146 31.89904785 C-8.5295112 19.6760675 -6.89826431 10.34739647 0 0 Z "
          fill="#3962A8"
          transform="translate(8,32)"
        />
        <path
          d="M0 0 C3.91355482 0.60511142 6.91908625 1.80734707 10.4140625 3.65234375 C11.42210938 4.18150391 12.43015625 4.71066406 13.46875 5.25585938 C14.5103125 5.81080078 15.551875 6.36574219 16.625 6.9375 C18.19894531 7.76411133 18.19894531 7.76411133 19.8046875 8.60742188 C27.50378024 12.66918683 27.50378024 12.66918683 31 15 C30.49937703 18.80473457 29.61519612 22.29886342 28.4375 25.9375 C26.7585994 31.43507647 26.34352596 35.7844001 28 41.375 C29.19281429 45.69895179 29.18158826 49.55108753 29 54 C25.535 54.495 25.535 54.495 22 55 C17.24890241 47.87335361 16.857842 39.80202258 16.875 31.4375 C16.87242188 30.17808594 16.86984375 28.91867188 16.8671875 27.62109375 C16.9883692 24.31711034 17.37077045 21.24103157 18 18 C17.443125 17.87625 16.88625 17.7525 16.3125 17.625 C13.77885636 16.94023145 11.42078968 16.00866237 9 15 C9 14.34 9 13.68 9 13 C7.04006395 13.21130782 7.04006395 13.21130782 5 14 C0.98510484 20.2850083 1.54926901 28.60604319 1.625 35.75 C1.61339844 36.85988281 1.60179687 37.96976563 1.58984375 39.11328125 C1.59371094 40.18449219 1.59757813 41.25570312 1.6015625 42.359375 C1.60494629 43.32327148 1.60833008 44.28716797 1.61181641 45.28027344 C2.06594148 48.46200506 3.25620276 50.33264869 5 53 C5.3984375 55.3515625 5.3984375 55.3515625 5.375 57.625 C5.38273438 58.38039062 5.39046875 59.13578125 5.3984375 59.9140625 C4.9104233 62.46896036 3.9691421 63.36425762 2 65 C2 64.01 2 63.02 2 62 C0.68 62 -0.64 62 -2 62 C-2.62817704 60.31368008 -3.25236893 58.62587549 -3.875 56.9375 C-4.22304687 55.99777344 -4.57109375 55.05804688 -4.9296875 54.08984375 C-5.28289063 53.07019531 -5.63609375 52.05054688 -6 51 C-6.36351562 49.98035156 -6.72703125 48.96070313 -7.1015625 47.91015625 C-11.09682381 33.45158669 -9.35890389 15.98293665 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z "
          fill="#497ACD"
          transform="translate(8,32)"
        />
        <path
          d="M0 0 C3.125 0.5625 3.125 0.5625 6 2 C7.175625 2.556875 7.175625 2.556875 8.375 3.125 C8.91125 3.41375 9.4475 3.7025 10 4 C9.10988005 9.44753411 5.23198062 11.84249421 1 15 C-10.39334559 22.51837304 -19.30680216 25.5086816 -32.9375 25.3125 C-34.05318359 25.31572266 -35.16886719 25.31894531 -36.31835938 25.32226562 C-44.52075779 25.26940893 -52.65524122 24.96848027 -60 21 C-60 20.34 -60 19.68 -60 19 C-60.99 18.67 -61.98 18.34 -63 18 C-61.68 16.35 -60.36 14.7 -59 13 C-59 13.99 -59 14.98 -59 16 C-58.01 15.34 -57.02 14.68 -56 14 C-54.09614201 14.19623098 -52.19215851 14.40519973 -50.30078125 14.69824219 C-46.21226536 15.23446944 -42.1171732 15.14371442 -38 15.125 C-36.72382812 15.13080078 -36.72382812 15.13080078 -35.421875 15.13671875 C-30.1920697 15.12869758 -25.17546723 14.75475564 -20 14 C-20 13.34 -20 12.68 -20 12 C-19.05898437 11.55269531 -18.11796875 11.10539062 -17.1484375 10.64453125 C-15.89041125 10.03429463 -14.63261071 9.42359253 -13.375 8.8125 C-12.44880859 8.37454102 -12.44880859 8.37454102 -11.50390625 7.92773438 C-8.2157646 6.31827557 -5.47888035 4.6644691 -2.734375 2.2265625 C-1.83203125 1.49179688 -0.9296875 0.75703125 0 0 Z "
          fill="#487ACF"
          transform="translate(100,104)"
        />
        <path
          d="M0 0 C7.53277185 2.10216889 11.19410672 5.65337827 15.0625 12.375 C24.4394439 29.15896008 25.89234982 46.70780708 21 65 C20.77054688 65.87269531 20.54109375 66.74539062 20.3046875 67.64453125 C19.26480285 70.96140471 18.52708184 72.6837509 15.5 74.5 C12.0204423 75.19591154 9.37502705 74.93104195 6 74 C7.06516922 71.51460515 8.00731493 69.99314225 10 68.125 C12.73724612 65.216676 14 62.01828832 14 58 C13.90073179 54.97796903 13.76260792 51.95799384 13.625 48.9375 C13.5940625 48.11572266 13.563125 47.29394531 13.53125 46.44726562 C13.29663418 41.4773204 12.63194743 36.8721428 11.46337891 32.0378418 C10.85208766 29.34951303 10.58358648 26.68388863 10.375 23.9375 C10.30023438 22.99777344 10.22546875 22.05804688 10.1484375 21.08984375 C10.09945312 20.40019531 10.05046875 19.71054687 10 19 C9.01 18.67 8.02 18.34 7 18 C4.73815567 16.20937324 3.84957656 14.69261298 2.5625 12.0625 C1.02964209 9.05809849 -0.50898822 7.23332091 -3 5 C-1.125 1.125 -1.125 1.125 0 0 Z "
          fill="#497CD3"
          transform="translate(104,21)"
        />
        <path
          d="M0 0 C2 1 4 2 6 3 C7.32860925 3.35169068 8.66158328 3.68770276 10 4 C8.84826645 6.46800047 7.95216435 8.04783565 6 10 C4.68 10 3.36 10 2 10 C-0.95416866 17.40886743 -1.45911863 23.81480897 -1.375 31.75 C-1.38660156 32.85988281 -1.39820313 33.96976563 -1.41015625 35.11328125 C-1.40628906 36.18449219 -1.40242187 37.25570312 -1.3984375 38.359375 C-1.39505371 39.32327148 -1.39166992 40.28716797 -1.38818359 41.28027344 C-0.93405852 44.46200506 0.25620276 46.33264869 2 49 C2.3984375 51.3515625 2.3984375 51.3515625 2.375 53.625 C2.38273438 54.38039062 2.39046875 55.13578125 2.3984375 55.9140625 C1.9104233 58.46896036 0.9691421 59.36425762 -1 61 C-1 60.01 -1 59.02 -1 58 C-2.32 58 -3.64 58 -5 58 C-5.62817704 56.31368008 -6.25236893 54.62587549 -6.875 52.9375 C-7.22304687 51.99777344 -7.57109375 51.05804688 -7.9296875 50.08984375 C-10.16388315 43.64003077 -11.36265315 38.10207291 -11.3125 31.3125 C-11.30758545 30.52447998 -11.3026709 29.73645996 -11.29760742 28.92456055 C-11.06221228 17.09082441 -8.56318644 8.38893555 0 0 Z "
          fill="#487BD0"
          transform="translate(11,36)"
        />
        <path
          d="M0 0 C2.10199129 2.09670991 3.75388668 4.29912183 5 7 C4.3125 9.9375 4.3125 9.9375 3 12 C-2.75 10.25 -2.75 10.25 -5 8 C-18.13943161 3.44611114 -32.57206952 4.76472737 -46.23535156 5.06591797 C-49 5 -49 5 -52 4 C-52 3.01 -52 2.02 -52 1 C-39.24490127 -6.68048956 -13.08071061 -8.04754078 0 0 Z "
          fill="#487DD5"
          transform="translate(92,8)"
        />
        <path
          d="M0 0 C1.3761145 0.00193359 1.3761145 0.00193359 2.7800293 0.00390625 C9.39867909 0.09774621 15.41871534 0.87068308 21.625 3.3125 C21.625 3.6425 21.625 3.9725 21.625 4.3125 C21.03726807 4.24393799 20.44953613 4.17537598 19.84399414 4.10473633 C13.24284358 3.38361308 6.70100059 3.06598907 0.0625 3 C-0.91396484 2.97099609 -1.89042969 2.94199219 -2.89648438 2.91210938 C-8.88500663 2.86003527 -13.19798453 3.63895965 -18.51538086 6.44848633 C-20.375 7.3125 -20.375 7.3125 -23.375 7.3125 C-23.375 8.3025 -23.375 9.2925 -23.375 10.3125 C-22.385 10.6425 -21.395 10.9725 -20.375 11.3125 C-20.705 11.9725 -21.035 12.6325 -21.375 13.3125 C-22.035 13.3125 -22.695 13.3125 -23.375 13.3125 C-23.60445312 14.06015625 -23.83390625 14.8078125 -24.0703125 15.578125 C-25.64256561 18.87326625 -27.23782459 20.04246545 -30.25 22.0625 C-31.11367188 22.65546875 -31.97734375 23.2484375 -32.8671875 23.859375 C-36.76631404 26.11868197 -36.76631404 26.11868197 -39.375 26.3125 C-41.515625 25.31640625 -41.515625 25.31640625 -43.625 23.875 C-44.33140625 23.40191406 -45.0378125 22.92882812 -45.765625 22.44140625 C-46.29671875 22.06886719 -46.8278125 21.69632813 -47.375 21.3125 C-35.78279803 6.36466062 -18.52939009 -0.10832931 0 0 Z "
          fill="#385E9E"
          transform="translate(63.375,1.6875)"
        />
        <path
          d="M0 0 C4.81177081 1.31488567 7.89756716 3.2184357 11.6875 6.4375 C12.61949219 7.21996094 13.55148438 8.00242187 14.51171875 8.80859375 C16.41712196 10.48666471 18.2418804 12.17132042 20 14 C19.67 14.66 19.34 15.32 19 16 C18.2575 15.46375 17.515 14.9275 16.75 14.375 C15.8425 13.92125 14.935 13.4675 14 13 C11.69712207 13.69140351 11.69712207 13.69140351 10 15 C10.9639104 17.15026166 11.71087924 18.74701933 13.5 20.3125 C15 22 15 22 16 25.625 C16.495 27.295625 16.495 27.295625 17 29 C18.485 29.495 18.485 29.495 20 30 C23.99689456 33.06783432 24.0110724 36.87986011 24.65234375 41.6328125 C25.18444196 47.26407177 25.21831326 52.91000872 25.25 58.5625 C25.25926514 59.62170654 25.26853027 60.68091309 25.27807617 61.7722168 C25.27396729 62.77679932 25.2698584 63.78138184 25.265625 64.81640625 C25.26336914 65.71818604 25.26111328 66.61996582 25.25878906 67.54907227 C24.98613032 70.13135633 24.30509386 71.77570275 23 74 C23.0314209 72.92069214 23.0314209 72.92069214 23.06347656 71.81958008 C23.98029903 52.93085468 23.98029903 52.93085468 19 35 C18.5875 34.12988281 18.175 33.25976562 17.75 32.36328125 C11.62497875 21.0006708 1.63385543 12.07665227 -10.5078125 7.75 C-23.40042638 3.93781027 -34.20121953 4.17529155 -47 8 C-48.41657512 8.39616084 -49.83322495 8.79205476 -51.25 9.1875 C-52.1575 9.455625 -53.065 9.72375 -54 10 C-53.34 8.68 -52.68 7.36 -52 6 C-51.34 6 -50.68 6 -50 6 C-50 5.34 -50 4.68 -50 4 C-35.15150642 0.852627 -13.32725021 0.59531269 -0.0625 8.6875 C0.948125 9.450625 1.95875 10.21375 3 11 C3.87754191 8.79561167 3.87754191 8.79561167 4 6 C2.16682624 2.70751892 2.16682624 2.70751892 0 0 Z "
          fill="#2F528C"
          transform="translate(92,9)"
        />
        <path
          d="M0 0 C7.53277185 2.10216889 11.19410672 5.65337827 15.0625 12.375 C24.52333241 29.30911362 25.68837579 46.56435284 21 65 C20.67 65 20.34 65 20 65 C20.0721875 63.99582031 20.144375 62.99164063 20.21875 61.95703125 C21.02830719 50.23861893 21.58394914 38.68162492 20 27 C16.47930015 27.58678331 14.28700157 28.35649921 11 30 C10.67 26.37 10.34 22.74 10 19 C9.01 18.67 8.02 18.34 7 18 C4.73815567 16.20937324 3.84957656 14.69261298 2.5625 12.0625 C1.02964209 9.05809849 -0.50898822 7.23332091 -3 5 C-1.125 1.125 -1.125 1.125 0 0 Z "
          fill="#497BD0"
          transform="translate(104,21)"
        />
        <path
          d="M0 0 C1.32 0.33 2.64 0.66 4 1 C4 1.66 4 2.32 4 3 C4.66 3 5.32 3 6 3 C7.63347575 9.06719565 8.23745682 14.99255347 8.3125 21.25 C8.33860352 22.25933594 8.33860352 22.25933594 8.36523438 23.2890625 C8.36065405 27.9243549 7.47165007 31.08703642 5 35 C4.01 35.66 3.02 36.32 2 37 C2 37.99 2 38.98 2 40 C0.35 39.34 -1.3 38.68 -3 38 C-2.855625 36.98421875 -2.71125 35.9684375 -2.5625 34.921875 C-1.09642908 24.21551022 -0.05002195 13.72487929 -2 3 C-1.34 3 -0.68 3 0 3 C0 2.01 0 1.02 0 0 Z "
          fill="#497CD3"
          transform="translate(94,47)"
        />
        <path
          d="M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C8.96870896 2.85580636 15.92978164 3.32943231 22.9375 3.71875 C26 4 26 4 27 5 C27.04092937 7.33297433 27.04241723 9.66705225 27 12 C18.55153694 16.22423153 6.49518637 11.3876057 -2 9 C-3.1640625 4.2890625 -3.1640625 4.2890625 -1.6875 1.6875 C-1.130625 1.130625 -0.57375 0.57375 0 0 Z "
          fill="#4B7BCF"
          transform="translate(44,92)"
        />
        <path
          d="M0 0 C3.125 0.5625 3.125 0.5625 6 2 C6.78375 2.37125 7.5675 2.7425 8.375 3.125 C8.91125 3.41375 9.4475 3.7025 10 4 C9.10988005 9.44753411 5.23198062 11.84249421 1 15 C-15.48453608 25.87800687 -15.48453608 25.87800687 -22.25 24.5625 C-22.8275 24.376875 -23.405 24.19125 -24 24 C-22.37478703 22.06006325 -21.47190573 21.09348228 -18.94921875 20.59375 C-18.20285156 20.5628125 -17.45648438 20.531875 -16.6875 20.5 C-12.54596369 20.18194084 -9.61764891 19.13348525 -6 17 C-6 16.01 -6 15.02 -6 14 C-4.68 13.67 -3.36 13.34 -2 13 C-2 12.01 -2 11.02 -2 10 C-2.99 10.33 -3.98 10.66 -5 11 C-5 10.34 -5 9.68 -5 9 C-6.65 9.33 -8.3 9.66 -10 10 C-10.33 10.99 -10.66 11.98 -11 13 C-13.97 13 -16.94 13 -20 13 C-17.61237819 10.61237819 -15.30366715 9.62697743 -12.25 8.1875 C-8.60028611 6.42361679 -5.52934991 4.83445914 -2.625 2 C-1.75875 1.34 -0.8925 0.68 0 0 Z "
          fill="#4A7ACD"
          transform="translate(100,104)"
        />
        <path
          d="M0 0 C0.99 0 1.98 0 3 0 C4.10141882 3.58849356 4.1357686 7.01300138 4.25 10.75 C4.59932351 16.45759092 5.52357463 19.78143283 8.921875 24.3125 C10.54323374 26.8502789 10.3638504 29.08919682 10 32 C6.535 32.495 6.535 32.495 3 33 C-1.83957402 25.74063896 -2.13779566 17.57090903 -2.0625 9.0625 C-2.05798828 8.37865234 -2.05347656 7.69480469 -2.04882812 6.99023438 C-2.0371956 5.32678396 -2.01926694 3.6633795 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z "
          fill="#497CD5"
          transform="translate(27,54)"
        />
        <path
          d="M0 0 C2.54173977 -0.02716824 5.08318415 -0.04691969 7.625 -0.0625 C8.33785156 -0.07087891 9.05070312 -0.07925781 9.78515625 -0.08789062 C13.97344438 -0.10710296 17.8728462 0.1732673 22 1 C22 1.33 22 1.66 22 2 C24.97 2.495 24.97 2.495 28 3 C27.42415568 5.38564077 26.77772405 7.66682784 26 10 C19.25 9.125 19.25 9.125 17 8 C14.2764805 8.08924852 11.58986689 8.23353332 8.875 8.4375 C7.74384766 8.51581055 7.74384766 8.51581055 6.58984375 8.59570312 C4.7262063 8.72545004 2.86305004 8.86207488 1 9 C0.67 6.03 0.34 3.06 0 0 Z "
          fill="#487DD5"
          transform="translate(54,28)"
        />
        <path
          d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C5.11375 2.185625 5.11375 2.185625 6.25 2.375 C8.81448542 2.9578376 10.69166512 3.78664449 13 5 C12.99476318 5.59949463 12.98952637 6.19898926 12.98413086 6.81665039 C12.96318557 9.56525602 12.95028444 12.31384478 12.9375 15.0625 C12.92912109 16.00544922 12.92074219 16.94839844 12.91210938 17.91992188 C12.88693224 25.14575929 13.14615973 31.61531716 16.125 38.3125 C17.2578125 40.86328125 17.2578125 40.86328125 18 43 C17.67 43.66 17.34 44.32 17 45 C9.19108409 32.74638668 7.99735669 22.11242357 11 8 C9.730447 7.35165346 8.45930294 6.70642185 7.1875 6.0625 C6.47980469 5.70285156 5.77210937 5.34320313 5.04296875 4.97265625 C2.88189715 3.89269484 2.88189715 3.89269484 0 3 C-2.642802 17.37160095 -1.73776104 29.8482255 2 44 C-1.56772137 42.21613931 -2.7755082 38.60498214 -4 35 C-4.56381598 30.86107816 -4.55973547 26.79652677 -4.5 22.625 C-4.51546875 21.5525 -4.5309375 20.48 -4.546875 19.375 C-4.51160835 12.12770411 -3.19811043 6.50367445 0 0 Z "
          fill="#284676"
          transform="translate(13,45)"
        />
        <path
          d="M0 0 C0 0.33 0 0.66 0 1 C-0.58773193 0.93143799 -1.17546387 0.86287598 -1.78100586 0.79223633 C-8.38215642 0.07111308 -14.92399941 -0.24651093 -21.5625 -0.3125 C-22.53896484 -0.34150391 -23.51542969 -0.37050781 -24.52148438 -0.40039062 C-30.51000663 -0.45246473 -34.82298453 0.32645965 -40.14038086 3.13598633 C-42 4 -42 4 -45 4 C-45 4.99 -45 5.98 -45 7 C-44.01 7.33 -43.02 7.66 -42 8 C-42.33 8.66 -42.66 9.32 -43 10 C-43.66 10 -44.32 10 -45 10 C-45.226875 10.61875 -45.45375 11.2375 -45.6875 11.875 C-47.37929835 14.61410209 -48.99244161 15.05024472 -52 16 C-52 15.34 -52 14.68 -52 14 C-52.99 14 -53.98 14 -55 14 C-55.8125 12.3125 -55.8125 12.3125 -56 10 C-52.12419015 4.60155057 -46.11821406 2.2256661 -40 0 C-39.01 0 -38.02 0 -37 0 C-37 -0.66 -37 -1.32 -37 -2 C-25.65346034 -4.9434538 -10.84194663 -4.26568392 0 0 Z "
          fill="#395FA4"
          transform="translate(85,5)"
        />
        <path
          d="M0 0 C3.47289095 2.90753661 5.94039259 5.52610203 7 10 C6.34 10.99 5.68 11.98 5 13 C-0.75 11.25 -0.75 11.25 -3 9 C-12.52277637 6.3949473 -22.16441485 5.43949456 -32 5 C-32 4.67 -32 4.34 -32 4 C-15.62184189 3.80806846 -15.62184189 3.80806846 -9 5 C-8.67 5.33 -8.34 5.66 -8 6 C-8 4.02 -8 2.04 -8 0 C-4.57930706 -1.14023098 -3.38312738 -1.12770913 0 0 Z "
          fill="#4775C5"
          transform="translate(90,7)"
        />
        <path
          d="M0 0 C0.33 0 0.66 0 1 0 C1.02505615 0.56509277 1.0501123 1.13018555 1.07592773 1.71240234 C1.19179956 4.26683742 1.31456537 6.8208955 1.4375 9.375 C1.47681641 10.26445313 1.51613281 11.15390625 1.55664062 12.0703125 C1.61948242 13.34648438 1.61948242 13.34648438 1.68359375 14.6484375 C1.72025146 15.43395996 1.75690918 16.21948242 1.79467773 17.02880859 C1.890891 19.07523496 1.890891 19.07523496 3 21 C2.34 21.33 1.68 21.66 1 22 C0.7525 22.86625 0.505 23.7325 0.25 24.625 C-1.34596553 28.93410693 -3.88581296 31.68995214 -7 35 C-3.78600767 35.08927756 -1.0937211 34.8534403 2 34 C2.66 34 3.32 34 4 34 C3.34 35.98 2.68 37.96 2 40 C-3.32257301 39.48072458 -6.75032135 38.16642723 -11 35 C-12.0625 31.375 -12.0625 31.375 -12 28 C-10 26 -10 26 -8.0546875 25.8046875 C-6.03645833 25.86979167 -4.01822917 25.93489583 -2 26 C-1.08877472 20.35652914 -0.70225954 14.77002113 -0.4375 9.0625 C-0.39431641 8.18787109 -0.35113281 7.31324219 -0.30664062 6.41210938 C-0.20153099 4.27488005 -0.10036015 2.13745762 0 0 Z "
          fill="#4370BB"
          transform="translate(117,60)"
        />
        <path
          d="M0 0 C3.91355482 0.60511142 6.91908625 1.80734707 10.4140625 3.65234375 C11.42210938 4.18150391 12.43015625 4.71066406 13.46875 5.25585938 C14.5103125 5.81080078 15.551875 6.36574219 16.625 6.9375 C18.19894531 7.76411133 18.19894531 7.76411133 19.8046875 8.60742188 C27.50378024 12.66918683 27.50378024 12.66918683 31 15 C30.44894091 18.9492568 29.61064629 22.34920174 28 26 C26.52470658 22.16423712 27.65360357 19.75140991 29 16 C18.1268772 9.99994628 18.1268772 9.99994628 6 8 C6 7.34 6 6.68 6 6 C2.33173827 6 1.64158305 6.5185129 -1 9 C-4.7634554 14.42380337 -6.00885892 19.51845897 -7 26 C-7.33 26 -7.66 26 -8 26 C-8.30989351 19.94360288 -7.53873719 15.71664216 -5.125 10.1875 C-4.72087891 9.20620117 -4.72087891 9.20620117 -4.30859375 8.20507812 C-3.0726369 5.25385434 -1.78003751 2.67005627 0 0 Z "
          fill="#254273"
          transform="translate(8,32)"
        />
        <path
          d="M0 0 C5.75 1.75 5.75 1.75 8 4 C7.625 7.625 7.625 7.625 7 11 C8.65 11.33 10.3 11.66 12 12 C12 14.31 12 16.62 12 19 C11.34 19.33 10.68 19.66 10 20 C5.25088045 18.12534755 3.96301816 15.33538311 1.98046875 10.94140625 C0.73290906 8.47113866 -0.91021574 6.79124366 -3 5 C-1.125 1.125 -1.125 1.125 0 0 Z "
          fill="#497CD4"
          transform="translate(104,21)"
        />
        <path
          d="M0 0 C0.680625 0.70125 1.36125 1.4025 2.0625 2.125 C3.03811394 3.08694988 4.01761175 4.04496939 5 5 C5.51949219 5.515625 6.03898437 6.03125 6.57421875 6.5625 C14.09145851 13.57158136 21.41740864 14.34734756 31.47265625 14.10546875 C32.72369141 14.05326172 32.72369141 14.05326172 34 14 C35.34211745 17.8353791 36.35058876 20.90979782 36 25 C33.87763479 27.12236521 29.36110131 26.23148154 26.4375 26.25 C25.25704102 26.2809375 25.25704102 26.2809375 24.05273438 26.3125 C18.36699994 26.34999866 14.21458907 25.26980968 9 23 C12.6585615 21.85519848 14.8287802 22.48266271 18.49609375 23.51953125 C23.59331028 24.49762428 28.83180869 24.14181013 34 24 C33.505 20.535 33.505 20.535 33 17 C32.41508789 16.98018066 31.83017578 16.96036133 31.22753906 16.93994141 C28.56791975 16.84446519 25.90906162 16.73487858 23.25 16.625 C22.32960938 16.5940625 21.40921875 16.563125 20.4609375 16.53125 C19.57148437 16.49257812 18.68203125 16.45390625 17.765625 16.4140625 C16.94868164 16.3826416 16.13173828 16.3512207 15.29003906 16.31884766 C12.83167042 15.97656307 11.14240001 15.2260723 9 14 C9 13.34 9 12.68 9 12 C8.34 12 7.68 12 7 12 C6.54625 11.236875 6.0925 10.47375 5.625 9.6875 C4.19410993 6.92083785 4.19410993 6.92083785 1.8125 5.4375 C1.214375 4.963125 0.61625 4.48875 0 4 C0 2.68 0 1.36 0 0 Z "
          fill="#1B2E54"
          transform="translate(37,80)"
        />
        <path
          d="M0 0 C0.33 0 0.66 0 1 0 C0.88543872 2.39674267 0.75871281 4.79181218 0.625 7.1875 C0.57859375 8.19780273 0.57859375 8.19780273 0.53125 9.22851562 C0.30006522 13.17792232 -0.13133122 16.48559134 -2 20 C-6.25066907 22.28882181 -9.4322565 22.26006717 -14 21 C-12.43542921 16.77565886 -9.61920511 14.55473302 -6 12 C-3.125 11.6875 -3.125 11.6875 -1 12 C-1.66 11.67 -2.32 11.34 -3 11 C-2.69217504 9.35328588 -2.37860766 7.70764424 -2.0625 6.0625 C-1.88847656 5.14597656 -1.71445313 4.22945313 -1.53515625 3.28515625 C-1 1 -1 1 0 0 Z "
          fill="#487CD3"
          transform="translate(124,74)"
        />
        <path
          d="M0 0 C2 1 4 2 6 3 C7.32860925 3.35169068 8.66158328 3.68770276 10 4 C8.84826645 6.46800047 7.95216435 8.04783565 6 10 C2.875 10.125 2.875 10.125 0 10 C0 9.34 0 8.68 0 8 C-2.04836882 8.56362302 -2.04836882 8.56362302 -4 10 C-4.81584568 13.05908413 -4.81584568 13.05908413 -5 16 C-5.33 16 -5.66 16 -6 16 C-6.27312207 10.62859937 -6.40444214 7.41316574 -3 3 C-1.3125 1.1875 -1.3125 1.1875 0 0 Z "
          fill="#497DD7"
          transform="translate(11,36)"
        />
        <path
          d="M0 0 C0.66 0.66 1.32 1.32 2 2 C-0.31 2 -2.62 2 -5 2 C-5 1.67 -5 1.34 -5 1 C-9.42682491 -0.0390378 -13.78934632 -0.31592951 -18.3125 -0.5625 C-19.05306641 -0.60568359 -19.79363281 -0.64886719 -20.55664062 -0.69335938 C-22.37091464 -0.79870432 -24.1854355 -0.89978316 -26 -1 C-25.67 1.97 -25.34 4.94 -25 8 C-23.68 7.67 -22.36 7.34 -21 7 C-15.30215845 6.59569771 -10.33769739 6.75254847 -5 9 C-8.14692933 9.97663324 -10.55637571 9.97784814 -13.8125 9.5625 C-17.92057895 9.08778865 -21.86817473 8.91017771 -26 9 C-26.66 5.7 -27.32 2.4 -28 -1 C-19.31597186 -5.02900381 -8.61864602 -3.81108485 0 0 Z "
          fill="#1E345F"
          transform="translate(80,29)"
        />
        <path
          d="M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C9.32097997 2.86859084 16.64748331 3.46589137 24 4 C24 4.33 24 4.66 24 5 C22.72382812 5.10957031 21.44765625 5.21914062 20.1328125 5.33203125 C18.46347228 5.49146262 16.79420495 5.65165855 15.125 5.8125 C13.86236328 5.91788086 13.86236328 5.91788086 12.57421875 6.02539062 C11.76855469 6.10595703 10.96289062 6.18652344 10.1328125 6.26953125 C9.01737061 6.37164917 9.01737061 6.37164917 7.87939453 6.47583008 C5.60154748 6.89086688 5.60154748 6.89086688 4 10 C1.03 9.505 1.03 9.505 -2 9 C-2.6875 6.75 -2.6875 6.75 -3 4 C-1.6875 1.6875 -1.6875 1.6875 0 0 Z "
          fill="#4775C8"
          transform="translate(44,92)"
        />
        <path
          d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C3.01 2 2.02 2 1 2 C-1.642802 16.37160095 -0.73776104 28.8482255 3 43 C-0.5703669 41.21481655 -1.78226225 37.60989728 -3 34 C-3.5400354 29.83980636 -3.51466484 25.7518038 -3.4375 21.5625 C-3.44458984 20.48162109 -3.45167969 19.40074219 -3.45898438 18.28710938 C-3.40600124 11.56640276 -2.47785219 6.25049716 0 0 Z "
          fill="#182B50"
          transform="translate(12,46)"
        />
        <path
          d="M0 0 C1.05058594 -0.01224609 2.10117187 -0.02449219 3.18359375 -0.03710938 C9.18177811 -0.04837005 14.41224197 0.29871109 20.125 2.1875 C20.785 2.8475 21.445 3.5075 22.125 4.1875 C21.05185547 3.9709375 21.05185547 3.9709375 19.95703125 3.75 C7.67312212 1.46166505 -2.88462774 1.60437126 -14.875 5.1875 C-16.29157512 5.58366084 -17.70822495 5.97955476 -19.125 6.375 C-20.0325 6.643125 -20.94 6.91125 -21.875 7.1875 C-21.215 5.8675 -20.555 4.5475 -19.875 3.1875 C-19.215 3.1875 -18.555 3.1875 -17.875 3.1875 C-17.875 2.5275 -17.875 1.8675 -17.875 1.1875 C-11.94190435 -0.09560892 -6.0388105 0.00367772 0 0 Z "
          fill="#264170"
          transform="translate(59.875,11.8125)"
        />
        <path
          d="M0 0 C3.70678873 1.53696118 5.17872343 3.8614286 7.5625 7.0625 C6.2425 6.7325 4.9225 6.4025 3.5625 6.0625 C3.2325 8.3725 2.9025 10.6825 2.5625 13.0625 C1.5725 12.7325 0.5825 12.4025 -0.4375 12.0625 C-0.7675 10.0825 -1.0975 8.1025 -1.4375 6.0625 C-2.076875 5.93875 -2.71625 5.815 -3.375 5.6875 C-4.055625 5.48125 -4.73625 5.275 -5.4375 5.0625 C-5.7675 4.4025 -6.0975 3.7425 -6.4375 3.0625 C-4.2312818 1.01970537 -3.05372536 0.07830065 0 0 Z "
          fill="#497ACF"
          transform="translate(86.4375,34.9375)"
        />
        <path
          d="M0 0 C6.20857963 6.20857963 6.86184051 19.48449119 7.1171875 27.93359375 C7.0887291 34.44582357 5.59852519 40.71427384 4 47 C3.67 47 3.34 47 3 47 C3.0721875 45.99582031 3.144375 44.99164063 3.21875 43.95703125 C4.58736494 26.21216374 4.58736494 26.21216374 1.75390625 8.75390625 C0.95949152 5.85202862 0.45095837 2.97282268 0 0 Z "
          fill="#1C3257"
          transform="translate(121,39)"
        />
        <path
          d="M0 0 C0.33 0.66 0.66 1.32 1 2 C3.02463255 2.65213292 3.02463255 2.65213292 5 3 C-2.01783344 8.49703883 -9.30695985 12.73839606 -18 15 C-20.3828125 14.625 -20.3828125 14.625 -22 14 C-20.37478703 12.06006325 -19.47190573 11.09348228 -16.94921875 10.59375 C-16.20285156 10.5628125 -15.45648438 10.531875 -14.6875 10.5 C-10.54596369 10.18194084 -7.61764891 9.13348525 -4 7 C-4 6.01 -4 5.02 -4 4 C-2.68 3.67 -1.36 3.34 0 3 C0 2.01 0 1.02 0 0 Z "
          fill="#203762"
          transform="translate(98,114)"
        />
        <path
          d="M0 0 C5.28 0 10.56 0 16 0 C16 0.33 16 0.66 16 1 C15.30132812 1.02578125 14.60265625 1.0515625 13.8828125 1.078125 C12.97273438 1.13484375 12.06265625 1.1915625 11.125 1.25 C10.22007813 1.29640625 9.31515625 1.3428125 8.3828125 1.390625 C5.82889456 1.75611148 5.82889456 1.75611148 4.6796875 4.046875 C4.45539062 4.69140625 4.23109375 5.3359375 4 6 C6.31 6.33 8.62 6.66 11 7 C11 7.33 11 7.66 11 8 C7.7 8.33 4.4 8.66 1 9 C0.67 6.03 0.34 3.06 0 0 Z "
          fill="#4F77C4"
          transform="translate(54,28)"
        />
        <path
          d="M0 0 C0.66 0.33 1.32 0.66 2 1 C1 4 1 4 -2.0625 6.375 C-5.26584338 8.66428578 -5.26584338 8.66428578 -5.375 11.8125 C-5.25125 12.534375 -5.1275 13.25625 -5 14 C-7.475 13.01 -7.475 13.01 -10 12 C-10 9 -10 9 -7.8125 6.73828125 C-6.884375 5.93777344 -5.95625 5.13726562 -5 4.3125 C-4.071875 3.50425781 -3.14375 2.69601563 -2.1875 1.86328125 C-1.1046875 0.94095703 -1.1046875 0.94095703 0 0 Z "
          fill="#314D81"
          transform="translate(27,12)"
        />
        <path
          d="M0 0 C3.48670834 1.1094072 6.77484237 2.26337666 10 4 C9.45773019 7.79588866 7.79872437 9.47211993 5 12 C4.34 11.67 3.68 11.34 3 11 C3.66 10.38125 4.32 9.7625 5 9.125 C7.2284549 7.24362573 7.2284549 7.24362573 7 5 C2.48382401 4.92345464 -1.59085217 4.89771304 -6 6 C-4 4 -2 2 0 0 Z "
          fill="#203762"
          transform="translate(100,104)"
        />
        <path
          d="M0 0 C4.0081803 3.67416528 6.52591615 7.14346504 9 12 C9 12.66 9 13.32 9 14 C8.34 14 7.68 14 7 14 C6.67 13.34 6.34 12.68 6 12 C5.01 12.495 5.01 12.495 4 13 C3.67 11.35 3.34 9.7 3 8 C1.68 7.67 0.36 7.34 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z "
          fill="#345993"
          transform="translate(112,25)"
        />
        <path
          d="M0 0 C0.60328125 0.08378906 1.2065625 0.16757813 1.828125 0.25390625 C3.02695313 0.40666016 3.02695313 0.40666016 4.25 0.5625 C5.03890625 0.66691406 5.8278125 0.77132812 6.640625 0.87890625 C9.01990719 1.00102173 10.7282873 0.65530174 13 0 C13.66 0 14.32 0 15 0 C14.34 1.98 13.68 3.96 13 6 C7.71862571 5.48474397 4.42778844 3.74522883 0 1 C0 0.67 0 0.34 0 0 Z "
          fill="#3E5C9D"
          transform="translate(106,94)"
        />
        <path
          d="M0 0 C0.680625 0.70125 1.36125 1.4025 2.0625 2.125 C8.67834394 8.85259859 8.67834394 8.85259859 17 13 C17 13.66 17 14.32 17 15 C14.39417629 15.93065133 13.35801776 16.14917407 10.75 15.0625 C10.1725 14.711875 9.595 14.36125 9 14 C9 13.34 9 12.68 9 12 C8.34 12 7.68 12 7 12 C6.54625 11.236875 6.0925 10.47375 5.625 9.6875 C4.19410993 6.92083785 4.19410993 6.92083785 1.8125 5.4375 C1.214375 4.963125 0.61625 4.48875 0 4 C0 2.68 0 1.36 0 0 Z "
          fill="#365690"
          transform="translate(37,80)"
        />
        <path
          d="M0 0 C0.33 0 0.66 0 1 0 C0.96519531 1.12535156 0.96519531 1.12535156 0.9296875 2.2734375 C0.80880364 9.12927937 1.35063873 15.34364917 3 22 C-0.26755825 18.95027897 -2.74883268 16.62679154 -3.1875 12.0390625 C-3.25 9.875 -3.25 9.875 -3 6 C-2.34 5.34 -1.68 4.68 -1 4 C-0.3574765 1.93125966 -0.3574765 1.93125966 0 0 Z "
          fill="#254071"
          transform="translate(34,58)"
        />
        <path
          d="M0 0 C5 5 10 10 15 15 C11.6875 14.875 11.6875 14.875 8 14 C6.3125 11.0625 6.3125 11.0625 5 8 C4.29875 7.67 3.5975 7.34 2.875 7 C2.25625 6.67 1.6375 6.34 1 6 C0.25 2.875 0.25 2.875 0 0 Z "
          fill="#233B65"
          transform="translate(19,96)"
        />
        <path
          d="M0 0 C0.33 0 0.66 0 1 0 C0.88543872 2.39674267 0.75871281 4.79181218 0.625 7.1875 C0.5940625 7.86103516 0.563125 8.53457031 0.53125 9.22851562 C0.29896078 13.19678975 -0.28387476 16.40729879 -2 20 C-2.33 20 -2.66 20 -3 20 C-3.09765625 13.84765625 -3.09765625 13.84765625 -3 12 C-2.67 11.67 -2.34 11.34 -2 11 C-2 10.01 -2 9.02 -2 8 C-1.17647059 1.17647059 -1.17647059 1.17647059 0 0 Z "
          fill="#3A63A5"
          transform="translate(124,74)"
        />
        <path
          d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C5.11375 2.185625 5.11375 2.185625 6.25 2.375 C8.80141485 2.95486701 10.7267573 3.73708739 13 5 C13.125 7.875 13.125 7.875 13 11 C12.34 11.66 11.68 12.32 11 13 C11 11.35 11 9.7 11 8 C8.36 6.68 5.72 5.36 3 4 C3 3.01 3 2.02 3 1 C2.01 0.67 1.02 0.34 0 0 Z "
          fill="#2D4B7D"
          transform="translate(13,45)"
        />
        <path
          d="M0 0 C-0.92683594 0.33773438 -1.85367188 0.67546875 -2.80859375 1.0234375 C-4.00613281 1.46945313 -5.20367187 1.91546875 -6.4375 2.375 C-7.63246094 2.81585938 -8.82742187 3.25671875 -10.05859375 3.7109375 C-13.10196898 4.67085236 -13.10196898 4.67085236 -14 7 C-15.84765625 7.6328125 -15.84765625 7.6328125 -18.0625 8.125 C-18.79597656 8.29257813 -19.52945313 8.46015625 -20.28515625 8.6328125 C-20.85105469 8.75398437 -21.41695312 8.87515625 -22 9 C-18.83107931 5.36366351 -15.3798134 3.51547651 -11 1.6875 C-10.38382813 1.41099609 -9.76765625 1.13449219 -9.1328125 0.84960938 C-5.76067643 -0.58680481 -3.47330758 -1.48483899 0 0 Z "
          fill="#4A75C0"
          transform="translate(52,5)"
        />
        <path
          d="M0 0 C2.475 0.99 2.475 0.99 5 2 C5 3.32 5 4.64 5 6 C5.66 6.33 6.32 6.66 7 7 C8.09506492 10.28519475 8.09960608 12.73663415 8.0625 16.1875 C8.05347656 17.27417969 8.04445313 18.36085938 8.03515625 19.48046875 C8.02355469 20.31191406 8.01195313 21.14335938 8 22 C7.67 22 7.34 22 7 22 C6.67 17.71 6.34 13.42 6 9 C5.34 9 4.68 9 4 9 C0 2.25 0 2.25 0 0 Z "
          fill="#4165A1"
          transform="translate(86,47)"
        />
        <path
          d="M0 0 C-0.33 1.32 -0.66 2.64 -1 4 C-1.99 4 -2.98 4 -4 4 C-4.33 4.99 -4.66 5.98 -5 7 C-7.97 7 -10.94 7 -14 7 C-11.79459886 4.79459886 -9.78605258 3.7599273 -7 2.375 C-6.113125 1.92898437 -5.22625 1.48296875 -4.3125 1.0234375 C-2 0 -2 0 0 0 Z "
          fill="#294476"
          transform="translate(94,110)"
        />
        <path
          d="M0 0 C1.125 3.75 1.125 3.75 0 6 C-0.66 6 -1.32 6 -2 6 C-2 6.66 -2 7.32 -2 8 C-2.99 8 -3.98 8 -5 8 C-5.75 6.25 -5.75 6.25 -6 4 C-2.77777778 0 -2.77777778 0 0 0 Z "
          fill="#477DD6"
          transform="translate(27,17)"
        />
        <path
          d="M0 0 C6.0546875 -0.1953125 6.0546875 -0.1953125 8 0 C10 2 10 2 10 6 C5.56909529 4.79157144 3.01887244 3.48331435 0 0 Z "
          fill="#365998"
          transform="translate(26,118)"
        />
        <path
          d="M0 0 C4.72284267 -0.73794417 7.55479825 1.23058746 11.42578125 3.61328125 C11.94527344 4.07089844 12.46476562 4.52851563 13 5 C13 5.99 13 6.98 13 8 C8.50202887 6.31326082 4.27113698 4.18326108 0 2 C0 1.34 0 0.68 0 0 Z "
          fill="#2C4D83"
          transform="translate(82,15)"
        />
        <path
          d="M0 0 C-2.22664317 0.985267 -4.45601317 1.96331444 -6.6875 2.9375 C-7.62625977 3.35418945 -7.62625977 3.35418945 -8.58398438 3.77929688 C-12.03484724 5.2788865 -15.27477406 6.43729857 -19 7 C-16.45398308 4.00468598 -13.65531543 2.75995951 -10.0625 1.25 C-9.02222656 0.80140625 -7.98195313 0.3528125 -6.91015625 -0.109375 C-3.98946545 -1.003224 -2.78743446 -1.10154037 0 0 Z "
          fill="#1B3257"
          transform="translate(48,5)"
        />
        <path
          d="M0 0 C0.33 0 0.66 0 1 0 C1.268125 1.134375 1.53625 2.26875 1.8125 3.4375 C2.95849272 8.04620455 4.44306645 12.51603139 6 17 C2.50325031 15.25162516 1.28362006 11.56357377 0 8 C-0.30968217 5.22693694 -0.20010953 2.80153338 0 0 Z "
          fill="#2D497E"
          transform="translate(9,72)"
        />
        <path
          d="M0 0 C0.33 0.66 0.66 1.32 1 2 C3.02463255 2.65213292 3.02463255 2.65213292 5 3 C0.375 7 0.375 7 -3 7 C-3.33 6.01 -3.66 5.02 -4 4 C-2.68 3.67 -1.36 3.34 0 3 C0 2.01 0 1.02 0 0 Z "
          fill="#325691"
          transform="translate(98,114)"
        />
        <path
          d="M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z M-6 2 C-4.02 2.99 -4.02 2.99 -2 4 C-2 3.34 -2 2.68 -2 2 C-1.34 2.33 -0.68 2.66 0 3 C0 4.98 0 6.96 0 9 C-2.04119788 7.38405168 -4.04072937 5.7143618 -6 4 C-6 3.34 -6 2.68 -6 2 Z "
          fill="#335B99"
          transform="translate(18,102)"
        />
        <path
          d="M0 0 C-0.33 0.99 -0.66 1.98 -1 3 C-3.31 3 -5.62 3 -8 3 C-7.67 2.01 -7.34 1.02 -7 0 C-2.25 -1.125 -2.25 -1.125 0 0 Z "
          fill="#447ED6"
          transform="translate(57,98)"
        />
        <path
          d="M0 0 C3.59634744 3.49359465 6.83451967 7.11098131 10 11 C6.01867611 9.31559374 3.10802023 6.96674659 0 4 C0 2.68 0 1.36 0 0 Z "
          fill="#17284A"
          transform="translate(37,80)"
        />
        <path
          d="M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 4.96 2.34 8.92 2 13 C1.67 13 1.34 13 1 13 C0.67 8.71 0.34 4.42 0 0 Z "
          fill="#456FB6"
          transform="translate(31,57)"
        />
        <path
          d="M0 0 C0.99 0.495 0.99 0.495 2 1 C2 2.32 2 3.64 2 5 C2.99 5.33 3.98 5.66 5 6 C4.67 7.65 4.34 9.3 4 11 C1.6870518 8.6870518 1.50419025 7.52095125 0.875 4.375 C0.70742188 3.55773437 0.53984375 2.74046875 0.3671875 1.8984375 C0.24601563 1.27195312 0.12484375 0.64546875 0 0 Z "
          fill="#4A78C0"
          transform="translate(3,83)"
        />
        <path
          d="M0 0 C0.66 0 1.32 0 2 0 C1.34 1.98 0.68 3.96 0 6 C-5.75 5.25 -5.75 5.25 -8 3 C-3.25 3.875 -3.25 3.875 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z "
          fill="#162F51"
          transform="translate(119,94)"
        />
        <path
          d="M0 0 C2.79872437 2.52788007 4.45773019 4.20411134 5 8 C4.34 8 3.68 8 3 8 C3 7.34 3 6.68 3 6 C2.01 6 1.02 6 0 6 C0 4.02 0 2.04 0 0 Z "
          fill="#2A487D"
          transform="translate(95,42)"
        />
        <path
          d="M0 0 C1.65 0.33 3.3 0.66 5 1 C5.33 2.98 5.66 4.96 6 7 C3.69 5.35 1.38 3.7 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z "
          fill="#345690"
          transform="translate(80,40)"
        />
        <path
          d="M0 0 C4.99275057 1.27721526 7.57611908 3.17330957 11 7 C5.58657319 5.85485202 3.0657052 4.65987191 0 0 Z "
          fill="#1B335E"
          transform="translate(92,9)"
        />
        <path
          d="M0 0 C0.99 0 1.98 0 3 0 C4 6.625 4 6.625 4 10 C1.16625119 6.79663178 0.4794463 4.21912747 0 0 Z "
          fill="#31568D"
          transform="translate(7,94)"
        />
        <path
          d="M0 0 C2.475 0.99 2.475 0.99 5 2 C5 4.31 5 6.62 5 9 C2.67527795 6.14693203 1.2491742 3.45925163 0 0 Z "
          fill="#243B6C"
          transform="translate(86,47)"
        />
      </svg>
    </span>
  );
}

export function ThumpsUp() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="16"
      height="16"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
    </svg>
  );
}

export function Reply() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="16"
      height="16"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <polyline points="9 14 4 9 9 4"></polyline>
      <path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>
    </svg>
  );
}
export function Clock() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6.93652V12.9365L16 14.9365M22 12.9365C22 18.4594 17.5228 22.9365 12 22.9365C6.47715 22.9365 2 18.4594 2 12.9365C2 7.41368 6.47715 2.93652 12 2.93652C17.5228 2.93652 22 7.41368 22 12.9365Z"
        stroke="#6F7490"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
}

export function AddFiles() {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 128.000000 128.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
        fill="#323338"
        stroke="none"
      >
        <path
          d="M952 1169 c-24 -5 -58 -17 -75 -28 -18 -11 -147 -136 -289 -278 -219
  -221 -257 -263 -263 -296 -27 -145 112 -238 236 -158 24 16 108 94 187 173
  120 123 142 149 142 175 0 31 -14 43 -48 43 -8 0 -90 -74 -182 -165 -114 -114
  -173 -165 -188 -165 -28 0 -62 34 -62 62 0 15 70 93 233 256 277 280 292 292
  360 292 44 0 54 -4 88 -38 43 -44 54 -76 44 -130 -6 -32 -49 -80 -323 -356
  -336 -337 -371 -366 -458 -366 -52 0 -137 43 -170 86 -53 68 -63 156 -27 229
  8 17 127 143 264 280 245 247 266 274 237 303 -30 30 -55 10 -315 -250 -237
  -240 -262 -268 -278 -317 -39 -120 -2 -258 90 -339 81 -71 204 -93 317 -57 49
  16 80 44 386 349 215 213 340 345 352 372 40 82 20 194 -46 260 -56 56 -130
  78 -212 63z"
        />
      </g>
    </svg>
  );
}

export function Emoji() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
      <line x1="9" y1="9" x2="9.01" y2="9"></line>
      <line x1="15" y1="9" x2="15.01" y2="9"></line>
    </svg>
  );
}

export function DownloadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
    >
      <path
        d="M20.75 14.5V18.6667C20.75 19.2192 20.5305 19.7491 20.1398 20.1398C19.7491 20.5305 19.2192 20.75 18.6667 20.75H4.08333C3.5308 20.75 3.00089 20.5305 2.61019 20.1398C2.21949 19.7491 2 19.2192 2 18.6667V14.5M6.16667 9.29167L11.375 14.5M11.375 14.5L16.5833 9.29167M11.375 14.5V2"
        stroke="#487ED8"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export const EmptyImage = () => {
  return (
    <svg viewBox="0 0 184 152" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(24 31.67)">
          <ellipse
            fillOpacity=".8"
            fill="#F5F5F7"
            cx="67.797"
            cy="106.89"
            rx="67.797"
            ry="12.668"
          ></ellipse>
          <path
            d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
            fill="#AEB8C2"
          ></path>
          <path
            d="M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z"
            fill="url(#linearGradient-1)"
            transform="translate(13.56)"
          ></path>
          <path
            d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
            fill="#F5F5F7"
          ></path>
          <path
            d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
            fill="#DCE0E6"
          ></path>
        </g>
        <path
          d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
          fill="#DCE0E6"
        ></path>
        <g transform="translate(149.65 15.383)" fill="#FFF">
          <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815"></ellipse>
          <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"></path>
        </g>
      </g>
    </svg>
  );
};

export function ServiceReportIconEmpty() {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 20 20"
      fill="#5c5f62"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7C9.20435 7 8.44129 7.31607 7.87868 7.87868C7.31607 8.44129 7 9.20435 7 10C7 10.7956 7.31607 11.5587 7.87868 12.1213C8.44129 12.6839 9.20435 13 10 13C10.7956 13 11.5587 12.6839 12.1213 12.1213C12.6839 11.5587 13 10.7956 13 10C13 9.20435 12.6839 8.44129 12.1213 7.87868C11.5587 7.31607 10.7956 7 10 7ZM11.5 10C11.5 10.3978 11.342 10.7794 11.0607 11.0607C10.7794 11.342 10.3978 11.5 10 11.5C9.60218 11.5 9.22064 11.342 8.93934 11.0607C8.65804 10.7794 8.5 10.3978 8.5 10C8.5 9.60218 8.65804 9.22064 8.93934 8.93934C9.22064 8.65804 9.60218 8.5 10 8.5C10.3978 8.5 10.7794 8.65804 11.0607 8.93934C11.342 9.22064 11.5 9.60218 11.5 10ZM9.34062 2C8.64687 2 8.04375 2.475 7.88125 3.14688L7.625 4.21875L7.59062 4.23125L6.65312 3.65625C6.0625 3.29375 5.3 3.38437 4.80938 3.875L3.87812 4.80938C3.3875 5.3 3.29688 6.0625 3.65937 6.65312L4.23438 7.59062L4.21875 7.625L3.15 7.88438C2.475 8.04375 2 8.64687 2 9.34062V10.6594C2 11.3531 2.475 11.9562 3.14688 12.1187L4.21875 12.375L4.23125 12.4094L3.65625 13.3469C3.29375 13.9375 3.38437 14.7 3.875 15.1906L4.80625 16.1219C5.29688 16.6125 6.05938 16.7031 6.65 16.3406L7.5875 15.7656L7.62187 15.7781L7.88125 16.8469C8.04375 17.5219 8.64687 17.9937 9.34062 17.9937H10.6594C11.3531 17.9937 11.9562 17.5188 12.1187 16.8469L12.375 15.7812L12.4094 15.7688L13.3469 16.3438C13.9375 16.7063 14.7 16.6156 15.1906 16.125L16.1219 15.1938C16.6125 14.7031 16.7031 13.9406 16.3406 13.35L15.7656 12.4125L15.7781 12.3781L16.8469 12.1187C17.5219 11.9562 17.9937 11.3531 17.9937 10.6594V9.34062C17.9937 8.64687 17.5188 8.04375 16.8469 7.88125L15.7812 7.625L15.7688 7.59062L16.3438 6.65312C16.7063 6.0625 16.6156 5.3 16.125 4.80938L15.1906 3.87812C14.7 3.3875 13.9375 3.29688 13.3469 3.65937L12.4094 4.23438L12.375 4.21875L12.1156 3.15C11.9563 2.475 11.3531 2 10.6594 2H9.34062ZM9.34062 3.5H10.6594L11.0125 4.95625C11.0719 5.20625 11.2594 5.40937 11.5031 5.49062C11.7156 5.5625 11.925 5.64688 12.125 5.74688C12.3562 5.8625 12.6312 5.85 12.8531 5.71563L14.1313 4.93438L15.0625 5.86875L14.2812 7.14687C14.1469 7.36875 14.1344 7.64375 14.25 7.875C14.35 8.075 14.4375 8.28125 14.5063 8.49687C14.5875 8.74375 14.7906 8.92813 15.0406 8.9875L16.5 9.34062V10.6594L15.0437 11.0125C14.7937 11.0719 14.5906 11.2594 14.5094 11.5031C14.4375 11.7156 14.3531 11.925 14.2531 12.125C14.1375 12.3562 14.15 12.6312 14.2844 12.8531L15.0656 14.1313L14.1313 15.0625L12.8531 14.2812C12.6312 14.1469 12.3562 14.1344 12.125 14.25C11.925 14.35 11.7188 14.4375 11.5031 14.5063C11.2563 14.5875 11.0719 14.7906 11.0125 15.0406L10.6594 16.5H9.34062L8.9875 15.0437C8.92813 14.7937 8.74062 14.5906 8.49687 14.5094C8.28437 14.4375 8.075 14.3531 7.875 14.2531C7.64375 14.1375 7.36875 14.15 7.14687 14.2844L5.86875 15.0656L4.9375 14.1313L5.71875 12.8531C5.85313 12.6312 5.86562 12.3562 5.75 12.125C5.65 11.925 5.5625 11.7188 5.49375 11.5031C5.4125 11.2563 5.20937 11.0719 4.95937 11.0125L3.5 10.6594V9.34062L4.95625 8.9875C5.20625 8.92813 5.40937 8.74062 5.49062 8.49687C5.5625 8.28437 5.64688 8.075 5.74688 7.875C5.8625 7.64375 5.85 7.36875 5.71563 7.14687L4.9375 5.86875L5.86875 4.9375L7.14687 5.71875C7.36875 5.85313 7.64375 5.86562 7.875 5.75C8.075 5.65 8.28125 5.5625 8.49687 5.49375C8.74375 5.4125 8.92813 5.20937 8.9875 4.95937L9.34062 3.5Z"
        fill="#5c5f62"
      />
    </svg>
  );
}

export function ExportReportViewIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_33_1119)">
        <path
          d="M12.4444 16H3.55555C2.60588 16 1.71302 15.6302 1.04142 14.9586C0.369847 14.287 0 13.3941 0 12.4444V11.5555C0 11.0646 0.397948 10.6666 0.888894 10.6666C1.37984 10.6666 1.77779 11.0646 1.77779 11.5555V12.4444C1.77779 12.9193 1.96273 13.3657 2.29845 13.7015C2.63426 14.0372 3.08068 14.2222 3.55555 14.2222H12.4444C12.9193 14.2222 13.3657 14.0372 13.7015 13.7015C14.0372 13.3656 14.2222 12.9192 14.2222 12.4444V11.5555C14.2222 11.0646 14.6202 10.6666 15.1111 10.6666C15.602 10.6666 16 11.0646 16 11.5555V12.4444C16 13.3941 15.6302 14.2869 14.9586 14.9586C14.287 15.6302 13.3941 16 12.4444 16ZM7.99998 12.4444C7.76788 12.4447 7.54491 12.3539 7.37903 12.1916L7.37897 12.1915L7.3772 12.1898L7.3767 12.1893C7.3762 12.1888 7.37577 12.1884 7.3753 12.1879L7.3744 12.187C7.37408 12.1867 7.37375 12.1864 7.37341 12.186L7.37148 12.1841L3.81591 8.62852C3.46879 8.2814 3.46879 7.71857 3.81591 7.37142C4.16302 7.0243 4.72588 7.02427 5.073 7.37142L7.11112 9.40954V0.888894C7.11109 0.397948 7.50904 0 7.99998 0C8.49093 0 8.88891 0.397948 8.88891 0.888894V9.40951L10.927 7.37142C11.2741 7.0243 11.837 7.0243 12.1841 7.37142C12.5312 7.71854 12.5312 8.2814 12.1841 8.62852L8.62852 12.1841L8.62659 12.186L8.6256 12.1869L8.6247 12.1878C8.62426 12.1883 8.62377 12.1888 8.62333 12.1892L8.6228 12.1897C8.62224 12.1903 8.62166 12.1909 8.62106 12.1915L8.621 12.1915C8.61122 12.201 8.60132 12.2103 8.59119 12.2193C8.51863 12.2841 8.43585 12.3366 8.3462 12.3744L8.34533 12.3748C8.34499 12.3749 8.34471 12.3751 8.34437 12.3752C8.23535 12.421 8.11825 12.4446 7.99998 12.4444Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_1119">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ChartColumnSvg() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.39995 4.79999C5.06495 4.79999 5.59995 5.33499 5.59995 5.99999V23.6C5.59995 24.265 6.13495 24.8 6.79995 24.8H27.6C28.265 24.8 28.8 25.335 28.8 26C28.8 26.665 28.265 27.2 27.6 27.2H6.79995C4.80995 27.2 3.19995 25.59 3.19995 23.6V5.99999C3.19995 5.33499 3.73495 4.79999 4.39995 4.79999ZM11.6 14.4C12.265 14.4 12.8 14.935 12.8 15.6V19.6C12.8 20.265 12.265 20.8 11.6 20.8C10.935 20.8 10.4 20.265 10.4 19.6V15.6C10.4 14.935 10.935 14.4 11.6 14.4ZM17.6 10.8V19.6C17.6 20.265 17.065 20.8 16.4 20.8C15.735 20.8 15.2 20.265 15.2 19.6V10.8C15.2 10.135 15.735 9.59999 16.4 9.59999C17.065 9.59999 17.6 10.135 17.6 10.8ZM21.2 12.8C21.865 12.8 22.4 13.335 22.4 14V19.6C22.4 20.265 21.865 20.8 21.2 20.8C20.535 20.8 20 20.265 20 19.6V14C20 13.335 20.535 12.8 21.2 12.8ZM27.2 7.59999V19.6C27.2 20.265 26.665 20.8 26 20.8C25.335 20.8 24.8 20.265 24.8 19.6V7.59999C24.8 6.93499 25.335 6.39999 26 6.39999C26.665 6.39999 27.2 6.93499 27.2 7.59999Z"
        fill="#8C9196"
      />
    </svg>
  );
}

export function ChartPieSvg() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8 15.2V4.03C16.8 3.58 17.15 3.2 17.6 3.2C23.785 3.2 28.8 8.215 28.8 14.4C28.8 14.85 28.42 15.2 27.97 15.2H16.8ZM3.19995 16.8C3.19995 10.735 7.70495 5.715 13.55 4.915C14.01 4.85 14.4 5.22 14.4 5.685V17.6L22.225 25.425C22.56 25.76 22.535 26.31 22.15 26.58C20.19 27.98 17.79 28.8 15.2 28.8C8.57495 28.8 3.19995 23.43 3.19995 16.8ZM29.52 17.6C29.985 17.6 30.35 17.99 30.29 18.45C29.905 21.245 28.56 23.73 26.595 25.565C26.295 25.845 25.825 25.825 25.535 25.53L17.6 17.6H29.52Z"
        fill="#8C9196"
      />
    </svg>
  );
}

export const Credentials = ({ fill, width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={width}
      height={height}
      fill={fill}
    >
      <path d="M 20 3 C 15.054688 3 11 7.054688 11 12 C 11 12.519531 11.085938 12.976563 11.15625 13.4375 L 3.28125 21.28125 L 3 21.59375 L 3 29 L 10 29 L 10 26 L 13 26 L 13 23 L 16 23 L 16 20.03125 C 17.179688 20.609375 18.554688 21 20 21 C 24.945313 21 29 16.945313 29 12 C 29 7.054688 24.945313 3 20 3 Z M 20 5 C 23.855469 5 27 8.144531 27 12 C 27 15.855469 23.855469 19 20 19 C 18.789063 19 17.542969 18.644531 16.59375 18.125 L 16.34375 18 L 14 18 L 14 21 L 11 21 L 11 24 L 8 24 L 8 27 L 5 27 L 5 22.4375 L 12.90625 14.5 L 13.28125 14.15625 L 13.1875 13.625 C 13.085938 13.023438 13 12.488281 13 12 C 13 8.144531 16.144531 5 20 5 Z M 22 8 C 20.894531 8 20 8.894531 20 10 C 20 11.105469 20.894531 12 22 12 C 23.105469 12 24 11.105469 24 10 C 24 8.894531 23.105469 8 22 8 Z" />
    </svg>
  );
};

export const CountryIcon = () => {
  return (
    <svg
      width="89"
      height="97"
      viewBox="0 0 89 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M80.6483 24.7799C79.7937 24.7797 78.9582 25.033 78.2475 25.5077C77.5368 25.9825 76.9828 26.6573 76.6556 27.4468C76.3284 28.2364 76.2428 29.1052 76.4094 29.9435C76.576 30.7818 76.9875 31.5518 77.5918 32.1562C78.1961 32.7606 78.966 33.1722 79.8043 33.339C80.6425 33.5058 81.5114 33.4203 82.301 33.0932C83.0906 32.7662 83.7655 32.2123 84.2404 31.5017C84.7152 30.7911 84.9687 29.9556 84.9687 29.101C84.9675 27.9555 84.5119 26.8572 83.702 26.0471C82.8921 25.237 81.7939 24.7813 80.6483 24.7799ZM80.6483 31.0783C80.2572 31.0785 79.8748 30.9626 79.5496 30.7455C79.2243 30.5283 78.9707 30.2195 78.821 29.8582C78.6712 29.4969 78.6319 29.0993 78.7081 28.7157C78.7843 28.3321 78.9726 27.9797 79.2491 27.7031C79.5256 27.4264 79.8779 27.238 80.2615 27.1617C80.6451 27.0853 81.0427 27.1244 81.4041 27.2741C81.7654 27.4237 82.0743 27.6772 82.2916 28.0023C82.5089 28.3275 82.6249 28.7099 82.6249 29.101C82.6245 29.6252 82.4161 30.1278 82.0456 30.4985C81.675 30.8693 81.1725 31.0778 80.6483 31.0785V31.0783ZM30.4335 14.1961C31.4403 14.1965 32.4247 13.8983 33.2621 13.3393C34.0994 12.7802 34.7522 11.9854 35.1378 11.0553C35.5234 10.1252 35.6245 9.10167 35.4283 8.11412C35.2322 7.12657 34.7475 6.21938 34.0357 5.50728C33.3239 4.79518 32.417 4.31017 31.4295 4.11359C30.442 3.91701 29.4184 4.01769 28.4882 4.40289C27.5579 4.7881 26.7628 5.44052 26.2034 6.27766C25.644 7.11479 25.3454 8.09902 25.3454 9.10586C25.3466 10.4551 25.883 11.7488 26.8369 12.7031C27.7907 13.6574 29.0842 14.1943 30.4335 14.1961ZM30.4335 6.35938C30.9768 6.35895 31.508 6.51967 31.9599 6.8212C32.4119 7.12273 32.7642 7.55152 32.9725 8.05334C33.1807 8.55515 33.2353 9.10745 33.1296 9.64036C33.0239 10.1733 32.7625 10.6628 32.3785 11.0472C31.9944 11.4315 31.5051 11.6933 30.9722 11.7994C30.4394 11.9056 29.8871 11.8513 29.3851 11.6435C28.8831 11.4357 28.4541 11.0837 28.1522 10.6319C27.8503 10.1802 27.6892 9.64916 27.6892 9.10586C27.6897 8.37798 27.9789 7.68003 28.4934 7.16513C29.0079 6.65024 29.7056 6.36046 30.4335 6.35938ZM50.1056 43.7766C50.1051 42.7703 49.8064 41.7868 49.247 40.9504C48.6877 40.1139 47.8929 39.4621 46.9631 39.0773C46.0334 38.6925 45.0104 38.5921 44.0235 38.7887C43.0367 38.9852 42.1303 39.47 41.4189 40.1817C40.7075 40.8933 40.2232 41.7999 40.027 42.7869C39.8309 43.7738 39.9317 44.7967 40.3169 45.7263C40.7021 46.6559 41.3542 47.4505 42.1909 48.0094C43.0276 48.5684 44.0112 48.8668 45.0175 48.8668C46.3667 48.865 47.6602 48.328 48.6141 47.3738C49.5679 46.4195 50.1043 45.1258 50.1056 43.7766ZM45.0175 46.523C44.4742 46.5235 43.943 46.3628 43.491 46.0612C43.0391 45.7597 42.6867 45.3309 42.4785 44.8291C42.2703 44.3273 42.2156 43.775 42.3214 43.2421C42.4271 42.7092 42.6885 42.2196 43.0725 41.8353C43.4565 41.451 43.9459 41.1892 44.4787 41.083C45.0116 40.9769 45.5639 41.0311 46.0659 41.2389C46.5679 41.4468 46.9969 41.7988 47.2988 42.2505C47.6007 42.7022 47.7618 43.2333 47.7618 43.7766C47.7613 44.5045 47.472 45.2025 46.9574 45.7174C46.4429 46.2323 45.745 46.5221 45.0171 46.523H45.0175ZM11.4226 30.0977C12.4294 30.0981 13.4138 29.7999 14.2511 29.2408C15.0885 28.6818 15.7413 27.8869 16.1269 26.9569C16.5125 26.0268 16.6136 25.0032 16.4174 24.0157C16.2212 23.0281 15.7366 22.1209 15.0248 21.4088C14.313 20.6967 13.406 20.2117 12.4186 20.0152C11.4311 19.8186 10.4075 19.9193 9.47725 20.3045C8.54701 20.6897 7.7519 21.3421 7.19248 22.1792C6.63306 23.0163 6.33447 24.0006 6.33447 25.0074C6.33571 26.3567 6.87211 27.6504 7.82598 28.6046C8.77985 29.5589 10.0733 30.0958 11.4226 30.0977ZM11.4226 22.2609C11.9659 22.2605 12.4971 22.4212 12.949 22.7228C13.4009 23.0243 13.7533 23.4531 13.9615 23.9549C14.1697 24.4567 14.2244 25.009 14.1187 25.5419C14.0129 26.0748 13.7515 26.5644 13.3675 26.9487C12.9835 27.333 12.4941 27.5948 11.9613 27.701C11.4285 27.8071 10.8761 27.7529 10.3742 27.545C9.87219 27.3372 9.44312 26.9852 9.14124 26.5335C8.83936 26.0818 8.67822 25.5507 8.67822 25.0074C8.67874 24.2795 8.96797 23.5816 9.48246 23.0667C9.99695 22.5518 10.6947 22.262 11.4226 22.2609Z"
        fill="#487ED8"
      />
      <path
        d="M88.0392 28.8125C87.7878 24.9453 84.6282 21.9166 80.8462 21.9166C79.0984 21.9203 77.4136 22.5698 76.1157 23.7404C72.2755 19.9891 67.4811 16.7578 62.1739 14.3559C56.156 11.6322 49.8993 10.1926 44.0808 10.1926C42.4757 10.2072 40.8726 10.3067 39.278 10.4906C39.3579 9.91929 39.3791 9.34128 39.3413 8.76562C39.0382 4.1043 35.2335 0.453125 30.6796 0.453125C26.1257 0.453125 22.3202 4.1043 22.0179 8.76367C21.9093 10.8962 22.552 12.9994 23.8343 14.7068L24.0763 15.0305C21.9321 16.2437 19.8662 17.5904 17.8907 19.0625C17.0928 18.211 16.1292 17.5315 15.0591 17.0659C13.989 16.6002 12.8351 16.3582 11.6681 16.3547C7.11397 16.3547 3.30869 20.007 3.00654 24.6652C2.89804 26.7978 3.5408 28.901 4.82295 30.6086L6.22002 32.477C2.90947 38.8438 0.94541 46.5965 0.94541 53.3697C0.93334 59.0421 2.04016 64.6611 4.20252 69.9052C6.36487 75.1492 9.54029 79.9153 13.547 83.9305C17.5537 87.9457 22.313 91.1313 27.5524 93.3048C32.7918 95.4783 38.4085 96.5971 44.0809 96.5971C49.7532 96.5971 55.3699 95.4783 60.6093 93.3048C65.8487 91.1313 70.608 87.9457 74.6147 83.9305C78.6214 79.9153 81.7968 75.1492 83.9592 69.9052C86.1216 64.6611 87.2284 59.0421 87.2163 53.3697C87.2163 48.5623 85.9919 41.3527 84.3927 36.6029L86.5327 33.7416C87.6083 32.3317 88.1428 30.5828 88.0392 28.8125ZM24.3565 8.91758C24.5519 5.90977 26.9708 2.79688 30.6796 2.79688C34.3884 2.79688 36.8067 5.90898 37.0026 8.9207C37.0897 10.4967 36.609 12.0516 35.6478 13.3035L30.6796 19.949L25.7198 13.315C24.7658 12.0534 24.2835 10.4976 24.3565 8.91758ZM5.3458 24.8191C5.54111 21.8113 7.95986 18.6984 11.6687 18.6984C15.3774 18.6984 17.796 21.8105 17.9917 24.8225C18.0789 26.3984 17.5982 27.9533 16.6368 29.2051L11.6681 35.8506L6.70889 29.2166C5.75491 27.955 5.27266 26.3992 5.3458 24.8191ZM7.7915 34.5789L10.7306 38.5094C10.8397 38.6553 10.9813 38.7738 11.1443 38.8554C11.3072 38.9371 11.4869 38.9796 11.6691 38.9796C11.8514 38.9796 12.0311 38.9371 12.194 38.8554C12.357 38.7738 12.4986 38.6553 12.6077 38.5094L18.5132 30.6094C19.559 29.2465 20.1868 27.6094 20.3204 25.8968C20.4539 24.1841 20.0876 22.4695 19.2657 20.9609C21.2508 19.4804 23.3313 18.1324 25.4938 16.9258L29.7413 22.607C29.8504 22.753 29.9921 22.8715 30.155 22.9531C30.3179 23.0347 30.4977 23.0772 30.6799 23.0772C30.8621 23.0772 31.0418 23.0347 31.2048 22.9531C31.3677 22.8715 31.5093 22.753 31.6185 22.607L37.5243 14.7072C37.937 14.1572 38.288 13.5635 38.571 12.9367C39.0579 12.8744 39.5444 12.8162 40.0241 12.7676L44.946 19.8684C45.5162 20.6874 45.8101 21.6671 45.785 22.6647C45.7598 23.6624 45.4169 24.626 44.8061 25.4152L43.4159 27.2205C43.0768 27.6593 42.629 28.0021 42.1169 28.215C41.6048 28.4279 41.0461 28.5036 40.4958 28.4346L38.9188 28.233C37.8077 28.0904 36.6791 28.2776 35.6734 28.7714C34.6678 29.2651 33.8295 30.0436 33.2628 31.01C32.9436 31.5543 32.4715 31.9929 31.9052 32.2713C31.3388 32.5496 30.7032 32.6555 30.0772 32.5758L26.4362 32.1129C25.3472 31.9713 24.2403 32.136 23.2398 32.5887C22.2392 33.0414 21.3847 33.7641 20.7722 34.6756C20.199 35.5223 19.8853 36.5179 19.8696 37.5403C19.8538 38.5627 20.1367 39.5674 20.6835 40.4314L23.0888 44.2332C23.5321 44.9297 24.1442 45.5029 24.8683 45.8996C25.5924 46.2962 26.405 46.5034 27.2306 46.502C28.0304 46.5026 28.818 46.305 29.5228 45.9268L31.9993 44.5986C33.2126 43.948 35.1829 43.9416 36.603 44.5268C36.7386 46.2819 37.3675 47.963 38.4173 49.3762L44.3243 57.2785C44.4334 57.4245 44.5751 57.543 44.738 57.6246C44.9009 57.7062 45.0807 57.7487 45.2629 57.7487C45.4451 57.7487 45.6248 57.7062 45.7878 57.6246C45.9507 57.543 46.0924 57.4245 46.2015 57.2785L49.1974 53.2711L49.5782 53.793C49.7405 54.0193 49.912 54.2389 50.0923 54.4512L53.1001 57.9938C53.2341 58.1516 53.3347 58.3351 53.3958 58.533C53.4568 58.7309 53.477 58.9392 53.4552 59.1451C53.4334 59.3511 53.37 59.5504 53.2688 59.7312C53.1677 59.9119 53.0309 60.0702 52.8667 60.1965L48.3087 63.7014C47.0956 64.6305 46.2032 65.9154 45.7562 67.3766L44.2368 72.3086C44.1175 72.6976 43.922 73.059 43.6618 73.3719L42.1835 75.1516C41.0823 76.4747 40.4005 78.0961 40.2253 79.8086C40.1825 80.225 40.0284 80.6223 39.7791 80.9586C39.5299 81.2949 39.1946 81.558 38.8087 81.7201C38.6469 81.7878 38.4719 81.8181 38.2968 81.8085C38.1216 81.799 37.9509 81.75 37.7974 81.6651C37.644 81.5802 37.5117 81.4616 37.4105 81.3183C37.3094 81.1751 37.242 81.0107 37.2134 80.8377L35.8208 72.4746C35.6469 71.4353 35.2228 70.4539 34.5849 69.6152L29.4831 62.9197C29.0247 62.3192 28.6858 61.6363 28.4847 60.908L26.8009 54.8281C26.5032 53.7629 25.9351 52.7927 25.1517 52.0119C24.3683 51.2311 23.3962 50.6662 22.33 50.3721L21.964 50.2723C21.2233 50.0693 20.5436 49.6881 19.9843 49.1619L16.8438 46.2021C16.3436 45.731 15.9145 45.1898 15.5698 44.5953C14.839 43.3353 13.7329 42.335 12.4061 41.734C11.0792 41.1331 9.59775 40.9616 8.16865 41.2434C8.12287 41.2523 8.07767 41.2641 8.0333 41.2785L4.88662 42.3021C5.62075 39.6456 6.59298 37.0607 7.7915 34.5789ZM38.9403 43.5883C39.1356 40.5805 41.5544 37.4676 45.2632 37.4676C48.972 37.4676 51.3905 40.5797 51.5862 43.5916C51.6734 45.1675 51.1927 46.7225 50.2313 47.9742L45.2632 54.6197L40.3034 47.9857C39.3494 46.7241 38.8672 45.1683 38.9403 43.5883ZM84.8726 53.3697C84.8726 75.8854 66.5733 94.2031 44.0808 94.2031C21.5882 94.2031 3.28916 75.8854 3.28916 53.3697C3.30829 50.5483 3.62303 47.7367 4.22822 44.9809L8.68779 43.5303C9.62936 43.3586 10.601 43.4817 11.47 43.8828C12.339 44.2839 13.063 44.9435 13.5431 45.7715C14.0015 46.5619 14.5721 47.2817 15.2372 47.9082L18.3778 50.867C19.2171 51.6561 20.2367 52.2279 21.3478 52.5324L21.7138 52.632C22.3884 52.8185 23.0034 53.1762 23.499 53.6705C23.9946 54.1649 24.3539 54.7789 24.5421 55.4531L26.2259 61.534C26.5064 62.5502 26.9792 63.5032 27.6188 64.3412L32.7206 71.0369C33.1275 71.5719 33.398 72.1978 33.5089 72.8607L34.9015 81.2238C34.9873 81.7461 35.1904 82.2422 35.4956 82.6746C35.8007 83.1071 36.2 83.4647 36.6634 83.7205C37.1268 83.9764 37.6421 84.1238 38.1707 84.1517C38.6992 84.1796 39.2272 84.0873 39.7149 83.8816C40.4889 83.5569 41.161 83.0297 41.6609 82.3555C42.1608 81.6813 42.4699 80.8849 42.5558 80.05C42.6837 78.7994 43.1815 77.6153 43.9856 76.649L45.464 74.8693C45.922 74.3189 46.2661 73.6829 46.4761 72.9982L47.9948 68.0662C48.2997 67.0698 48.9082 66.1935 49.7354 65.5598L54.2954 62.0547C54.7112 61.735 55.0578 61.3342 55.314 60.8765C55.5703 60.4189 55.731 59.914 55.7863 59.3924C55.8416 58.8708 55.7904 58.3434 55.6359 57.8422C55.4813 57.341 55.2265 56.8764 54.887 56.4766L51.8792 52.934C51.7386 52.7683 51.6049 52.5968 51.4784 52.4201L50.6665 51.3068L52.1081 49.3787C53.4048 47.6789 54.0492 45.5706 53.9245 43.4363C53.6216 38.775 49.8169 35.1238 45.2628 35.1238C41.1476 35.1238 37.6456 38.1057 36.7845 42.1182C34.8378 41.5443 32.5071 41.6689 30.8919 42.5346L28.4153 43.8627C27.8491 44.1637 27.1902 44.2401 26.57 44.0768C25.9499 43.9134 25.4142 43.5223 25.0696 42.9814L22.6642 39.1795C22.3612 38.7008 22.2044 38.144 22.2131 37.5776C22.2218 37.0111 22.3956 36.4594 22.7132 35.9902C23.0838 35.4386 23.6009 35.0013 24.2064 34.7273C24.8118 34.4533 25.4817 34.3536 26.1407 34.4393L29.7817 34.902C30.8628 35.0402 31.9607 34.8576 32.9388 34.377C33.917 33.8964 34.7323 33.1389 35.2835 32.1986C35.6176 31.6278 36.1123 31.1679 36.7059 30.8762C37.2995 30.5845 37.9658 30.4738 38.6218 30.558L40.1985 30.7596C41.1548 30.8795 42.1257 30.7481 43.0156 30.3781C43.9055 30.0082 44.6835 29.4126 45.2729 28.6502L46.6632 26.8449C47.5786 25.6622 48.0925 24.2182 48.1301 22.7232C48.1677 21.2281 47.7271 19.76 46.8724 18.5328L42.7364 12.5676C43.2104 12.548 43.6616 12.5363 44.0808 12.5363C49.569 12.5363 55.4909 13.9035 61.2075 16.4912C62.9985 17.304 64.7391 18.2236 66.4198 19.2451L63.2718 24.641C62.8205 25.4329 62.627 26.3456 62.718 27.2524C62.809 28.1593 63.18 29.0153 63.7796 29.7018C64.6842 30.7379 65.9394 31.4036 67.3046 31.5713L67.8755 31.6416C68.428 31.7101 68.9488 31.9375 69.3746 32.2962C69.8005 32.655 70.113 33.1296 70.2743 33.6625C70.4269 34.1688 70.4314 34.7082 70.2872 35.2169C70.1431 35.7257 69.8563 36.1826 69.4608 36.5336L63.8077 41.532C63.2347 42.0391 62.7759 42.662 62.4616 43.3596C62.1473 44.0572 61.9848 44.8136 61.9847 45.5787V46.9051C61.9829 47.6911 62.1789 48.4649 62.5548 49.1552C62.9306 49.8455 63.4741 50.4302 64.1353 50.8553C64.4639 51.0666 64.7405 51.3495 64.9441 51.683C65.1478 52.0165 65.2732 52.3918 65.311 52.7807L65.4433 54.1049C65.5468 55.177 66.0467 56.1718 66.845 56.8949C67.6433 57.6179 68.6826 58.0172 69.7597 58.0145H73.0685C74.4392 58.014 75.7801 57.6144 76.9275 56.8645C78.0749 56.1145 78.979 55.0466 79.5294 53.7912L79.7282 53.3379C79.923 52.8885 80.2405 52.503 80.6442 52.2257C81.048 51.9483 81.5216 51.7903 82.011 51.7697L82.7874 51.7346C82.9137 51.729 83.0397 51.7198 83.1655 51.707L84.8161 51.5408C84.8528 52.1828 84.8726 52.7969 84.8726 53.3697ZM84.6216 49.2031L82.9308 49.3732C82.8483 49.3816 82.7655 49.3875 82.6819 49.3914L81.9044 49.4268C80.9778 49.4656 80.0808 49.7647 79.3163 50.2898C78.5518 50.8148 77.9507 51.5446 77.5817 52.3955L77.3829 52.8488C77.0154 53.6872 76.4117 54.4005 75.6455 54.9015C74.8794 55.4024 73.9839 55.6694 73.0685 55.6697H69.7593C69.264 55.6708 68.7861 55.487 68.4191 55.1544C68.0521 54.8217 67.8224 54.3641 67.7749 53.8711L67.6425 52.5467C67.5706 51.8071 67.332 51.0935 66.9447 50.4594C66.5573 49.8252 66.0313 49.2872 65.4062 48.8855C65.0746 48.6723 64.8021 48.379 64.6136 48.0327C64.4252 47.6864 64.3269 47.2983 64.3278 46.9041V45.5777C64.3279 45.1446 64.4198 44.7164 64.5977 44.3215C64.7756 43.9266 65.0353 43.574 65.3597 43.2869L71.0128 38.2885C71.7435 37.6398 72.2734 36.7956 72.5399 35.8556C72.8064 34.9155 72.7983 33.9188 72.5167 32.9832C72.2236 32.0158 71.6561 31.1543 70.883 30.5032C70.1098 29.852 69.1644 29.4393 68.1612 29.315L67.5903 29.2447C66.7975 29.1474 66.0684 28.7607 65.5431 28.159C65.2647 27.8409 65.092 27.4443 65.0487 27.0238C65.0054 26.6033 65.0938 26.1798 65.3015 25.8117L68.395 20.5092C70.6245 22.0018 72.7123 23.6959 74.6319 25.5703C74.0615 26.5617 73.7267 27.671 73.6534 28.8125C73.5628 30.5813 74.0956 32.3259 75.1589 33.7424L79.9077 40.0924C80.0168 40.2383 80.1585 40.3568 80.3214 40.4384C80.4843 40.52 80.664 40.5624 80.8462 40.5624C81.0284 40.5624 81.2081 40.52 81.371 40.4384C81.5339 40.3568 81.6755 40.2383 81.7847 40.0924L82.6579 38.9246C83.5906 42.2917 84.2473 45.7293 84.6216 49.2031ZM84.6565 32.3365L80.8462 37.4316L77.0444 32.3477C76.3092 31.3773 75.9369 30.1802 75.9921 28.9641C76.1425 26.6516 77.9993 24.2598 80.8462 24.2598C83.6931 24.2598 85.5501 26.6516 85.7005 28.9668C85.767 30.1789 85.3965 31.3746 84.6563 32.3367L84.6565 32.3365Z"
        fill="#487ED8"
      />
    </svg>
  );
};
